/* Generated by scripts/gen-tech-library.ts from data/tech-library/ — do not edit. Run: npx tsx scripts/gen-tech-library.ts */
import type { TechLibrary } from './tech-library';

/** The Tech Wizard's library (D-1.8.5-7): 116 entries, 45 guided flows, the free-help lines, Scam Watch's lists and the What's New pages — catalog of 2026-10-10. */
export const TECH_LIBRARY: TechLibrary = {
  "catalogDate": "2026-10-10",
  "entries": [
    {
      "id": "android-factory-reset-find-hub",
      "title": "Android — lost phone (Find Hub) and factory reset (Factory Reset Protection)",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Android 16–17; Find Hub (formerly Find My Device)",
      "topics": [
        "lost phone",
        "find hub",
        "find my device",
        "factory reset",
        "google account",
        "factory reset protection"
      ],
      "sources": [
        {
          "title": "Find, lock or erase a lost Android device (Find Hub)",
          "url": "https://support.google.com/android/answer/6160491"
        },
        {
          "title": "Find Hub",
          "url": "https://www.google.com/android/find/"
        },
        {
          "title": "Factory reset your Android device",
          "url": "https://support.google.com/android/answer/6088915"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "high",
      "body": "## Steps\n1. Lost phone: on another device, open Find Hub (google.com/android/find), sign in with the tenant's Google account, and ring or locate the phone.\n2. Before any factory reset: back the phone up, and make sure the tenant knows their Google account email and password (they sign in on another device to prove it).\n3. Don't factory reset within 24 hours of changing the Google password.\n4. ⚠ This erases everything on the phone: factory reset only with the tenant's clear OK. Afterwards the phone asks for the Google account and password that were on it (Factory Reset Protection).\n\n## Good to know\n- A phone reset without the Google password stays locked: step 2 is not optional."
    },
    {
      "id": "android-frozen-slow-storage",
      "title": "Android — frozen, slow, storage full, updates, battery (safe mode)",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Android 16–17",
      "topics": [
        "frozen",
        "not responding",
        "slow",
        "storage full",
        "update",
        "safe mode",
        "battery"
      ],
      "sources": [
        {
          "title": "Fix an Android device that's frozen or not responding",
          "url": "https://support.google.com/android/answer/7664998"
        },
        {
          "title": "Safe mode (Android)",
          "url": "https://support.google.com/android/answer/7665064"
        },
        {
          "title": "Free up storage (Android)",
          "url": "https://support.google.com/android/answer/7431795"
        },
        {
          "title": "Check and update Android",
          "url": "https://support.google.com/android/answer/7680439"
        },
        {
          "title": "Battery (Android)",
          "url": "https://support.google.com/android/answer/7664692"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Frozen: press and hold the power button until the phone restarts (Google's page gives the time for most phones). Charge it if the battery is low.\n2. If it keeps freezing or is slow, restart in safe mode (Google's page) to see whether a downloaded app is the cause; restart normally to leave safe mode.\n3. Storage: open Settings, then Storage, and go through what takes space with the tenant; nothing is removed without their OK.\n4. Update: Settings, then System (or Software update), then check for updates; use Wi-Fi and a charger.\n5. Battery: Settings, Battery shows which apps use the most.\n\n## Good to know\n- On Samsung phones, use the Samsung entries: the keys and Device Care are different."
    },
    {
      "id": "android-magnification",
      "title": "Android — Magnification and the Pixel Magnifier",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "Android 16–17",
      "topics": [
        "easier to see",
        "magnification",
        "zoom",
        "magnifier",
        "camera",
        "low vision"
      ],
      "sources": [
        {
          "title": "Magnification (Android Accessibility Help)",
          "url": "https://support.google.com/accessibility/android/answer/6006949"
        },
        {
          "title": "Accessibility shortcuts (Android)",
          "url": "https://support.google.com/accessibility/android/answer/7650693"
        },
        {
          "title": "Pixel Magnifier",
          "url": "https://support.google.com/pixelphone/answer/14140405"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings, then Accessibility, then Magnification.\n2. Turn on the Magnification shortcut, and choose how to start it (the accessibility button on screen, holding both volume keys, or a triple-tap on the screen if offered).\n3. Start magnification with that shortcut, then tap the screen.\n4. While magnified, drag two fingers to move around and pinch two fingers to change how big it is.\n5. Use the shortcut again to stop.\n6. On a Pixel, the Magnifier app uses the camera as a magnifying glass for letters and labels.\n\n## Good to know\n- Menu names differ a little between phone makers and Android versions; on Samsung see the Samsung entry."
    },
    {
      "id": "android-text-display",
      "title": "Android — font size, high-contrast text, color inversion, color correction, extra dim, dark theme",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Android 16–17",
      "topics": [
        "easier to see",
        "text size",
        "font size",
        "high contrast text",
        "color inversion",
        "invert colors",
        "extra dim",
        "dark theme"
      ],
      "sources": [
        {
          "title": "Text & display settings (Android)",
          "url": "https://support.google.com/accessibility/android/answer/11183305?hl=en"
        },
        {
          "title": "Dark theme & color inversion (Android)",
          "url": "https://support.google.com/accessibility/android/answer/6151800?hl=en"
        },
        {
          "title": "Accessibility shortcuts (Android)",
          "url": "https://support.google.com/accessibility/android/answer/7650693"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings, then Accessibility, then the display and text settings (\"Display size and text\" or \"Text and display\", depending on the phone).\n2. Make the font size and the display size bigger until the tenant can read comfortably; turn on bold text if offered.\n3. Turn on high-contrast text to give text a solid outline.\n4. Turn on color inversion for light text on a dark screen (Google's page notes that dark theme is gentler, because it doesn't change photos).\n5. Use color correction if colors are hard to tell apart.\n6. Turn on Extra dim if the screen is too bright even at the lowest brightness.\n\n## Good to know\n- Any of these can be put on an accessibility shortcut so the tenant can turn it on and off quickly."
    },
    {
      "id": "android-wifi-fix",
      "title": "Android and Samsung — Wi-Fi won't connect (reset Wi-Fi settings last)",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet",
        "internet"
      ],
      "version": "Android 16–17; One UI",
      "topics": [
        "internet",
        "wi-fi",
        "won't connect",
        "forget network",
        "qr code",
        "samsung"
      ],
      "sources": [
        {
          "title": "Fix internet connection problems (Android)",
          "url": "https://support.google.com/android/answer/2651367?hl=en"
        },
        {
          "title": "Fix Wi-Fi problems (Pixel)",
          "url": "https://support.google.com/pixelphone/answer/6183600"
        },
        {
          "title": "Connect, forget and share by QR (Android)",
          "url": "https://support.google.com/android/answer/9075847?hl=en"
        },
        {
          "title": "Samsung Wi-Fi connection issues",
          "url": "https://www.samsung.com/us/support/troubleshooting/TSG01001559/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "medium",
      "body": "## Steps\n1. Swipe down from the top of the screen and check Wi-Fi is on and Airplane mode is off.\n2. Open Settings, then the Wi-Fi settings, and choose the right network.\n3. Restart the phone.\n4. Restart the modem and router by unplugging them for a full minute.\n5. Forget the network and connect again with the password in hand (or scan the router's QR code where offered).\n6. ⚠ This erases every saved Wi-Fi password and Bluetooth pairing on the phone: as the very last step, reset the network settings (Google's and Samsung's pages show where on each phone). Have the Wi-Fi password ready first.\n\n## Good to know\n- Private DNS settings set by someone else can block the internet; Google's advanced-settings page explains them."
    },
    {
      "id": "aph-pixblaster-pageblaster",
      "title": "APH PixBlaster and PageBlaster embossers — guides and jams",
      "platform": "APH",
      "devices": [
        "printer"
      ],
      "version": "PixBlaster user guide (Dec 2021); PageBlaster FAQ (catalog Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "pixblaster",
        "pageblaster",
        "paper jam"
      ],
      "sources": [
        {
          "title": "APH PixBlaster",
          "url": "https://www.aph.org/product/pixblaster/"
        },
        {
          "title": "PixBlaster user guide (PDF)",
          "url": "https://media.aph.org/app/uploads/2021/12/PixBlaster-User-Guide-12-16-21.pdf"
        },
        {
          "title": "PixBlaster FAQ",
          "url": "https://aph.org/pixblaster-faqs"
        },
        {
          "title": "PageBlaster FAQ",
          "url": "https://aph.org/pageblaster-faqs"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. PageBlaster: it is based on the Index Basic-D V5, so the Index steps (HELP+10 for the address, firmware care, Duxbury setup) are the place to start, with APH's FAQ.\n2. PixBlaster jam: tear the paper at the nearest perforation on both sides, open the tractor lid, pull the paper out evenly (front, then rear), reload, cancel the job, and send it again.\n3. For anything else, use the PixBlaster user guide and FAQ.\n\n## Good to know\n- APH customer service: 1-800-223-1839, Mon–Fri 8–8 ET."
    },
    {
      "id": "apple-account-recovery",
      "title": "Apple Account — forgot the password, account recovery, two-factor codes",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "computer"
      ],
      "version": "Apple pages (Oct 2026)",
      "topics": [
        "account",
        "apple account",
        "apple id",
        "password",
        "forgot password",
        "account recovery",
        "two-factor"
      ],
      "sources": [
        {
          "title": "If you forgot your Apple Account password",
          "url": "https://support.apple.com/en-us/102656"
        },
        {
          "title": "Apple Account recovery",
          "url": "https://support.apple.com/en-us/118574"
        },
        {
          "title": "Two-factor authentication for Apple Account",
          "url": "https://support.apple.com/en-us/102660"
        },
        {
          "title": "Phishing and fake support calls (Apple)",
          "url": "https://support.apple.com/en-us/102568"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. On the tenant's own iPhone or iPad that is already signed in, reset the password from Settings (their name, then Sign-In & Security, then Change Password); the device passcode lets them do it.\n2. If no signed-in device is available, follow Apple's forgotten-password page on a trusted device or the web.\n3. If that fails, start account recovery. It takes days: tell the tenant they'll get a message from Apple when it's ready.\n4. During recovery, don't sign in on another Apple device: that cancels it.\n\n## Good to know\n- Apple never asks for a code on a website or by phone. Never enter a code on a website, or tap Allow on a sign-in prompt the tenant didn't start."
    },
    {
      "id": "be-my-eyes-aira-seeing-ai",
      "title": "Free \"be my eyes\" help — Be My Eyes, Be My AI, Aira's free minutes, Seeing AI, Lookout",
      "platform": "Be My Eyes",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "Be My Eyes, Aira, Seeing AI, Lookout pages (catalog Oct 2026)",
      "topics": [
        "free help",
        "be my eyes",
        "be my ai",
        "aira",
        "seeing ai",
        "lookout",
        "read mail",
        "describe"
      ],
      "sources": [
        {
          "title": "Be My Eyes",
          "url": "https://www.bemyeyes.com/"
        },
        {
          "title": "Getting started with Be My Eyes",
          "url": "https://support.bemyeyes.com/hc/en-us/articles/360005528557-Getting-started-with-Be-My-Eyes"
        },
        {
          "title": "Using Be My AI",
          "url": "https://support.bemyeyes.com/hc/en-us/articles/18133134809105-Using-Be-My-AI"
        },
        {
          "title": "Aira Explorer app",
          "url": "https://aira.io/aira-explorer-app/"
        },
        {
          "title": "Free Aira minutes",
          "url": "https://aira.io/explorer-tips-how-to-get-free-aira-minutes/"
        },
        {
          "title": "Seeing AI (free; iOS and Android)",
          "url": "https://www.seeingai.com/"
        },
        {
          "title": "Lookout (Android camera reading app)",
          "url": "https://support.google.com/accessibility/android/answer/9031274?hl=en"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Be My Eyes (free): install the app; a sighted volunteer answers a video call and describes what the camera sees. Be My AI in the same app describes a photo.\n2. Inside Be My Eyes, some companies' help desks answer too (Microsoft's Disability Answer Desk is one).\n3. Aira: the Aira Explorer app connects to a trained agent; there are free minutes (5 every 48 hours, and 3 welcome calls).\n4. Seeing AI (free, from Microsoft, iPhone and Android) reads text, documents and labels aloud.\n5. On Android, Google's Lookout reads text and labels with the camera.\n\n## Good to know\n- Remind the tenant not to show bank cards, passwords or medical papers on a volunteer call."
    },
    {
      "id": "braille-device-firmware",
      "title": "Update firmware on braille displays and talking-book players (Focus, DS1/DA1, notetakers)",
      "platform": "Freedom Scientific",
      "devices": [
        "screenReader",
        "other"
      ],
      "version": "Focus Blue 5th Gen downloads; NLS DS1/DA1 firmware page (catalog Oct 2026)",
      "topics": [
        "firmware",
        "update",
        "braille display",
        "focus",
        "talking book player",
        "ds1",
        "da1"
      ],
      "sources": [
        {
          "title": "Focus 5th Gen firmware downloads",
          "url": "https://support.freedomscientific.com/Downloads/Focus/Focus5Downloads"
        },
        {
          "title": "Focus Blue 5th Gen user guide (PDF)",
          "url": "https://support.freedomscientific.com/Content/Documents/Manuals/Focus/Focus-Blue-Users-Guide.pdf"
        },
        {
          "title": "NLS DS1/DA1 firmware",
          "url": "https://www.loc.gov/nls/news-and-updates/nls-dtbm-firmware/"
        },
        {
          "title": "HumanWare support index",
          "url": "https://www.humanware.com/support/"
        },
        {
          "title": "SELVAS BLV download center",
          "url": "https://selvasblv.com/support/download-center/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Update only when there is a reason (a problem the maker's notes say it fixes, or the maker asks).\n2. Get the firmware only from the maker's own page for that exact model (Freedom Scientific for Focus; NLS for the DS1 and DA1; HumanWare or SELVAS BLV for their devices).\n3. Charge the device fully, or keep it plugged in.\n4. Follow the maker's instructions for that model step by step; read them aloud with the tenant.\n5. Never turn the device off or unplug it while it updates.\n6. Afterwards, check it with the tenant (read a line, play a book).\n\n## Good to know\n- Firmware updates are the tenant's choice; explain what it changes before you start."
    },
    {
      "id": "braille-display-iphone",
      "title": "Pair a braille display with an iPhone or iPad (VoiceOver → Braille, not the Bluetooth menu)",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27; Apple braille pages (May 2024, Feb 2025)",
      "topics": [
        "braille",
        "braille display",
        "pair",
        "bluetooth",
        "voiceover",
        "focus",
        "orbit reader"
      ],
      "sources": [
        {
          "title": "Use a braille display with VoiceOver on iPhone",
          "url": "https://support.apple.com/guide/iphone/use-a-braille-display-iph73b8c43/ios"
        },
        {
          "title": "Common braille commands for VoiceOver",
          "url": "https://support.apple.com/en-us/118665"
        },
        {
          "title": "Supported braille displays",
          "url": "https://support.apple.com/en-us/103246"
        },
        {
          "title": "Focus Blue with iOS",
          "url": "https://support.freedomscientific.com/Content/Documents/Manuals/Focus/Focus-Blue-iOS-Support.htm"
        },
        {
          "title": "Orbit Reader 40 support (pair through VoiceOver braille settings)",
          "url": "https://www.orbitresearch.com/support/orbit-reader-40-support/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Turn VoiceOver on (the display works through VoiceOver).\n2. Turn the braille display on and make it discoverable (its manual says how; many are discoverable when switched on).\n3. On the iPhone, open Settings, then Accessibility, then VoiceOver, then Braille. Do not pair it in the Bluetooth menu.\n4. Choose the display's name when it appears.\n5. If it asks for a PIN, type the one in the display's manual; a Focus display uses 0000.\n6. Ask the tenant to read a line on the display to confirm it works.\n\n## Good to know\n- Apple's \"common braille commands\" page lists the display keys for VoiceOver.\n- If the display was paired in the Bluetooth menu before, forget it there first, then pair it again from VoiceOver, Braille."
    },
    {
      "id": "braille-display-windows",
      "title": "Braille displays on Windows — with Narrator, JAWS or NVDA",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "Windows 11 24H2/25H2 (Narrator guide Aug 2026); JAWS 2026; NVDA 2026.2",
      "topics": [
        "braille",
        "braille display",
        "narrator",
        "jaws",
        "nvda",
        "bluetooth",
        "usb"
      ],
      "sources": [
        {
          "title": "Chapter 8, Using Narrator with braille",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/chapter-8-using-narrator-with-braille"
        },
        {
          "title": "Appendix C, supported braille displays (Narrator)",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/appendix-c-supported-braille-displays"
        },
        {
          "title": "Freedom Scientific braille display documentation",
          "url": "https://support.freedomscientific.com/Products/Blindness/BrailleDisplayDocumentation"
        },
        {
          "title": "NVDA User Guide (2026.2)",
          "url": "https://download.nvaccess.org/documentation/userGuide.html"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Connect the display with its USB cable if it has one; that is the simplest. For Bluetooth, pair it first in Settings, Bluetooth & devices, Add device.\n2. Narrator: open Settings, then Accessibility, then Narrator, then Braille; install the braille support when asked, then choose the display (Microsoft's chapter 8).\n3. JAWS: Freedom Scientific's Focus displays are usually found by JAWS by themselves over USB; for other displays or Bluetooth, choose the display in JAWS's braille settings (the display's documentation shows how).\n4. NVDA: open the NVDA menu (NVDA+N), then Preferences, Settings, Braille, and choose the display (NVDA detects many displays by itself).\n5. Ask the tenant to read a line on the display to confirm.\n\n## Good to know\n- Only one screen reader should drive the display at a time."
    },
    {
      "id": "braille-notetakers-displays",
      "title": "Braille notetakers and displays — which one is it, Wi-Fi, and who supports it (BrailleNote, BrailleSense, Brailliant, Mantis, Monarch, Chameleon, Focus, Orbit, Braille Lite)",
      "platform": "HumanWare",
      "devices": [
        "screenReader",
        "other",
        "internet"
      ],
      "version": "Makers' support pages and manuals (catalog Oct 2026; BrailleSense 6 manual V3.2, Aug 2026)",
      "topics": [
        "braille",
        "notetaker",
        "braillenote",
        "braillesense",
        "brailliant",
        "mantis",
        "monarch",
        "chameleon",
        "orbit reader",
        "braille lite",
        "wi-fi"
      ],
      "sources": [
        {
          "title": "HumanWare support index",
          "url": "https://www.humanware.com/support/"
        },
        {
          "title": "BrailleNote Touch Plus support",
          "url": "https://www.humanware.com/support/braillenote_touch_plus/"
        },
        {
          "title": "BrailleNote evolve support (Windows 11)",
          "url": "https://www.humanware.com/support/braillenote-evolve/"
        },
        {
          "title": "BrailleNote evolve getting started (PDF)",
          "url": "https://www.humanware.com/wp-content/uploads/2026/06/BNE-Getting-started-guide-final.pdf"
        },
        {
          "title": "BrailleSense 6 manual V3.2 (PDF)",
          "url": "https://selvasblv.com/wp-content/uploads/2026/08/BrailleSense-6-User-Manual-English_V3.2_260814.pdf"
        },
        {
          "title": "SELVAS BLV download center",
          "url": "https://selvasblv.com/support/download-center/"
        },
        {
          "title": "APH Chameleon 20 FAQ",
          "url": "https://www.aph.org/chameleon-20-faqs/"
        },
        {
          "title": "Orbit Reader 20 user guides",
          "url": "https://www.orbitresearch.com/support/orbit-reader-20-support/orbit-reader-20-user-guide-downloads/"
        },
        {
          "title": "Braille Lite M20/M40 manual (legacy, 2002)",
          "url": "https://www.freedomscientific.com/Content/Documents/Manuals/Legacy/Braille_Lite_MDocs/Braille_Lite_Part_440013-001_Rev_E.pdf"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Read the label to find the maker and model; take a photo for the ticket.\n2. \"Braille Lite\" often means something else: the real Braille Lite is a Freedom Scientific notetaker from about 2002 with no Wi-Fi. Check whether the label says Brailliant, BrailleNote, BrailleSense or an NLS eReader.\n3. Open the maker's support page for that model (HumanWare for BrailleNote, Brailliant, Mantis Q40 and Monarch; SELVAS BLV for BrailleSense; APH for Chameleon 20; Orbit Research for Orbit Reader).\n4. Wi-Fi on a notetaker (BrailleNote Touch Plus, BrailleNote evolve, BrailleSense): the tenant opens the Wi-Fi settings on the device; the tech reads the steps aloud from the manual and spells the network name and password.\n5. A display that only shows a screen reader's output (Brailliant, Focus, Orbit Reader) doesn't need Wi-Fi: it pairs with a phone or computer (see the iPhone and Windows braille display entries).\n6. For anything else, call the maker's line (HumanWare 1-800-722-3393; SELVAS BLV 888-520-4467; APH 1-800-223-1839; Orbit Research 1-888-606-7248).\n\n## Good to know\n- The BrailleNote evolve is the successor of the BrailleNote Touch Plus and runs Windows 11.\n- Mantis Q40 and Monarch are made with APH; APH has its own pages for them."
    },
    {
      "id": "brother-printer-jam-scan",
      "title": "Brother printer — \"Paper Jam\" that stays after clearing, and scanning with iPrint&Scan",
      "platform": "Brother",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Brother FAQ (Oct 2026; includes the macOS 15 scanning fix)",
      "topics": [
        "printer",
        "paper jam",
        "jam message",
        "scan",
        "iprint&scan",
        "mac"
      ],
      "sources": [
        {
          "title": "Brother: \"Paper Jam\" stays after clearing",
          "url": "https://support.brother.com/g/b/faqend.aspx?c=us_ot&lang=en&prod=mfcj825dw_all&faqid=faq00002918_006"
        },
        {
          "title": "Brother: scan with iPrint&Scan (incl. macOS 15 fix)",
          "url": "https://support.brother.com/g/b/faqend.aspx?c=us_ot&lang=en&prod=mfcj4345dw_us&faqid=faq00100479_003"
        },
        {
          "title": "Brother accessibility documents by model",
          "url": "https://508accessibility.brother-usa.com/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Jam message that won't go away: turn the printer off and unplug it.\n2. Open every cover Brother's FAQ shows for the model and look with a flashlight for small torn pieces of paper; remove them gently.\n3. Close the covers firmly, plug in, and turn the printer on.\n4. Scanning: use Brother iPrint&Scan on the computer; choose the printer, then Scan.\n5. On a Mac with macOS 15 or later, follow Brother's page for the scanning fix if iPrint&Scan can't scan.\n\n## Good to know\n- A tiny scrap left behind is the usual reason the jam message stays."
    },
    {
      "id": "brother-printer-new-router",
      "title": "Brother printer — after a router change (and the Brother Mobile Connect app)",
      "platform": "Brother",
      "devices": [
        "printer",
        "internet"
      ],
      "version": "Brother FAQ; Brother Mobile Connect (Oct 2026)",
      "topics": [
        "printer",
        "wi-fi",
        "new router",
        "reconnect",
        "mobile connect"
      ],
      "sources": [
        {
          "title": "Brother: after a router change",
          "url": "https://support.brother.com/g/b/faqend.aspx?c=us&lang=en&prod=hl2270dw_all&ftype3=2039&faqid=faq00100014_000"
        },
        {
          "title": "Brother Mobile Connect app",
          "url": "https://www.brother-usa.com/apps/printing-scanning/brother-mobile-connect"
        },
        {
          "title": "Brother support by model",
          "url": "https://support.brother.com/g/b/countrytop.aspx?c=us&lang=en"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Have the new Wi-Fi name and password ready.\n2. Use the printer's wireless setup wizard on its control panel (Brother's after-a-router-change page shows the menu for the model), pick the network and type the password.\n3. Or set it up with the Brother Mobile Connect app on a phone.\n4. On each computer, add the printer again if it isn't found, and print a test page.\n\n## Good to know\n- Brother's accessibility documents by model are at 508accessibility.brother-usa.com."
    },
    {
      "id": "brother-printer-offline",
      "title": "Brother printer — offline or paused",
      "platform": "Brother",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Brother FAQ (Oct 2026)",
      "topics": [
        "printer",
        "offline",
        "paused",
        "not printing",
        "brother"
      ],
      "sources": [
        {
          "title": "Brother: printer offline or paused",
          "url": "https://support.brother.com/g/b/faqend.aspx?c=us&lang=en&prod=mfc7820n_all&faqid=faq00002646_000&pfs=1"
        },
        {
          "title": "Brother support by model",
          "url": "https://support.brother.com/g/b/countrytop.aspx?c=us&lang=en"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check the printer is on, ready, and shows no error.\n2. Turn the printer off, wait a full minute, and turn it on again.\n3. On Windows, open the printer's print queue and make sure neither \"Pause Printing\" nor \"Use Printer Offline\" is ticked; cancel stuck jobs.\n4. Check the computer and the printer are on the same network.\n5. Restart the computer and print a test page.\n\n## Good to know\n- After a router change, the printer needs the new Wi-Fi first (see the Brother new-router entry)."
    },
    {
      "id": "canon-printer-new-router",
      "title": "Canon printer — reconnect to a new router (Wi-Fi Connection Assistant, Canon PRINT app)",
      "platform": "Canon",
      "devices": [
        "printer",
        "internet"
      ],
      "version": "Canon Wi-Fi Connection Assistant 1.9; Canon PRINT app (Oct 2026)",
      "topics": [
        "printer",
        "wi-fi",
        "new router",
        "reconnect",
        "canon print"
      ],
      "sources": [
        {
          "title": "Canon Wi-Fi Connection Assistant (new router)",
          "url": "https://ij.manual.canon/ij/webmanual/NWDeviceSetupUtility/W/1.9/EN/NWDS/nwds_0004_2.html"
        },
        {
          "title": "Canon PRINT app",
          "url": "https://www.usa.canon.com/mobile-apps/canon-print"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Have the new Wi-Fi name and password ready.\n2. On the computer, run Canon's Wi-Fi Connection Assistant and follow it to put the printer on the new network.\n3. Or use the Canon PRINT app on a phone to set it up.\n4. Print a test page from each device the tenant uses.\n\n## Good to know\n- Canon's page for the Connection Assistant shows each screen of the setup."
    },
    {
      "id": "canon-printer-offline",
      "title": "Canon printer shows offline (Windows)",
      "platform": "Canon",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Canon IJ online manual (TS3700 series page; similar on other models, Oct 2026)",
      "topics": [
        "printer",
        "offline",
        "not printing",
        "canon",
        "pixma"
      ],
      "sources": [
        {
          "title": "Canon: printer shows offline (Windows)",
          "url": "https://ij.manual.canon/ij/webmanual/Manual/All/TS3700%20series/EN/NTR/ntr_t_03_17.html"
        },
        {
          "title": "Canon manuals portal",
          "url": "https://ij.manual.canon/ij/webmanual/WebPortal/PTL/ptl-top.html?lng=en"
        },
        {
          "title": "Canon support by model",
          "url": "https://www.usa.canon.com/support"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check the printer is on and shows no error.\n2. Turn the printer off, wait a full minute, and turn it on again.\n3. Check the computer and printer are on the same Wi-Fi.\n4. Open the printer's print queue in Windows and make sure \"Use Printer Offline\" is not ticked; cancel stuck jobs.\n5. Restart the computer and print a test page.\n\n## Good to know\n- Canon's manual for each model is in the manuals portal; search the model name printed on the front of the printer."
    },
    {
      "id": "canon-scan-mobile",
      "title": "Canon — scanning (IJ Scan Utility, Canon PRINT app) and printing from an iPhone (AirPrint)",
      "platform": "Canon",
      "devices": [
        "printer",
        "phone",
        "tablet",
        "computer"
      ],
      "version": "IJ Scan Utility 1.2; Canon PRINT app; AirPrint (Oct 2026)",
      "topics": [
        "printer",
        "scan",
        "scanning",
        "print from phone",
        "airprint"
      ],
      "sources": [
        {
          "title": "Canon IJ Scan Utility",
          "url": "https://ij.manual.canon/ij/webmanual/ScanUtility/W/1.2/EN/SU/su-001.html"
        },
        {
          "title": "Canon PRINT app",
          "url": "https://www.usa.canon.com/mobile-apps/canon-print"
        },
        {
          "title": "Canon: printing from iPhone or iPad (AirPrint)",
          "url": "https://ij.manual.canon/ij/webmanual/Portal/W/EN/AFG/afg_appleairprint.html"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. On a computer, open IJ Scan Utility, choose Document or Photo, and scan; note where it saves the file.\n2. On a phone, scan or print with the Canon PRINT app.\n3. From an iPhone or iPad, print with AirPrint: choose Share, then Print, pick the Canon printer, then Print.\n4. The printer and the phone or computer must be on the same Wi-Fi.\n\n## Good to know\n- Tell the tenant where the scan was saved and what it is called."
    },
    {
      "id": "connected-no-internet",
      "title": "Connected but no internet — is it the device or the provider?",
      "platform": "Verizon",
      "devices": [
        "internet",
        "phone",
        "computer",
        "tablet",
        "tv"
      ],
      "version": "Microsoft, Apple, Google, Spectrum and Verizon pages (Oct 2026)",
      "topics": [
        "internet",
        "no internet",
        "connected no internet",
        "wi-fi",
        "outage"
      ],
      "sources": [
        {
          "title": "Fix Wi-Fi connection issues in Windows",
          "url": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/fix-wi-fi-connection-issues-in-windows"
        },
        {
          "title": "iPhone or iPad can't connect to Wi-Fi",
          "url": "https://support.apple.com/en-us/111786"
        },
        {
          "title": "Fix internet connection problems (Android)",
          "url": "https://support.google.com/android/answer/2651367?hl=en"
        },
        {
          "title": "Verizon outages",
          "url": "https://www.verizon.com/support/residential/service-outage"
        },
        {
          "title": "Spectrum router and modem quick fixes",
          "url": "https://www.spectrum.com/resources/internet-wifi/modem-troubleshooting-slow-dropped-connections"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Check two or three other devices in the apartment on the same Wi-Fi (a phone, a TV, the computer).\n2. If only one device has no internet, the problem is that device: follow the Wi-Fi entry for it.\n3. If every device says \"connected, no internet\", the Wi-Fi is working but the internet coming into the apartment isn't: restart the modem and router by unplugging them for a full minute.\n4. If it is still down, check for an outage with the provider (Spectrum or Verizon) and call them.\n\n## Good to know\n- The app's Internet check (on Tools and the ticket) shows in words whether this device is really online."
    },
    {
      "id": "dell-supportassist-diagnostics",
      "title": "Dell — SupportAssist, the Service Tag, and diagnostics (F12 at the Dell logo)",
      "platform": "Dell",
      "devices": [
        "computer"
      ],
      "version": "Dell support pages (Oct 2026)",
      "topics": [
        "dell",
        "supportassist",
        "service tag",
        "diagnostics",
        "drivers",
        "battery"
      ],
      "sources": [
        {
          "title": "Dell SupportAssist",
          "url": "https://www.dell.com/support/kbdoc/en-us/000130387"
        },
        {
          "title": "Find the Service Tag",
          "url": "https://www.dell.com/support/kbdoc/en-us/000130711/how-to-find-the-service-tag-of-your-computer"
        },
        {
          "title": "Dell preboot diagnostics (F12 at the Dell logo)",
          "url": "https://www.dell.com/support/kbdoc/en-us/000181163"
        },
        {
          "title": "Dell drivers and firmware",
          "url": "https://www.dell.com/support/kbdoc/en-us/000183911"
        },
        {
          "title": "Dell laptop battery",
          "url": "https://www.dell.com/support/kbdoc/en-us/000123069"
        },
        {
          "title": "Dell contact information",
          "url": "https://www.dell.com/support/contents/en-us/category/contact-information"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Find the Service Tag (the label on the bottom or back, or Dell's page shows other places). Write it on the ticket.\n2. Open SupportAssist (search for it in Start) and run its checks and updates. Dell warned some installed versions are discontinued: check which version is on the PC against Dell's page.\n3. For a hardware check, restart, press F12 when the Dell logo appears, and choose Diagnostics.\n4. Get drivers and firmware through SupportAssist or Dell's drivers page with the Service Tag.\n5. Note any error code the diagnostics show, and contact Dell (online form) with the Service Tag.\n\n## Good to know\n- Dell's technical support is through an online form; no phone line is in the catalog."
    },
    {
      "id": "duxbury-send-to-embosser",
      "title": "Duxbury DBT — sending braille to the embosser (garbage output, \"WriteComm failed\")",
      "platform": "Duxbury",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Duxbury DBT 15.1 (catalog Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "duxbury",
        "dbt",
        "writecomm failed",
        "garbage",
        "emboss"
      ],
      "sources": [
        {
          "title": "Duxbury Systems (DBT 15.1)",
          "url": "https://www.duxburysystems.com/"
        },
        {
          "title": "Supported embossers",
          "url": "https://duxburysystems.com/emb_list.asp"
        },
        {
          "title": "Embosser setup in DBT",
          "url": "https://duxburysystems.com/documentation/dbt12.7/Content/the_menus/MENU_GLOBAL/Global_Embosser_setup_general.htm"
        },
        {
          "title": "Index interfacing notes",
          "url": "https://duxburysystems.com/documentation/dbt14.1/Content/embossers_and_embossing/Embossers_elt_info/ztech_Index_Basic.htm"
        },
        {
          "title": "\"WriteComm failed\" errors",
          "url": "https://duxburysystems.com/documentation/dbt12.7/Content/POPUPS/WriteComm_Failed_Errors.htm"
        },
        {
          "title": "Common problems",
          "url": "https://www.duxburysystems.com/documentation/dbt12.4/troubleshooting/Common_Problems.htm"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Make sure the embosser is on, ready, and has paper.\n2. Install the embosser maker's own Windows driver for that model (Index support page, or HumanWare for Romeo and Juliet), so Windows lists the embosser as a printer.\n3. In DBT, open the embosser setup (Global menu) and pick the embosser model from the list.\n4. Set DBT to send through that Windows printer (\"Send to Printer\") rather than a port.\n5. If the model isn't in DBT's list, choose Generic.\n6. Emboss one page to test.\n7. If it prints garbage, or says \"WriteComm failed\", the setup is talking to the wrong printer or port: go back to step 2 and check the driver, the chosen printer and the model.\n\n## Good to know\n- Duxbury's support: support@duxsys.com, +1-978-692-3000 (duxburysystems.com/contact.asp).\n- Index's interfacing notes in the DBT documentation list the settings each Index model expects."
    },
    {
      "id": "epson-printer-new-router",
      "title": "Epson printer — connect to a new Wi-Fi router",
      "platform": "Epson",
      "devices": [
        "printer",
        "internet"
      ],
      "version": "Epson networking guide; Epson Smart Panel app (Oct 2026)",
      "topics": [
        "printer",
        "wi-fi",
        "new router",
        "reconnect",
        "smart panel"
      ],
      "sources": [
        {
          "title": "Connecting to a new Wi-Fi router (Epson)",
          "url": "https://files.support.epson.com/docid/cpd4/cpd41557/source/printers/source/networking/tasks/switching_router.html"
        },
        {
          "title": "Epson Smart Panel app",
          "url": "https://epson.com/smart-panel-print-scan-app"
        },
        {
          "title": "Epson Smart Panel support",
          "url": "https://epson.com/Support/Printers/Mobile-and-Cloud-Solutions/Epson-Smart-Panel-App/s/SPT_SMARTPANELAPP"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Have the new Wi-Fi name and password ready.\n2. On printers with a screen, open the Wi-Fi setup on the control panel, choose the Wi-Fi setup wizard, pick the network and type the password.\n3. Or use the Epson Smart Panel app on the phone to set the printer up on the new network.\n4. On each computer that prints, add the printer again if it doesn't find it by itself.\n5. Print a test page.\n\n## Good to know\n- Epson's \"switching router\" page has the exact steps for printers without a screen."
    },
    {
      "id": "epson-printer-offline",
      "title": "Epson printer says \"offline\" (Windows and Mac)",
      "platform": "Epson",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Epson FAQ pages (Oct 2026; the same FAQ applies to other models)",
      "topics": [
        "printer",
        "offline",
        "not printing",
        "epson"
      ],
      "sources": [
        {
          "title": "Epson printer offline, Windows (FAQ)",
          "url": "https://epson.com/faq/SPT_C11CJ63202~faq-0000493-et2850?faq_cat=faq-topFaqs"
        },
        {
          "title": "Epson printer offline, Mac (FAQ)",
          "url": "https://epson.com/faq/SPT_C11CJ63202~faq-0000492-et2850"
        },
        {
          "title": "Epson printer problems",
          "url": "https://epson.com/support/printer-problems"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check the printer is on, has paper and ink, and shows no error.\n2. Turn the printer off, wait a full minute, and turn it on again.\n3. Check the computer is on the same Wi-Fi as the printer (the printer's panel or a network status sheet shows its network).\n4. Windows: open the printer's print queue (Settings, Bluetooth & devices, Printers & scanners), make sure \"Use Printer Offline\" is not ticked, and cancel stuck jobs.\n5. Mac: open System Settings, then Printers & Scanners, remove the printer, and add it again.\n6. Restart the computer and print a test page.\n\n## Good to know\n- If the router was changed, the printer has to be put on the new Wi-Fi first (see the Epson new-router entry)."
    },
    {
      "id": "epson-scan-mobile",
      "title": "Epson — scanning (ScanSmart, Smart Panel) and printing from a phone",
      "platform": "Epson",
      "devices": [
        "printer",
        "phone",
        "tablet",
        "computer"
      ],
      "version": "Epson ScanSmart, Smart Panel, iPrint (Oct 2026)",
      "topics": [
        "printer",
        "scan",
        "scanning",
        "print from phone",
        "airprint",
        "mopria"
      ],
      "sources": [
        {
          "title": "Epson ScanSmart",
          "url": "https://epson.com/scansmart-document-scanning-software"
        },
        {
          "title": "Epson Smart Panel app",
          "url": "https://epson.com/smart-panel-print-scan-app"
        },
        {
          "title": "Epson mobile printing (Connect, AirPrint, Mopria)",
          "url": "https://epson.com/connect"
        },
        {
          "title": "Epson iPrint support",
          "url": "https://epson.com/support/epson-iprint-support"
        },
        {
          "title": "Epson support by model (drivers, manuals)",
          "url": "https://epson.com/Support/sl/s"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. On a computer, scan with Epson ScanSmart (install it from Epson's support page for the model if it isn't there).\n2. On a phone or tablet, use the Epson Smart Panel app to scan and to print.\n3. From an iPhone or iPad, most Epson printers also print with AirPrint: choose Share, then Print, then the printer. Android phones print through Mopria or the Epson app.\n4. Tell the tenant where the scan was saved and what it is called.\n\n## Good to know\n- The printer and the phone must be on the same Wi-Fi."
    },
    {
      "id": "fire-tablet-accessibility",
      "title": "Amazon Fire tablet — VoiceView screen reader, Screen Magnifier and color inversion",
      "platform": "Amazon",
      "devices": [
        "tablet",
        "screenReader"
      ],
      "version": "Fire OS (Amazon developer pages Oct 2020 and Nov 2025; customer help pages not read)",
      "topics": [
        "fire tablet",
        "kindle",
        "screen reader",
        "voiceview",
        "screen magnifier",
        "color inversion",
        "invert colors",
        "easier to see"
      ],
      "sources": [
        {
          "title": "Assistive technologies for Fire OS (VoiceView, Screen Magnifier, inversion)",
          "url": "https://developer.amazon.com/docs/fire-tablets/ft-assistive-technologies-fire-os.html"
        },
        {
          "title": "Accessibility on Amazon Fire devices",
          "url": "https://developer.amazon.com/apps-and-games/blogs/2025/11/guide-to-accessibility-on-amazon-fire-devices"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "low",
      "body": "## Steps\n1. Open Settings, then Accessibility.\n2. VoiceView (the screen reader): turn it on there. With VoiceView on, touch to hear an item and double-tap to press it; VoiceView's own tutorial on the tablet teaches the rest.\n3. Screen Magnifier: turn it on there, then use the gesture the tablet shows to zoom in and out.\n4. Color inversion: turn it on there for light text on a dark screen.\n5. If the tenant's tablet looks different, use the tablet's own on-screen help for its version.\n\n## Good to know\n- Low confidence: Amazon's customer help pages (the VoiceView guide, Screen Magnifier, accessibility support) block automated reading, so these steps come from Amazon's developer pages only. A person should collect those pages, check the steps on a Fire tablet, and mark this entry checked. Amazon's accessibility phone number is not confirmed."
    },
    {
      "id": "google-account-gmail",
      "title": "Google account recovery and Gmail not syncing",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet",
        "computer"
      ],
      "version": "Google account and Gmail pages (Oct 2026)",
      "topics": [
        "account",
        "google account",
        "password",
        "account recovery",
        "gmail",
        "email",
        "not syncing",
        "two-step"
      ],
      "sources": [
        {
          "title": "Recover your Google account",
          "url": "https://support.google.com/accounts/answer/7682439?hl=en"
        },
        {
          "title": "Tips for account recovery",
          "url": "https://support.google.com/accounts/answer/7299973?hl=en"
        },
        {
          "title": "2-Step Verification",
          "url": "https://support.google.com/accounts/answer/185839?hl=en"
        },
        {
          "title": "Gmail app sync troubleshooter",
          "url": "https://support.google.com/mail/troubleshooter/2650727"
        },
        {
          "title": "Avoid and report phishing in Gmail",
          "url": "https://support.google.com/mail/answer/8253?hl=en"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Account: use Google's recovery page from a device and place the tenant has used before; they answer the questions themselves, as fully as they can.\n2. Once in, check the recovery phone and email are current, and turn on 2-Step Verification if they agree.\n3. Gmail not syncing: check the internet, then run Google's Gmail sync troubleshooter on the device.\n4. Check the Google storage: full storage stops Gmail.\n5. Restart the device and check that the Gmail app is up to date.\n\n## Good to know\n- Google never asks for a password or a code by phone, text or email."
    },
    {
      "id": "hp-printer-jam-ink",
      "title": "HP printer — paper jams and ink cartridge errors",
      "platform": "HP",
      "devices": [
        "printer"
      ],
      "version": "HP support pages (Oct 2026)",
      "topics": [
        "printer",
        "paper jam",
        "ink",
        "cartridge",
        "cartridge error"
      ],
      "sources": [
        {
          "title": "HP paper jams",
          "url": "https://support.hp.com/us-en/help/printer/paper-jam"
        },
        {
          "title": "HP ink cartridge errors",
          "url": "https://support.hp.com/us-en/help/printer/ink-cartridge-issue"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Jam: turn the printer off and unplug it.\n2. Remove the loose paper from the input and output trays.\n3. Open the access doors the printer has (front, cartridge door, rear) and pull any stuck paper out slowly with both hands, so it doesn't tear. Look for small torn pieces with a flashlight.\n4. Reload the paper straight and not over-full, plug in and turn on.\n5. Cartridge error: open the cartridge door, take the cartridge out, make sure any protective tape is removed, and push it back in until it clicks.\n6. Check the cartridge is the right number for this printer model, then turn the printer off and on.\n\n## Good to know\n- Never pull paper out with the printer on, and never use tools in the paper path."
    },
    {
      "id": "hp-printer-offline",
      "title": "HP printer says \"offline\" — the HP app's Diagnose & Fix, and the Windows queue",
      "platform": "HP",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "HP app (replaced HP Smart, Oct 2026); Windows 11 and 10",
      "topics": [
        "printer",
        "offline",
        "not printing",
        "hp app",
        "diagnose and fix"
      ],
      "sources": [
        {
          "title": "HP printer offline",
          "url": "https://support.hp.com/us-en/help/printer/printer-offline"
        },
        {
          "title": "Why is my HP printer offline (Windows detail)",
          "url": "https://www.hp.com/us-en/shop/tech-takes/why-is-my-hp-printer-offline"
        },
        {
          "title": "The HP app (replaces HP Smart)",
          "url": "https://www.hp.com/us-en/hp-app/overview.html"
        },
        {
          "title": "Fix printer connection and printing problems in Windows",
          "url": "https://support.microsoft.com/en-US/Windows/Hardware/Printer/fix-printer-connection-and-printing-problems-in-windows"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check that the printer is on, has paper, and shows no error or blinking light on its panel.\n2. Turn the printer off, unplug it for a full minute, plug it back in and turn it on.\n3. Make sure the computer or phone is on the same Wi-Fi network as the printer.\n4. Open the HP app (it replaced HP Smart), choose the printer, and run Diagnose & Fix.\n5. On Windows: open Settings, then Bluetooth & devices, then Printers & scanners, choose the printer, open the print queue, and make sure \"Use Printer Offline\" is not ticked. Cancel any stuck jobs there.\n6. Restart the computer, then print a test page.\n7. If it is still offline, remove the printer from the computer and add it again through the HP app.\n\n## Good to know\n- HP Smart is no longer available to download; install the HP app instead. HP Print and Scan Doctor is probably retired, so use Diagnose & Fix.\n- HP's accessibility line: (877) 656-7058, Mon–Fri 11 AM–8 PM ET."
    },
    {
      "id": "hp-printer-scan",
      "title": "HP printer — scanning (with the HP app)",
      "platform": "HP",
      "devices": [
        "printer",
        "computer",
        "phone"
      ],
      "version": "HP app (Oct 2026)",
      "topics": [
        "printer",
        "scan",
        "scanning",
        "hp app"
      ],
      "sources": [
        {
          "title": "HP scanning problems",
          "url": "https://support.hp.com/us-en/help/printer/scanning-issues"
        },
        {
          "title": "Print, scan and fax (HP)",
          "url": "https://support.hp.com/us-en/help/how-to-print-scan-fax"
        },
        {
          "title": "The HP app (replaces HP Smart)",
          "url": "https://www.hp.com/us-en/hp-app/overview.html"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Place the page face down on the glass, lined up with the corner mark (or in the feeder, as the printer shows).\n2. Open the HP app on the computer or phone, choose the printer, then Scan.\n3. Choose document or photo, scan, and save or share the file where the tenant can find it again.\n4. If the app can't find the printer, check both are on the same Wi-Fi and run Diagnose & Fix in the HP app.\n\n## Good to know\n- Tell the tenant exactly where the scan was saved (for example the Documents folder) and its name."
    },
    {
      "id": "hp-printer-wifi-new-router",
      "title": "HP printer — reconnect to Wi-Fi after a new router or a new Wi-Fi password",
      "platform": "HP",
      "devices": [
        "printer",
        "internet"
      ],
      "version": "HP app (Oct 2026); HP wireless help page",
      "topics": [
        "printer",
        "wi-fi",
        "new router",
        "wireless",
        "reconnect"
      ],
      "sources": [
        {
          "title": "HP wireless printer problems",
          "url": "https://support.hp.com/us-en/help/printer/wireless-printer-issues"
        },
        {
          "title": "The HP app (replaces HP Smart)",
          "url": "https://www.hp.com/us-en/hp-app/overview.html"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "medium",
      "body": "## Steps\n1. Have the new Wi-Fi name and password ready (on the router's label, or in the provider's app).\n2. Put the printer near the router for setup.\n3. On printers with a touchscreen, open the Wireless (or network) settings and run the Wireless Setup Wizard; choose the network and type the password.\n4. Or open the HP app on the phone or computer, add the printer, and follow its Wi-Fi setup.\n5. Print a test page from the tenant's device.\n6. ⚠ This erases the printer's saved network settings: if the printer won't join, restore its network settings (HP's wireless page shows the buttons for each model), then set it up again with the HP app.\n\n## Good to know\n- A printer keeps the old router's name and password; after a router change it always needs this once."
    },
    {
      "id": "hp-support-assistant-diagnostics",
      "title": "HP computer — HP Support Assistant and HP PC Hardware Diagnostics",
      "platform": "HP",
      "devices": [
        "computer"
      ],
      "version": "HP support pages (Oct 2026)",
      "topics": [
        "hp",
        "support assistant",
        "diagnostics",
        "battery",
        "won't power on",
        "updates"
      ],
      "sources": [
        {
          "title": "HP Support Assistant",
          "url": "https://support.hp.com/us-en/help/hp-support-assistant"
        },
        {
          "title": "HP PC Hardware Diagnostics",
          "url": "https://support.hp.com/us-en/help/hp-pc-hardware-diagnostics"
        },
        {
          "title": "HP computer problems hub",
          "url": "https://support.hp.com/us-en/help/computer"
        },
        {
          "title": "HP: battery not charging",
          "url": "https://support.hp.com/us-en/help/computer/battery-adapter-issues"
        },
        {
          "title": "HP: Windows 11 and 10 support",
          "url": "https://support.hp.com/us-en/help/windows-10-support-center"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open HP Support Assistant (search for it in Start). It shows the model and serial number, updates, and checks.\n2. Install the updates it offers and restart.\n3. For a hardware check, run HP PC Hardware Diagnostics: the Windows version from HP's page, or the version that runs before Windows starts (HP's page shows the key for each model).\n4. Battery won't charge: follow HP's battery page (check the adapter, the outlet, and the battery check).\n5. Note any failure ID the diagnostics give and contact HP with it.\n\n## Good to know\n- HP's accessibility line: (877) 656-7058, Mon–Fri 11 AM–8 PM ET."
    },
    {
      "id": "index-connect-usb-network-wifi",
      "title": "Index embosser — connect it to a computer (USB, network cable or Wi-Fi)",
      "platform": "Index",
      "devices": [
        "printer",
        "computer",
        "internet"
      ],
      "version": "Index V4 and V5 (catalog Oct 2026); Romeo 60 and Juliet 120 Wi-Fi configuration file",
      "topics": [
        "braille printer",
        "embosser",
        "usb",
        "wi-fi",
        "network",
        "driver",
        "connect",
        "direct braille",
        "word",
        "pdf"
      ],
      "sources": [
        {
          "title": "Index Braille support (FAQ, firmware, drivers)",
          "url": "https://indexbraille.com/support/"
        },
        {
          "title": "Basic-D V5 page (manual, firmware, drivers)",
          "url": "https://www.indexbraille.com/en-us/braille-embossers/basic-d-v5"
        },
        {
          "title": "Index V4 user manual 1.5.3 (PDF)",
          "url": "https://www.indexbraille.com/getmedia/ef31e8a5-d995-4719-af28-3512812c39d0/User-manual-V4-eng-1_5_3.pdf?ext=.pdf"
        },
        {
          "title": "Installing the embosser on a Wi-Fi network using the configuration file (PDF, HumanWare)",
          "url": "https://www.humanware.com/wp-content/uploads/2024/11/Installing-the-Embosser-on-a-Wi-fi-Network-Using-the-Configuration-File.pdf"
        },
        {
          "title": "Index Direct-Braille (print Word and PDF from Windows)",
          "url": "https://www.indexbraille.com/en-us/support/knowledge-base/troubleshooting/all-v4/braille-pdf-word-files-directly-in-windows"
        },
        {
          "title": "Index free tools",
          "url": "https://indexbraille.com/print-braille/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Find out which model and generation it is first (serial label), so you install the right driver.\n2. USB: connect the embosser to the computer with a USB cable, turn the embosser on, then install the Windows driver for that model from Index's support page.\n3. Network cable: plug the embosser into the router with a network cable, turn it on, and get its IP address with HELP+10 (spoken) or HELP+1 (printed page).\n4. Add the embosser on the computer with the driver from Index's support page, using that IP address.\n5. Wi-Fi: on models with Wi-Fi, follow the Wi-Fi section of the manual for that model. For Romeo 60 and Juliet 120, HumanWare's guide uses a configuration file on a USB drive with the network name and password.\n6. Send a one-page test from the program the tenant uses (often Duxbury DBT). If nothing comes out, see \"sending from Duxbury\".\n\n## Good to know\n- USB is the simplest and the easiest to fix later. Use the network or Wi-Fi only when the embosser is shared or far from the computer.\n- After a router change, a network-connected embosser needs the new network too: check its address again with HELP+10.\n- Index Direct-Braille (a free Index tool) embosses Word and PDF files straight from Windows once the driver is in. For formatting that matters (tables, math, contracted braille), Duxbury DBT gives more control."
    },
    {
      "id": "index-error-codes",
      "title": "Index V4 embosser — what the error codes mean",
      "platform": "Index",
      "devices": [
        "printer"
      ],
      "version": "Index V4 user manual 1.3.9 (catalog Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "error code",
        "spool error",
        "tray"
      ],
      "sources": [
        {
          "title": "Index V4 user manual 1.3.9 with the full error-code table (PDF)",
          "url": "https://www.indexbraille.com/getmedia/323e7fe3-4418-4273-9317-88b5c412b2f6/V4-user-1_3_9-english.pdf?ext=.pdf"
        },
        {
          "title": "Index Braille support (FAQ, firmware, drivers)",
          "url": "https://indexbraille.com/support/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Listen to, or read, the number the embosser gives, and write it on the ticket.\n2. 120: out of paper. Load paper.\n3. 121: paper jam. Turn it off and clear the jam (see \"loading paper, jams\").\n4. 123: the paper tray is empty. Load the tray, then press OK.\n5. 130, 131 or 132: a door or tray is open. Close it firmly.\n6. 134: the braille output tray is full. Empty it.\n7. 200 to 299: a spool error in the job that was sent. Press OK to emboss it anyway, or ON to cancel the job, then send it again from the computer.\n8. Any other number: look it up in the error-code table of the V4 manual, or call HumanWare (Index's US distributor).\n\n## Good to know\n- These codes are from the V4 manual. A V5 may use different messages: check the manual for its generation."
    },
    {
      "id": "index-firmware-update",
      "title": "Index embosser — update the firmware (never turn it off during the update)",
      "platform": "Index",
      "devices": [
        "printer"
      ],
      "version": "Index V4 and V5; Firmware Version 3 for board 1366 only (catalog Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "firmware",
        "update"
      ],
      "sources": [
        {
          "title": "Index Braille support (FAQ, firmware, drivers)",
          "url": "https://indexbraille.com/support/"
        },
        {
          "title": "Firmware Version 3 (board 1366 only)",
          "url": "https://indexbraille.com/learn-more/firmware-version-3/"
        },
        {
          "title": "Basic-D V5 page (manual, firmware, drivers)",
          "url": "https://www.indexbraille.com/en-us/braille-embossers/basic-d-v5"
        },
        {
          "title": "ETC firmware version 3 release notes, board 1366 only (PDF, HumanWare)",
          "url": "https://www.humanware.com/wp-content/uploads/2026/04/ETC-Firmware-version-3-Release-notes-1366-Only.pdf"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Only update when there is a reason (a fix the release notes name, or Index or HumanWare asks you to). If it works, leave it.\n2. Identify the model and generation from the serial label first. Index's Firmware Version 3 is for board 1366 only; never load it on anything else.\n3. Download the firmware and its instructions from the page for that model (Index support, or HumanWare for Romeo 60 and Juliet 120).\n4. Plug the embosser into a wall outlet (not a loose power strip) and make sure nobody will need it for the next half hour.\n5. Start the update the way the instructions for that model say. It takes about 5 to 15 minutes.\n6. Never turn the embosser off, unplug it or close the computer while it updates, even if it seems stuck.\n7. When it says it is done, turn it off and on, check its IP address with HELP+10 if it is on the network, and emboss one test page.\n\n## Good to know\n- An interrupted firmware update can leave the embosser unusable until it is repaired. Patience is the whole job here."
    },
    {
      "id": "index-identify-model",
      "title": "Index braille embosser — which model is it? (read the serial label)",
      "platform": "Index",
      "devices": [
        "printer",
        "other"
      ],
      "version": "Index embossers 1986 to today (V3, V4, V5; serial ranges as of Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "serial number",
        "model",
        "identify"
      ],
      "sources": [
        {
          "title": "Which model is it? Index embossers from 1986 to today",
          "url": "https://www.indexbraille.com/en-us/support/embosser-overview-from-1986-to-today"
        },
        {
          "title": "Index Braille support (FAQ, firmware, drivers)",
          "url": "https://indexbraille.com/support/"
        },
        {
          "title": "Index V5 embossers brochure (PDF)",
          "url": "https://www.indexbraille.com/getmedia/3bd1667d-aa99-4ffc-bf19-094c767a8cec/Index-V5-Embossers-190828.pdf?ext=.pdf"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Turn the embosser off and unplug it before you move it to look for the label.\n2. Find the product label with the serial number on the embosser's case. Look on the back and underneath; a flashlight helps.\n3. Write down the model name and the full serial number exactly as printed (take a photo of the label for the ticket).\n4. Use the serial number to place the generation: 30000 to 49999 is a V3; 50000 and up is a V4 or later; the V5 models were made from 2016.\n5. Open Index's \"embosser overview from 1986 to today\" page and match the model name and serial to confirm the generation before you download any manual, driver or firmware.\n6. If the label says Romeo 60 or Juliet 120, it is an Enabling Technologies embosser: use the HumanWare support page for it, not Index's.\n7. If the label says PageBlaster, it is APH's embosser based on the Index Basic-D V5: use APH's PageBlaster FAQ and the Basic-D V5 materials.\n\n## Good to know\n- The generation decides which manual, error-code table, driver and firmware apply. Never load firmware for a different generation.\n- In the US and Canada, Index embossers are sold and repaired through HumanWare.\n- Write the model and serial number on the ticket so the next visit doesn't have to look again."
    },
    {
      "id": "index-network-ip-address",
      "title": "Index embosser — find its network address (HELP+10 speaks it, HELP+1 prints the network page)",
      "platform": "Index",
      "devices": [
        "printer",
        "internet"
      ],
      "version": "Index V4 and V5; Romeo 60 and Juliet 120 (catalog Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "ip address",
        "network page",
        "help key",
        "ethernet"
      ],
      "sources": [
        {
          "title": "Basic-D V5 page (manual, firmware, drivers)",
          "url": "https://www.indexbraille.com/en-us/braille-embossers/basic-d-v5"
        },
        {
          "title": "Index V4 user manual 1.5.3 (PDF)",
          "url": "https://www.indexbraille.com/getmedia/ef31e8a5-d995-4719-af28-3512812c39d0/User-manual-V4-eng-1_5_3.pdf?ext=.pdf"
        },
        {
          "title": "Juliet 120 / Romeo 60 manual (PDF)",
          "url": "https://humanware.com/wp-content/uploads/2024/11/2024-09-18-Manual-Juliet-120-Romeo-60_EN.pdf"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Turn the embosser on and wait until it says it is ready.\n2. Make sure its network cable runs to the router (or that it was set up on Wi-Fi before), and that the computer is on the same network.\n3. On the embosser's keypad, use the combination the manual writes as HELP+10. The embosser speaks its IP address out loud.\n4. If you need it on paper, use HELP+1. The embosser prints its network page, with the IP address and the network settings.\n5. Write the IP address on the ticket. The computer's driver or Duxbury needs this address to send to the embosser over the network.\n6. If the address is missing or starts with 169.254, the embosser did not get an address from the router: check the cable, restart the router, then turn the embosser off and on and ask again with HELP+10.\n\n## Good to know\n- Index, Romeo 60 and Juliet 120 all use HELP+10 and HELP+1 for this (catalog, Oct 2026).\n- If you're not sure how the keypad combination is pressed on this model, the manual for its generation explains the keypad. Check the generation first (see \"which model is it\").\n- The tenant can do this by touch and hear the result, which makes it a good first step over the phone."
    },
    {
      "id": "index-paper-and-jams",
      "title": "Index embosser — loading paper, jams and \"out of paper\"",
      "platform": "Index",
      "devices": [
        "printer"
      ],
      "version": "Index V4 (Basic-D, Everest-D, BrailleBox) and V5 (catalog Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "paper jam",
        "out of paper",
        "double feed",
        "loading paper"
      ],
      "sources": [
        {
          "title": "Index V4 user manual 1.3.9 with the error-code table (PDF)",
          "url": "https://www.indexbraille.com/getmedia/323e7fe3-4418-4273-9317-88b5c412b2f6/V4-user-1_3_9-english.pdf?ext=.pdf"
        },
        {
          "title": "Clear a paper jam on the BrailleBox",
          "url": "https://www.indexbraille.com/en-us/support/knowledge-base/troubleshooting/braille-box-v4/clear-a-paper-jam-braille-box"
        },
        {
          "title": "BrailleBox \"out of paper\" message",
          "url": "https://www.indexbraille.com/en-us/support/knowledge-base/troubleshooting/braille-box-v4/braille-box-out-of-paper-message"
        },
        {
          "title": "Basic-D V5 page (manual, firmware, drivers)",
          "url": "https://www.indexbraille.com/en-us/braille-embossers/basic-d-v5"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Turn the embosser off before you put your hands near the paper path.\n2. Remove the paper that is stuck by pulling it gently and evenly; tear at the nearest fold or perforation if it is continuous paper. Look for small torn pieces.\n3. Reload the paper the way the manual for that model shows: continuous tractor-feed paper on a Basic-D; single sheets in the tray on an Everest-D or a BrailleBox. Keep it straight, and fan it first.\n4. BrailleBox says \"out of paper\" with paper in it: push the paper tray all the way in, and clean the paper sensor gently with a cotton swab.\n5. Everest-D picks up two sheets at once: move the paper selector up one step. It doesn't pick up a sheet: move it down one step. In humid weather, fan the paper before loading.\n6. Turn the embosser on, clear the message, and send one page to test.\n\n## Good to know\n- On a V4, code 120 means out of paper and 121 means a jam (the full list is in \"Index error codes\").\n- Braille paper is heavy: a bent stack or damp paper causes most jams."
    },
    {
      "id": "internet-outage-check",
      "title": "Check for an internet outage (Spectrum, Verizon Fios)",
      "platform": "Spectrum",
      "devices": [
        "internet"
      ],
      "version": "Spectrum and Verizon pages (Oct 2026)",
      "topics": [
        "internet",
        "outage",
        "down",
        "no internet",
        "provider"
      ],
      "sources": [
        {
          "title": "Contact Spectrum (internet 888-369-2408, 24/7)",
          "url": "https://www.spectrum.com/contact-spectrum"
        },
        {
          "title": "My Spectrum app",
          "url": "https://www.spectrum.com/apps"
        },
        {
          "title": "Verizon outages",
          "url": "https://www.verizon.com/support/residential/service-outage"
        },
        {
          "title": "Verizon Home app",
          "url": "https://www.verizon.com/support/verizon-home-app-faqs/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Ask a neighbor with the same provider, or the front desk, whether their internet is down too.\n2. Spectrum: check the My Spectrum app (on mobile data) or call Spectrum internet support, 888-369-2408 (24/7).\n3. Verizon: check Verizon's outage page or the Verizon Home app on mobile data.\n4. If there is an outage, nothing in the apartment will fix it: tell the tenant, and note it on the ticket.\n\n## Good to know\n- Spectrum Disability Support (844-762-1301) and Verizon's Center for Customers with Disabilities (800-974-6006) are the accessible routes in."
    },
    {
      "id": "iphone-email-not-sending",
      "title": "iPhone and iPad — can't send email (Mail, iCloud Mail)",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "iOS/iPadOS 27 (Apple pages Oct 2026)",
      "topics": [
        "email",
        "mail",
        "can't send",
        "icloud mail",
        "outbox",
        "storage full"
      ],
      "sources": [
        {
          "title": "If you can't send email on your iPhone",
          "url": "https://support.apple.com/en-us/102556"
        },
        {
          "title": "If iCloud Mail is not working",
          "url": "https://support.apple.com/en-us/102562"
        },
        {
          "title": "Check storage on iPhone and iPad",
          "url": "https://support.apple.com/en-us/108429"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check the device has internet (open a web page in Safari).\n2. Look in the Mail app's Outbox for a stuck message; a very large attachment is a common cause. Send it again smaller.\n3. For iCloud Mail, check iCloud storage (Settings, their name, iCloud): full iCloud storage stops email.\n4. Restart the iPhone or iPad and try again.\n5. Follow Apple's can't-send page for the account's settings; for an Outlook.com or Gmail account, see that provider's entry.\n\n## Good to know\n- The mail lives on the provider's server; the problem is usually storage, internet, or the account's sign-in."
    },
    {
      "id": "iphone-ipad-forgot-passcode",
      "title": "iPhone and iPad — forgot the passcode, \"iPhone Unavailable\"",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "passcode",
        "forgot passcode",
        "iphone unavailable",
        "locked out",
        "security lockout"
      ],
      "sources": [
        {
          "title": "Forgot your passcode / \"iPhone Unavailable\"",
          "url": "https://support.apple.com/en-us/105090"
        },
        {
          "title": "Use your previous passcode within 72 hours",
          "url": "https://support.apple.com/en-us/105039"
        },
        {
          "title": "Reset your iPhone with a computer (erases)",
          "url": "https://support.apple.com/en-us/118430"
        },
        {
          "title": "Contact Apple Support",
          "url": "https://support.apple.com/HT201232"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "high",
      "body": "## Steps\n1. Stop guessing: each wrong try makes the wait longer.\n2. Ask whether the passcode was changed in the last 72 hours. If so, on the lock screen choose \"Forgot Passcode?\" and use the option to enter the previous passcode.\n3. Check that the tenant knows their Apple Account password and has the backup they expect (iCloud or a computer). Without the Apple Account password, stop and call Apple Support (1-800-275-2273).\n4. ⚠ This erases everything on the iPhone or iPad: on the \"iPhone Unavailable\" screen, \"Forgot Passcode?\" can reset the device with the Apple Account password; afterwards it is set up again from the backup.\n5. ⚠ This erases everything on the iPhone or iPad: if that option isn't there, reset it with a computer in recovery mode (Apple's page), then restore the backup.\n\n## Good to know\n- Only the tenant types the Apple Account password. Never keep it."
    },
    {
      "id": "iphone-ipad-invert-filters-contrast",
      "title": "iPhone and iPad — invert colors (Smart and Classic Invert), Color Filters, contrast and glare",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "easier to see",
        "invert colors",
        "smart invert",
        "classic invert",
        "color filters",
        "contrast",
        "reduce white point",
        "glare",
        "grayscale"
      ],
      "sources": [
        {
          "title": "Display & Text Size, the full list (Apple)",
          "url": "https://support.apple.com/en-us/111773"
        },
        {
          "title": "Change display colors on iPhone (invert, Color Filters)",
          "url": "https://support.apple.com/guide/iphone/change-display-colors-iph3e2e1fb0/ios"
        },
        {
          "title": "About the vision accessibility features (iPhone and iPad)",
          "url": "https://support.apple.com/en-us/111779"
        },
        {
          "title": "Accessibility Shortcut (triple-click)",
          "url": "https://support.apple.com/en-us/111771"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Open Settings, then Accessibility, then Display & Text Size.\n2. Turn on Smart Invert to make the screen dark with light text while photos and videos keep their real colors. This is usually the most comfortable.\n3. If the tenant prefers everything reversed, including pictures, turn Smart Invert off and Classic Invert on instead (only one is on at a time).\n4. Turn on Increase Contrast to make buttons and text stand out; turn on Button Shapes if it's hard to tell what is a button.\n5. Turn on Reduce White Point and move its slider to make bright colors less glaring.\n6. Open Color Filters and turn it on; choose Grayscale or a tint and adjust the intensity until it is comfortable.\n7. To switch any of these on and off quickly, add it to the Accessibility Shortcut (Settings, Accessibility, Accessibility Shortcut): three clicks of the side button (or the Home button) then turns it on or off.\n\n## Good to know\n- If the screen suddenly looks gray, tinted or reversed, a Color Filter or an invert was probably turned on by accident (often by the triple-click): turn it off here.\n- Dark Mode (Settings, Display & Brightness) is a gentler choice some people like better."
    },
    {
      "id": "iphone-ipad-magnifier",
      "title": "iPhone and iPad — Magnifier (use the camera as a magnifying glass, read text aloud, find doors)",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "easier to see",
        "magnifier",
        "camera",
        "read text aloud",
        "detection mode",
        "doors",
        "mail",
        "labels"
      ],
      "sources": [
        {
          "title": "Magnify or describe things around you (iPhone)",
          "url": "https://support.apple.com/guide/iphone/magnify-or-describe-things-around-you-iphe867dc99c/ios"
        },
        {
          "title": "Magnifier on iPad",
          "url": "https://support.apple.com/guide/ipad/magnify-information-ipadd86f5027/ipados"
        },
        {
          "title": "Magnifier: read text aloud",
          "url": "https://support.apple.com/guide/iphone/detect-text-read-loud-iph29dbe3fb6/ios"
        },
        {
          "title": "Magnifier Detection Mode (doors, people, furniture)",
          "url": "https://support.apple.com/guide/iphone/detect-doors-around-you-iph35c335575/ios"
        },
        {
          "title": "Turn accessibility features on or off quickly",
          "url": "https://support.apple.com/guide/iphone/quickly-turn-accessibility-features-on-or-off-iph3e2e31a5/ios"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open the Magnifier app (ask Siri \"Open Magnifier\", or search for it).\n2. Point the camera at the letter, label or screen and use the zoom slider to make it bigger. Turn on the light if it is dark.\n3. Freeze the picture (the shutter button) to hold it still and read it comfortably.\n4. To hear the text read aloud, use Magnifier's reading feature (Apple's \"read text aloud\" page shows where it is in this version).\n5. To find it quickly next time, add Magnifier to Control Center or to the Accessibility Shortcut.\n\n## Good to know\n- Detection Mode can announce doors, people and furniture nearby on supported iPhones."
    },
    {
      "id": "iphone-ipad-restart-frozen",
      "title": "iPhone and iPad — frozen, black screen, won't turn on (restart and force restart)",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "iOS/iPadOS 27 (iPhone 8 and later; iPads with and without a Home button)",
      "topics": [
        "frozen",
        "won't turn on",
        "black screen",
        "force restart",
        "restart",
        "app not responding",
        "recovery mode"
      ],
      "sources": [
        {
          "title": "Restart your iPhone",
          "url": "https://support.apple.com/en-us/118259"
        },
        {
          "title": "If your iPhone won't turn on or is frozen (force restart)",
          "url": "https://support.apple.com/en-us/116940"
        },
        {
          "title": "If your iPad won't turn on or is frozen",
          "url": "https://support.apple.com/en-us/102642"
        },
        {
          "title": "If an app stops responding",
          "url": "https://support.apple.com/en-us/119876"
        },
        {
          "title": "If you can't update or restore your iPhone or iPad (recovery mode)",
          "url": "https://support.apple.com/en-us/118106"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "high",
      "body": "## Steps\n1. Plug it into a charger that works and leave it for up to an hour; a fully flat battery shows nothing at first.\n2. One app frozen: swipe up from the bottom and pause to see open apps, then swipe that app up to close it, and open it again.\n3. Force restart an iPhone 8 or later: press and quickly release volume up, press and quickly release volume down, then press and hold the side button until the Apple logo appears.\n4. iPad without a Home button: press and release the volume button nearest the top button, then the other volume button, then hold the top button until the Apple logo appears. iPad with a Home button: hold the top button and the Home button together until the Apple logo appears.\n5. If it is stuck on the Apple logo, connect it to a computer and use recovery mode to Update (Apple's page); Update keeps the data.\n6. ⚠ This erases everything on the iPhone or iPad: Restore in recovery mode only if Update fails, only with the tenant's OK, and only after checking they know their Apple Account password (the backup comes back from iCloud or the computer).\n\n## Good to know\n- Force restart doesn't erase anything; it is the right first step for a frozen phone."
    },
    {
      "id": "iphone-ipad-storage-update",
      "title": "iPhone and iPad — storage full, updating, battery and slow",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "iOS/iPadOS 27 (current 27.0.1, 28 Sep 2026)",
      "topics": [
        "storage full",
        "update",
        "software update",
        "slow",
        "battery",
        "offload apps"
      ],
      "sources": [
        {
          "title": "Check storage on iPhone and iPad",
          "url": "https://support.apple.com/en-us/108429"
        },
        {
          "title": "Update your iPhone or iPad",
          "url": "https://support.apple.com/en-us/118575"
        },
        {
          "title": "iPhone battery and performance",
          "url": "https://support.apple.com/en-us/101575"
        },
        {
          "title": "Apple security releases (current versions)",
          "url": "https://support.apple.com/en-us/100100"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Open Settings, then General, then iPhone (or iPad) Storage, and wait for the list.\n2. Go through the recommendations with the tenant. \"Offload Unused Apps\" removes apps that aren't used but keeps their documents and data.\n3. Large videos and old messages are usually the biggest; the tenant decides what goes.\n4. Update: connect to Wi-Fi and a charger, then Settings, General, Software Update.\n5. Battery: Settings, Battery, Battery Health shows if the battery needs service, which can make an old phone slow.\n\n## Good to know\n- Full storage can stop email and backups; it is worth checking on every visit."
    },
    {
      "id": "iphone-ipad-text-size",
      "title": "iPhone and iPad — bigger and bolder text, Hover Text, Accessibility Reader",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "iOS/iPadOS 27 (Hover Text iOS 18–27; Accessibility Reader iOS 26–27)",
      "topics": [
        "easier to see",
        "text size",
        "larger text",
        "bold text",
        "hover text",
        "accessibility reader",
        "older adults"
      ],
      "sources": [
        {
          "title": "Make text easier to read on iPhone",
          "url": "https://support.apple.com/guide/iphone/make-text-easier-to-read-iph3c076905a/ios"
        },
        {
          "title": "Display & Text Size, the full list (Apple)",
          "url": "https://support.apple.com/en-us/111773"
        },
        {
          "title": "Hover Text and Hover Typing",
          "url": "https://support.apple.com/guide/iphone/view-a-larger-version-text-reading-typing-iphe2449dec8/ios"
        },
        {
          "title": "Accessibility Reader",
          "url": "https://support.apple.com/guide/iphone/read-listen-text-apps-accessibility-reader-iph406a46ab8/ios"
        },
        {
          "title": "Personalize Apple Accessibility for older adults",
          "url": "https://support.apple.com/en-us/126977"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Open Settings, then Accessibility, then Display & Text Size.\n2. Turn on Bold Text.\n3. Open Larger Text, turn on Larger Accessibility Sizes, and drag the slider until the tenant can read the sample comfortably.\n4. For one word at a time even bigger, turn on Hover Text (Apple's Hover Text page shows where it is): it shows a large copy of whatever is under the finger or pointer.\n5. Accessibility Reader shows the text of a page or app in a simple, large, high-contrast view that can also read it aloud.\n\n## Good to know\n- Apple's page for older adults walks through the settings that help most, in plain words.\n- Some apps don't follow the text size; Zoom works everywhere."
    },
    {
      "id": "iphone-ipad-wifi-fix",
      "title": "iPhone and iPad — can't connect to Wi-Fi (Reset Network Settings last)",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "internet"
      ],
      "version": "iOS/iPadOS 27 (Apple page Oct 2026)",
      "topics": [
        "internet",
        "wi-fi",
        "won't connect",
        "forget network",
        "reset network settings"
      ],
      "sources": [
        {
          "title": "iPhone or iPad can't connect to Wi-Fi",
          "url": "https://support.apple.com/en-us/111786"
        },
        {
          "title": "Forget a Wi-Fi network",
          "url": "https://support.apple.com/en-us/102480"
        },
        {
          "title": "Share a Wi-Fi password",
          "url": "https://support.apple.com/en-us/102635"
        },
        {
          "title": "Private Wi-Fi address",
          "url": "https://support.apple.com/en-us/102509"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "high",
      "body": "## Steps\n1. Open Settings, then Wi-Fi, check Wi-Fi is on and choose the right network.\n2. Make sure Airplane Mode is off.\n3. Restart the iPhone or iPad.\n4. Restart the modem and router by unplugging them for a full minute.\n5. Forget the network (tap its info button, then Forget This Network) and join again with the password in hand.\n6. ⚠ This erases every saved Wi-Fi password, Bluetooth pairing and network setting on the device: as the very last step, use Reset Network Settings (Settings, General, Transfer or Reset, Reset). Have the Wi-Fi password ready first.\n\n## Good to know\n- A nearby iPhone that is already connected can share the password by bringing the two phones close."
    },
    {
      "id": "iphone-ipad-zoom",
      "title": "iPhone and iPad — Zoom (magnify the whole screen)",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "easier to see",
        "zoom",
        "magnification",
        "stuck zoomed in",
        "low vision"
      ],
      "sources": [
        {
          "title": "Zoom in on iPhone",
          "url": "https://support.apple.com/guide/iphone/zoom-in-iph3e2e367e/ios"
        },
        {
          "title": "Zoom in on iPad",
          "url": "https://support.apple.com/guide/ipad/zoom-in-ipad9a245e3e/ipados"
        },
        {
          "title": "Accessibility Shortcut (triple-click)",
          "url": "https://support.apple.com/en-us/111771"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Open Settings, then Accessibility, then Zoom, and turn Zoom on.\n2. Double-tap the screen with three fingers to zoom in; do it again to zoom out.\n3. While zoomed in, drag with three fingers to move around the screen.\n4. To change how far it zooms, double-tap with three fingers and keep your fingers down on the second tap, then slide them up (more) or down (less).\n5. Choose Full Screen Zoom or Window Zoom in the same Zoom settings.\n\n## Good to know\n- \"My screen is stuck big and I can't do anything\": Zoom is on. Double-tap with three fingers to zoom out, then turn Zoom off in Settings if it isn't wanted.\n- Zoom and VoiceOver can both be on, but the gestures change; practise with the tenant."
    },
    {
      "id": "iphone-speak-screen",
      "title": "iPhone and iPad — have the screen read aloud (Speak Screen, Speak Selection)",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "read aloud",
        "speak screen",
        "speak selection",
        "low vision",
        "reading"
      ],
      "sources": [
        {
          "title": "Hear what's on the screen or typed (iPhone)",
          "url": "https://support.apple.com/guide/iphone/hear-whats-on-the-screen-or-typed-iph96b214f0/ios"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings, then Accessibility, then Spoken Content.\n2. Turn on Speak Screen. Then swipe down with two fingers from the top of the screen to hear the whole page read aloud; a small control appears to pause or change the speed.\n3. Turn on Speak Selection. Then select some text and choose Speak.\n4. Choose the voice and the speaking rate in the same Spoken Content settings.\n\n## Good to know\n- This is for people who can see the screen but tire reading it. A person who cannot see the screen needs VoiceOver instead.\n- You can also ask Siri \"Speak Screen\"."
    },
    {
      "id": "jaws-start-basics",
      "title": "JAWS — start it, stop speech, and the first keys",
      "platform": "Vispero",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "JAWS 2026 (Sep 2026 build; keystrokes PDF)",
      "topics": [
        "screen reader",
        "jaws",
        "start",
        "keys",
        "hotkeys",
        "say all"
      ],
      "sources": [
        {
          "title": "JAWS Keystrokes (PDF)",
          "url": "https://support.freedomscientific.com/Content/Documents/Manuals/JAWS/Keystrokes.pdf"
        },
        {
          "title": "JAWS Hotkeys",
          "url": "https://www.freedomscientific.com/training/jaws/hotkeys/"
        },
        {
          "title": "Getting Started with JAWS (9 lessons)",
          "url": "https://www.freedomscientific.com/training/jaws/getting-started/"
        },
        {
          "title": "FSCompanion (Vispero's AI helper for JAWS keystrokes)",
          "url": "https://www.freedomscientific.com/training/jaws/fscompanion/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Start JAWS from its desktop shortcut key, Ctrl+Alt+J, or from the Start menu.\n2. The \"JAWS key\" is Insert (or Caps Lock with the laptop layout).\n3. Press Ctrl to stop speech.\n4. Insert + Down Arrow reads everything from the current spot (desktop layout).\n5. Insert + H lists the hotkeys for the program in front; Insert + J opens the JAWS window; Insert + F4 closes JAWS.\n6. FSCompanion, Vispero's AI helper, can answer \"what is the key for…\" questions in plain words.\n\n## Good to know\n- JAWS needs a license; Freedom Scientific's phone support (727-803-8600) is only with a current maintenance agreement or subscription. Training (Getting Started, webinars, podcast) is free."
    },
    {
      "id": "jaws-web-email",
      "title": "JAWS — reading a web page and email",
      "platform": "Vispero",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "JAWS 2026; Outlook (catalog Oct 2026)",
      "topics": [
        "screen reader",
        "jaws",
        "web page",
        "headings",
        "links",
        "email",
        "outlook"
      ],
      "sources": [
        {
          "title": "JAWS Keystrokes (PDF)",
          "url": "https://support.freedomscientific.com/Content/Documents/Manuals/JAWS/Keystrokes.pdf"
        },
        {
          "title": "Surfing the internet with JAWS",
          "url": "https://support.freedomscientific.com/SurfsUp/1-StartHere.htm"
        },
        {
          "title": "Email in Outlook with a screen reader",
          "url": "https://support.microsoft.com/en-us/accessibility/outlook/basic-tasks-using-a-screen-reader-with-email-in-outlook"
        },
        {
          "title": "Outlook keyboard shortcuts",
          "url": "https://support.microsoft.com/en-us/accessibility/outlook/keyboard-shortcuts-for-outlook"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Web page: H moves to the next heading and Shift+H to the previous one.\n2. Insert + F6 lists the headings and Insert + F7 lists the links; arrow to one and press Enter.\n3. Tab moves between links and buttons; Enter follows a link.\n4. Email in Outlook: Up and Down arrows move through the messages; Enter opens one; Insert + Down Arrow reads it.\n5. Ctrl+N starts a new message, Ctrl+R replies, Ctrl+Enter sends.\n\n## Good to know\n- Freedom Scientific's \"Surf's Up\" tutorial teaches web browsing with JAWS from the start."
    },
    {
      "id": "lenovo-vantage-diagnostics",
      "title": "Lenovo — Lenovo Vantage, the serial number, and diagnostics (F10 on ThinkPad, Novo button on IdeaPad)",
      "platform": "Lenovo",
      "devices": [
        "computer"
      ],
      "version": "Lenovo support pages; UEFI diagnostics guide v04.34 (Oct 2026)",
      "topics": [
        "lenovo",
        "vantage",
        "diagnostics",
        "serial number",
        "thinkpad",
        "ideapad",
        "no power"
      ],
      "sources": [
        {
          "title": "Lenovo Vantage",
          "url": "https://support.lenovo.com/us/en/solutions/ht505081"
        },
        {
          "title": "Find the Lenovo serial number",
          "url": "https://pcsupport.lenovo.com/us/en/solutions/ht510152"
        },
        {
          "title": "Lenovo diagnostics",
          "url": "https://support.lenovo.com/us/en/solutions/diagnose"
        },
        {
          "title": "Lenovo diagnostics downloads",
          "url": "https://support.lenovo.com/us/en/solutions/ht506581"
        },
        {
          "title": "Lenovo UEFI diagnostics guide (PDF)",
          "url": "https://download.lenovo.com/pccbbs/thinkvantage_en/ldiag_v04.34.001_bootable_uefi_ug.pdf"
        },
        {
          "title": "Lenovo: no power",
          "url": "https://support.lenovo.com/us/en/solutions/ht510410"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Find the serial number (label on the bottom, or Lenovo's page shows other places). Write it on the ticket.\n2. Open Lenovo Vantage (search for it in Start) to check for updates and the device's health.\n3. For a hardware check, use Lenovo's diagnostics; the built-in UEFI diagnostics start with F10 on a ThinkPad, or from the Novo button menu on an IdeaPad (Lenovo's guide shows each step).\n4. No power: follow Lenovo's no-power page for that model.\n5. Note any error code and contact Lenovo with the serial number.\n\n## Good to know\n- The Novo button is a small button or pinhole on the side of many IdeaPads; it opens a startup menu."
    },
    {
      "id": "mac-easier-to-see",
      "title": "Mac — Zoom, invert colors, color filters, contrast and a bigger pointer",
      "platform": "Apple",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "macOS 27",
      "topics": [
        "easier to see",
        "zoom",
        "magnification",
        "invert colors",
        "color filters",
        "contrast",
        "pointer size",
        "hover text",
        "mac"
      ],
      "sources": [
        {
          "title": "Zoom in on what's on the screen (Mac)",
          "url": "https://support.apple.com/guide/mac-help/zoom-in-on-whats-onscreen-mchl779716b8/mac"
        },
        {
          "title": "Adjust the display colors on Mac (invert, filters)",
          "url": "https://support.apple.com/guide/mac-help/adjust-the-display-colors-mchl11ddd4b3/mac"
        },
        {
          "title": "Display settings for accessibility on Mac",
          "url": "https://support.apple.com/guide/mac-help/change-display-settings-for-accessibility-unac089/mac"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open the Apple menu, then System Settings, then Accessibility, then Zoom.\n2. Turn on \"Use keyboard shortcuts to zoom\". Then Option-Command-8 turns zoom on and off, Option-Command-Equals zooms in and Option-Command-Minus zooms out.\n3. Or turn on \"Use scroll gesture with modifier keys to zoom\", and zoom by holding the key shown there while scrolling.\n4. Turn on Hover Text (in the same Zoom settings) to show a large copy of the text under the pointer.\n5. In Accessibility, then Display: turn on Invert colors for light text on a dark screen, and Increase contrast to make edges and buttons stand out.\n6. In the same Display settings, open Color filters to choose Grayscale or a tint, and under Pointer make the pointer bigger with an outline color that stands out.\n\n## Good to know\n- If the Mac screen is \"stuck big\", Zoom is on: use the same shortcut or gesture to zoom out.\n- Dark Mode (System Settings, Appearance) is a gentler alternative to inverting."
    },
    {
      "id": "mac-slow-storage-update",
      "title": "Mac — running slowly, storage full, updating macOS, battery",
      "platform": "Apple",
      "devices": [
        "computer"
      ],
      "version": "macOS 27 (current 27.0.1, 28 Sep 2026)",
      "topics": [
        "mac",
        "slow",
        "storage full",
        "update",
        "software update",
        "battery"
      ],
      "sources": [
        {
          "title": "If your Mac runs slowly",
          "url": "https://support.apple.com/guide/mac-help/if-your-mac-runs-slowly-mchlp1731/mac"
        },
        {
          "title": "Free up storage on Mac",
          "url": "https://support.apple.com/en-us/102624"
        },
        {
          "title": "Update macOS",
          "url": "https://support.apple.com/en-us/108382"
        },
        {
          "title": "Apple security releases (current versions)",
          "url": "https://support.apple.com/en-us/100100"
        },
        {
          "title": "Mac battery cycle count",
          "url": "https://support.apple.com/en-us/102888"
        },
        {
          "title": "Mac battery \"Service Recommended\"",
          "url": "https://support.apple.com/en-us/108376"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Restart the Mac.\n2. Quit programs that aren't needed; Activity Monitor shows which ones use the most.\n3. Check storage: Apple menu, System Settings, General, Storage. Go through the recommendations with the tenant; nothing is removed without their OK.\n4. Update: Apple menu, System Settings, General, Software Update. Plug a laptop in first.\n5. Battery: if the battery status says \"Service Recommended\", the battery needs service; Apple's pages explain the cycle count.\n\n## Good to know\n- Apple's security releases page shows the current versions (macOS 27.0.1 on 28 Sep 2026; security fixes also for macOS Tahoe 26.7.1 and Sequoia 15.8.1)."
    },
    {
      "id": "mac-wifi-fix",
      "title": "Mac — not connecting over Wi-Fi (Wireless Diagnostics)",
      "platform": "Apple",
      "devices": [
        "computer",
        "internet"
      ],
      "version": "macOS 27",
      "topics": [
        "internet",
        "wi-fi",
        "mac",
        "wireless diagnostics",
        "forget network"
      ],
      "sources": [
        {
          "title": "If your Mac doesn't connect to the internet over Wi-Fi",
          "url": "https://support.apple.com/en-us/101588"
        },
        {
          "title": "Use Wireless Diagnostics on Mac",
          "url": "https://support.apple.com/guide/mac-help/use-wireless-diagnostics-mchlf4de377f/mac"
        },
        {
          "title": "Forget a Wi-Fi network",
          "url": "https://support.apple.com/en-us/102480"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check that Wi-Fi is on and the Mac is on the right network (the Wi-Fi icon in the menu bar).\n2. Restart the Mac.\n3. Restart the modem and router by unplugging them for a full minute.\n4. Run Wireless Diagnostics (Apple's page shows how to open it) and follow what it suggests.\n5. Forget the network and join it again, with the password in hand.\n\n## Good to know\n- Forgetting a network removes only that one saved password."
    },
    {
      "id": "mac-wont-start-startup-keys",
      "title": "Mac won't turn on or start up — Apple Diagnostics, Safe Mode, macOS Recovery (startup keys)",
      "platform": "Apple",
      "devices": [
        "computer"
      ],
      "version": "macOS 27 (Apple silicon and Intel)",
      "topics": [
        "mac",
        "won't turn on",
        "won't start",
        "apple diagnostics",
        "safe mode",
        "recovery",
        "reinstall macos"
      ],
      "sources": [
        {
          "title": "If your Mac doesn't turn on",
          "url": "https://support.apple.com/en-us/102623"
        },
        {
          "title": "Apple Diagnostics",
          "url": "https://support.apple.com/en-us/102550"
        },
        {
          "title": "Start up your Mac in safe mode",
          "url": "https://support.apple.com/en-us/116946"
        },
        {
          "title": "macOS Recovery",
          "url": "https://support.apple.com/en-us/102518"
        },
        {
          "title": "Reinstall macOS",
          "url": "https://support.apple.com/en-us/102655"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check the power: the charger is in firmly at both ends and the outlet works. Let a laptop charge for a while.\n2. Follow Apple's \"if your Mac doesn't turn on\" page for this kind of Mac (it covers holding the power button and what to try next).\n3. Find out whether the Mac has Apple silicon or Intel (Apple menu, About This Mac, if it starts; otherwise the model on the box or the bottom).\n4. Apple Diagnostics: on Apple silicon, hold the power button until the startup options appear, then press Command-D. On Intel, hold D while it starts.\n5. Safe Mode: on Apple silicon, hold the power button until the options appear, select the disk, then hold Shift and choose \"Continue in Safe Mode\". On Intel, hold Shift while it starts.\n6. macOS Recovery: on Apple silicon, hold the power button until Options appears; on Intel, hold Command-R while it starts. From there, Reinstall macOS keeps the tenant's files, but back up first if you can.\n\n## Good to know\n- Write down any reference code Apple Diagnostics shows; Apple Support (1-800-275-2273) will ask for it.\n- Never choose Disk Utility's Erase in Recovery without Apple Support and the tenant's clear OK."
    },
    {
      "id": "magnifiers-reading-machines",
      "title": "Video magnifiers and reading machines — RUBY, TOPAZ, explorē, Eschenbach, SARA, PEARL, OrCam, Envision",
      "platform": "Freedom Scientific",
      "devices": [
        "other",
        "screenReader"
      ],
      "version": "Makers' documentation pages (catalog Oct 2026)",
      "topics": [
        "magnifier",
        "video magnifier",
        "cctv",
        "reading machine",
        "ruby",
        "topaz",
        "explore",
        "sara",
        "pearl",
        "orcam",
        "envision"
      ],
      "sources": [
        {
          "title": "RUBY documentation",
          "url": "https://support.freedomscientific.com/Products/LowVision/RubyProductDocumentation"
        },
        {
          "title": "RUBY 10 guides",
          "url": "https://support.freedomscientific.com/Support/RubyDocumentation/RUBY10Guides"
        },
        {
          "title": "TOPAZ documentation",
          "url": "https://support.freedomscientific.com/Products/LowVision/TopazProductDocumentation"
        },
        {
          "title": "SARA CE documentation",
          "url": "https://support.freedomscientific.com/Products/LowVision/SARADocumentation"
        },
        {
          "title": "PEARL quick start (PDF)",
          "url": "https://support.freedomscientific.com/Content/Documents/Manuals/PEARL/PEARL-Quick-Start-Guide.pdf"
        },
        {
          "title": "explorē 8 support",
          "url": "https://www.humanware.com/support/explore-8-handheld-electronic-magnifier/"
        },
        {
          "title": "explorē 12 support",
          "url": "https://www.humanware.com/support/explore-12-portable-video-magnifier/"
        },
        {
          "title": "Eschenbach user manuals",
          "url": "https://eschenbach.com/resource-center/user-manuals.asp"
        },
        {
          "title": "OrCam MyEye 3 user guide",
          "url": "https://orcam.helpjuice.com/myeye-resources/orcam-myeye-3-user-guide"
        },
        {
          "title": "OrCam Read user guide",
          "url": "https://orcam.helpjuice.com/read-resources/2714386-orcam-read-user-guide"
        },
        {
          "title": "Envision Glasses: connect to Wi-Fi",
          "url": "https://support.letsenvision.com/hc/en-us/articles/7604041235217-Connect-to-Wi-Fi"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Read the maker and model on the device and open its manual from the maker's page.\n2. Most \"it stopped working\" calls are power: charge a handheld fully, or check a desktop unit's power cord and switch.\n3. A blank or odd-colored screen on a video magnifier is often a color mode or the zoom set very high: go through its color and zoom buttons with the manual.\n4. Reading machines (SARA, PEARL, OrCam Read) read a page aloud; check the page is flat, well lit and the right way up.\n5. Envision Glasses use Wi-Fi: follow Envision's Wi-Fi page.\n6. For repairs, call the maker (Freedom Scientific 727-803-8600 for hardware; HumanWare 1-800-722-3393; Eschenbach 800-487-5389; OrCam 1-800-713-3741).\n\n## Good to know\n- Write the model and serial on the ticket; makers ask for them first."
    },
    {
      "id": "microsoft-account-recovery",
      "title": "Microsoft account — can't sign in, forgotten password, the recovery form",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "phone",
        "other"
      ],
      "version": "Microsoft account pages (Oct 2026)",
      "topics": [
        "account",
        "password",
        "forgot password",
        "sign in",
        "recovery",
        "two-step",
        "outlook.com"
      ],
      "sources": [
        {
          "title": "I can't sign in to my Microsoft account",
          "url": "https://support.microsoft.com/en-us/accounts-billing/manage/i-can-t-sign-in-to-my-microsoft-account"
        },
        {
          "title": "Reset a forgotten Microsoft account password",
          "url": "https://support.microsoft.com/en-us/accounts-billing/manage/reset-a-forgotten-microsoft-account-password"
        },
        {
          "title": "Help with the Microsoft account recovery form",
          "url": "https://support.microsoft.com/en-us/accounts-billing/manage/help-with-the-microsoft-account-recovery-form"
        },
        {
          "title": "Two-step verification",
          "url": "https://support.microsoft.com/help/12408"
        },
        {
          "title": "Protect yourself from phishing",
          "url": "https://support.microsoft.com/en-us/security/protect-yourself-from-phishing"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Check the email address is spelled right and Caps Lock is off.\n2. Use \"Forgot password\" and have the code sent to the tenant's own phone or other email; the tenant reads and types the code themselves.\n3. If none of those still work, fill in the recovery form from a device the tenant has used before, with as much detail as they remember.\n4. Once in, check the recovery phone and email are current, and turn on two-step verification if the tenant agrees.\n\n## Good to know\n- Never write down, keep or type the tenant's password for them; the close-out boundary checklist says so.\n- Microsoft never asks for a password or a code by phone, text or email."
    },
    {
      "id": "narrator-start-basics",
      "title": "Narrator on Windows — turn it on (Windows key + Ctrl + Enter) and the first keys",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10 (Narrator guide Aug 2026)",
      "topics": [
        "screen reader",
        "narrator",
        "turn on",
        "turn off",
        "keys",
        "scan mode"
      ],
      "sources": [
        {
          "title": "Chapter 1, Introducing Narrator",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/chapter-1-introducing-narrator"
        },
        {
          "title": "Chapter 2, Narrator basics",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/chapter-2-narrator-basics"
        },
        {
          "title": "Chapter 3, Using scan mode",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/chapter-3-using-scan-mode"
        },
        {
          "title": "Appendix B, all Narrator keyboard commands and touch gestures",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/appendix-b-narrator-keyboard-commands-and-touch-gestures"
        },
        {
          "title": "Complete guide to Narrator",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/complete-guide-to-narrator"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Press the Windows logo key + Ctrl + Enter to turn Narrator on; press it again to turn it off.\n2. The \"Narrator key\" is Caps Lock or Insert; Narrator commands use it.\n3. Press Ctrl to stop Narrator talking.\n4. Press Narrator key + Space Bar to turn scan mode on or off. In scan mode, the Up and Down arrows read line by line and H jumps to the next heading.\n5. Press Narrator key + F1 to hear the list of commands.\n6. Open Narrator's settings (Settings, then Accessibility, then Narrator) to change the voice and speed.\n\n## Good to know\n- \"My computer is reading everything aloud\": Narrator is on; Windows logo key + Ctrl + Enter turns it off.\n- Microsoft's Disability Answer Desk helps free: 1-800-936-5900."
    },
    {
      "id": "narrator-web-outlook",
      "title": "Narrator — reading a web page in Edge and email in Outlook",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "Windows 11 24H2/25H2; Outlook (Microsoft pages Aug–Sep 2026)",
      "topics": [
        "screen reader",
        "narrator",
        "web page",
        "edge",
        "email",
        "outlook",
        "read aloud"
      ],
      "sources": [
        {
          "title": "Chapter 3, Using scan mode",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/chapter-3-using-scan-mode"
        },
        {
          "title": "Chapter 4, Reading text",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/chapter-4-reading-text"
        },
        {
          "title": "Appendix E, Narrator with Outlook",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/appendix-e-narrator-with-outlook"
        },
        {
          "title": "Email in Outlook with a screen reader",
          "url": "https://support.microsoft.com/en-us/accessibility/outlook/basic-tasks-using-a-screen-reader-with-email-in-outlook"
        },
        {
          "title": "Outlook keyboard shortcuts",
          "url": "https://support.microsoft.com/en-us/accessibility/outlook/keyboard-shortcuts-for-outlook"
        },
        {
          "title": "Edge Reading mode and Read aloud",
          "url": "https://support.microsoft.com/en-us/edge/use-immersive-reader-in-microsoft-edge"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Web page: open it in Edge; scan mode should be on (Narrator key + Space Bar switches it). Use the Down arrow to read, H for the next heading, Tab for the next link.\n2. For a cleaner page, Edge's Read aloud reads the article without the clutter (F9 opens reading mode where it is offered).\n3. Email: open Outlook; use the Up and Down arrows in the message list, and Enter to open a message.\n4. Ctrl+N starts a new message, Ctrl+R replies; Ctrl+Enter sends (Outlook may ask the first time).\n5. Microsoft's Outlook-with-a-screen-reader page lists the rest of the keys.\n\n## Good to know\n- The Outlook keys are Outlook's own, so they work the same with JAWS and NVDA."
    },
    {
      "id": "nls-braille-ereader",
      "title": "NLS braille eReader (HumanWare or Zoomax) — Wi-Fi, BARD, pairing with an iPhone",
      "platform": "NLS",
      "devices": [
        "other",
        "screenReader",
        "internet",
        "phone"
      ],
      "version": "NLS eReader guides and FAQ (catalog Oct 2026)",
      "topics": [
        "braille",
        "braille ereader",
        "nls",
        "bard",
        "wi-fi",
        "humanware",
        "zoomax",
        "pair iphone"
      ],
      "sources": [
        {
          "title": "NLS braille eReader (HumanWare) user guide",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/nls-braille-ereader-humanware-user-guide/"
        },
        {
          "title": "NLS braille eReader (HumanWare) FAQ",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/nls-braille-ereader-humanware-frequently-asked-questions/"
        },
        {
          "title": "NLS braille eReader (Zoomax) user guide",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/nls-braille-ereader-zoomax-user-guide/"
        },
        {
          "title": "Equipment for NLS materials",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Read the label to see whether the eReader is the HumanWare or the Zoomax model; open the NLS guide for that one.\n2. The tenant opens the eReader's Wi-Fi settings (the guide gives the keys); the tech reads the guide aloud and gives the Wi-Fi name and password letter by letter.\n3. Once on Wi-Fi and linked to the tenant's BARD account, braille books come straight to the eReader.\n4. It can also be a braille display for an iPhone: pair it in Settings, Accessibility, VoiceOver, Braille (see the iPhone braille display entry).\n5. The HumanWare eReader does not work with Android phones or Chromebooks.\n\n## Good to know\n- NLS lends it free; the library replaces it if it is broken."
    },
    {
      "id": "nls-da2-wifi",
      "title": "NLS DA2 talking-book player — turn on Wi-Fi and get books from BARD",
      "platform": "NLS",
      "devices": [
        "other",
        "internet"
      ],
      "version": "DA2 User Guide (Aug 2026)",
      "topics": [
        "talking books",
        "da2",
        "wi-fi",
        "bard",
        "wifi_config.txt",
        "usb drive"
      ],
      "sources": [
        {
          "title": "DA2 User Guide (Wi-Fi, BARD)",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/da2-user-guide/"
        },
        {
          "title": "DA2 Getting Started",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/da2-getting-started/"
        },
        {
          "title": "BARD FAQ",
          "url": "https://www.loc.gov/nls/how-to-enroll/sign-up-for-bard-and-bard-mobile/nls-bard-2-frequently-asked-questions/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Make sure the tenant has a BARD account with a permanent password (not a temporary one); the library sets this up.\n2. Wi-Fi is off when the DA2 comes out of the box. Press and hold the Info key to open the menu, then go to Settings, then Wi-Fi, and turn it on (the DA2 speaks each choice).\n3. Choose the network and enter the password the way the DA2 guide describes.\n4. Or, easier: on a computer, make a text file named wifi_config.txt on a USB drive, with the Wi-Fi name on line 1 and the password on line 2, and plug the drive into the DA2.\n5. Once connected and linked to BARD, books the tenant picks on BARD come to the player over Wi-Fi.\n\n## Good to know\n- The wifi_config.txt file holds the Wi-Fi password in plain text: with the tenant's OK, remove it from the USB drive once the DA2 is connected.\n- The DA2 guide is the place to check the exact keys; read it aloud with the tenant if needed."
    },
    {
      "id": "nls-talking-book-players-bard",
      "title": "Talking books — which NLS player is it (DS1, DA1, DA2), BARD, and the Heiskell Library",
      "platform": "NLS",
      "devices": [
        "other",
        "phone",
        "tablet"
      ],
      "version": "NLS equipment pages (DA2 guide Aug 2026); BARD 2",
      "topics": [
        "talking books",
        "nls",
        "bard",
        "bard mobile",
        "ds1",
        "da1",
        "da2",
        "cartridge",
        "heiskell",
        "library"
      ],
      "sources": [
        {
          "title": "Equipment for NLS materials (DS1, DA1, DA2, eReaders)",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/"
        },
        {
          "title": "Sign up for BARD and BARD Mobile",
          "url": "https://www.loc.gov/nls/how-to-enroll/sign-up-for-bard-and-bard-mobile/"
        },
        {
          "title": "BARD",
          "url": "https://nlsbard.loc.gov/"
        },
        {
          "title": "BARD FAQ",
          "url": "https://www.loc.gov/nls/how-to-enroll/sign-up-for-bard-and-bard-mobile/nls-bard-2-frequently-asked-questions/"
        },
        {
          "title": "BARD Mobile iOS guide",
          "url": "https://www.loc.gov/nls/how-to-enroll/sign-up-for-bard-and-bard-mobile/bard-mobile-ios-version/"
        },
        {
          "title": "BARD Express user guide (Windows; copy to cartridge)",
          "url": "https://www.loc.gov/nls/how-to-enroll/sign-up-for-bard-and-bard-mobile/bard-express-user-guide/"
        },
        {
          "title": "My Talking Books (Alexa)",
          "url": "https://www.loc.gov/nls/how-to-enroll/sign-up-for-bard-and-bard-mobile/welcome-to-my-talking-books/"
        },
        {
          "title": "Heiskell Library (NYPL)",
          "url": "https://www.nypl.org/about/locations/heiskell"
        },
        {
          "title": "Heiskell Library talking-book players",
          "url": "https://www.nypl.org/about/locations/heiskell/digital-player"
        },
        {
          "title": "Heiskell Library BARD",
          "url": "https://www.nypl.org/about/locations/heiskell/bard"
        },
        {
          "title": "Find your library (NLS)",
          "url": "https://www.loc.gov/nls/find-your-library/"
        },
        {
          "title": "NLS patron services (monthly Zoom help sessions)",
          "url": "https://www.loc.gov/nls/services-and-resources/patron-services-and-events/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Read the player's label: DS1, DA1 or DA2.\n2. DS1 and DA1 have no Wi-Fi. Books come on cartridges by mail, or on a USB drive loaded from BARD on a computer (BARD Express on Windows does the copying).\n3. The DA2 is the only NLS player with Wi-Fi, and there are few of them: the tenant asks the library for one (see the DA2 entry to connect it).\n4. BARD (the NLS download site) needs an account from the library; once signed up, the BARD Mobile app plays books on an iPhone, iPad or Android device.\n5. In Manhattan the library is the Andrew Heiskell Braille and Talking Book Library (NYPL), 40 W. 20th St., 212-206-5400. NLS's own line, 888-657-7323, connects to the local library.\n6. For a player that is broken, the library replaces it; don't open it.\n\n## Good to know\n- Heiskell hours (catalog): Mon/Wed/Fri/Sat 10–5; Tue/Thu 12–7. NLS line: Mon–Fri 9:30–4 ET.\n- NLS holds free monthly Zoom help sessions for patrons; \"My Talking Books\" plays NLS books on an Alexa speaker."
    },
    {
      "id": "nvda-magnifier",
      "title": "NVDA — the built-in Magnifier (new in NVDA 2026.2)",
      "platform": "NV Access",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "NVDA 2026.2 (31 Aug 2026)",
      "topics": [
        "easier to see",
        "nvda",
        "magnifier",
        "zoom"
      ],
      "sources": [
        {
          "title": "NVDA 2026.2 release (built-in Magnifier)",
          "url": "https://www.nvaccess.org/post/nvda-2026-2/"
        },
        {
          "title": "NVDA User Guide (2026.2)",
          "url": "https://download.nvaccess.org/documentation/userGuide.html"
        },
        {
          "title": "NVDA Commands Quick Reference (2026.2)",
          "url": "https://download.nvaccess.org/documentation/keyCommands.html"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "low",
      "body": "## Steps\n1. Check the NVDA version: open the NVDA menu with NVDA+N, then Help, then About. The Magnifier needs 2026.2 or later.\n2. If it is older, download the current NVDA from NV Access (free) and install it over the old one.\n3. Look up the Magnifier's commands in the 2026.2 Commands Quick Reference before you teach them; this entry does not name them because they were new on the catalog date.\n4. For a person who needs magnification all day, Windows Magnifier (Windows logo key + Plus) also works alongside NVDA.\n\n## Good to know\n- Low confidence: the Magnifier's keys were not in the catalog. A person should read them in the Quick Reference, add them here, and mark this entry checked."
    },
    {
      "id": "nvda-start-basics",
      "title": "NVDA — start it, stop speech, and the first keys",
      "platform": "NV Access",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "NVDA 2026.2 (31 Aug 2026)",
      "topics": [
        "screen reader",
        "nvda",
        "start",
        "keys",
        "say all",
        "free"
      ],
      "sources": [
        {
          "title": "NVDA Commands Quick Reference (2026.2)",
          "url": "https://download.nvaccess.org/documentation/keyCommands.html"
        },
        {
          "title": "NVDA User Guide (2026.2)",
          "url": "https://download.nvaccess.org/documentation/userGuide.html"
        },
        {
          "title": "Download NVDA",
          "url": "https://www.nvaccess.org/download/"
        },
        {
          "title": "NVDA 2026.2 release",
          "url": "https://www.nvaccess.org/post/nvda-2026-2/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Start NVDA with Ctrl+Alt+N (the shortcut its installer sets up), or from the Start menu.\n2. The \"NVDA key\" is Insert (Caps Lock can be chosen too, with the laptop layout).\n3. Press Ctrl to stop speech.\n4. NVDA + Down Arrow reads everything from the current spot (desktop layout).\n5. NVDA + N opens the NVDA menu (settings, help, exit); NVDA + Q closes NVDA.\n6. NVDA + 1 turns on input help: each key says what it does without doing it. Press NVDA + 1 again to leave.\n7. In 2026.2, NVDA + X repeats the last thing NVDA said.\n\n## Good to know\n- NVDA and its User Guide are free; NV Access's training and phone support are paid."
    },
    {
      "id": "nvda-web-email",
      "title": "NVDA — reading a web page and email",
      "platform": "NV Access",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "NVDA 2026.2; Outlook (catalog Oct 2026)",
      "topics": [
        "screen reader",
        "nvda",
        "web page",
        "browse mode",
        "headings",
        "links",
        "email",
        "outlook"
      ],
      "sources": [
        {
          "title": "NVDA Commands Quick Reference (2026.2)",
          "url": "https://download.nvaccess.org/documentation/keyCommands.html"
        },
        {
          "title": "NVDA User Guide (2026.2)",
          "url": "https://download.nvaccess.org/documentation/userGuide.html"
        },
        {
          "title": "Email in Outlook with a screen reader",
          "url": "https://support.microsoft.com/en-us/accessibility/outlook/basic-tasks-using-a-screen-reader-with-email-in-outlook"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Web pages open in browse mode: the arrows read line by line, H jumps to the next heading and K to the next link.\n2. NVDA + F7 lists the links, headings and landmarks of the page; choose one and press Enter.\n3. NVDA + Space switches between browse mode and focus mode (focus mode is for typing into boxes; NVDA usually switches by itself).\n4. Email in Outlook: Up and Down arrows move through the messages; Enter opens one; NVDA + Down Arrow reads it.\n5. Ctrl+N starts a new message, Ctrl+R replies, Ctrl+Enter sends.\n\n## Good to know\n- If typing in a web form makes NVDA jump around instead of typing, it is in browse mode: NVDA + Space."
    },
    {
      "id": "outlook-email-not-sending",
      "title": "Outlook.com — can't send or receive email",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "phone",
        "tablet"
      ],
      "version": "Outlook.com (Oct 2026; ActiveSync below 16.1 blocked since 1 Mar 2026)",
      "topics": [
        "email",
        "outlook",
        "can't send",
        "can't receive",
        "storage full",
        "mailbox full"
      ],
      "sources": [
        {
          "title": "Can't send or receive email in Outlook.com",
          "url": "https://support.microsoft.com/en-us/outlook/can-t-send-or-receive-email-in-outlook-com"
        },
        {
          "title": "Add your Outlook.com account to another mail app",
          "url": "https://support.microsoft.com/en-us/outlook/add-your-outlook-com-account-to-another-mail-app-or-smart-device"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check the device has internet (open a web page).\n2. Sign in to Outlook.com in a browser: if mail works there, the problem is the app on the device.\n3. Check the mailbox storage: a full mailbox stops email. Help the tenant choose what to remove, with their OK.\n4. Look in the Outbox for a message that is stuck (often a very large attachment) and send it again smaller.\n5. An older phone or mail app may no longer reach Outlook.com (old ActiveSync versions stopped working on 1 Mar 2026): set the account up again in a current mail app, following Microsoft's page.\n\n## Good to know\n- Full storage stops email on Gmail and iCloud too."
    },
    {
      "id": "reliability-android-wifi",
      "title": "Android Wi-Fi connection fails",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "no internet",
        "wifi drops",
        "wi-fi drops",
        "cannot connect"
      ],
      "sources": [
        {
          "title": "Connect to Wi-Fi networks on your Android device › Disconnect Wi-Fi on your device",
          "url": "https://support.google.com/android/answer/9075847?hl=en"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings, then Network & internet → Internet and select the intended network.\n2. Check the Android-version notes before following the connection procedure.\n\n## Good to know\n- Confirm Android version and whether another device connects; menus vary by device.\n- Stop if the network is managed or credentials are unknown; the holder enters credentials personally."
    },
    {
      "id": "reliability-apple-account",
      "title": "Apple Account recovery",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "forgot",
        "recover",
        "cant sign in",
        "cannot sign in"
      ],
      "sources": [
        {
          "title": "If you forgot your password and can&rsquo;t sign in to your Apple Account › Choose \"Forgot Password?\" and follow the onscreen instructions",
          "url": "https://support.apple.com/en-us/102656"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. The holder chooses Forgot Password and follows Apple’s onscreen instructions.\n2. Review Apple’s recovery-request cancellation warning before using another signed-in device.\n\n## Good to know\n- The account holder performs recovery personally. The tech never collects passwords or security codes.\n- Account recovery can require a waiting period; avoid activity that cancels the request."
    },
    {
      "id": "reliability-apple-mail",
      "title": "iPhone Mail will not send",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "email not sending",
        "cant send email",
        "cannot send email",
        "outbox"
      ],
      "sources": [
        {
          "title": "If you can&rsquo;t send email on your iPhone or iPad › Check the Outbox for unsent email",
          "url": "https://support.apple.com/en-us/102556"
        },
        {
          "title": "If iCloud Mail isn't working › If you can't send or receive mail from the Mail app on your Mac › Check your device and account settings",
          "url": "https://support.apple.com/en-us/102562"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. If Outbox is present: In Mail’s mailbox list, open Outbox and check the unsent message.\n2. For the unsent message: Check the recipient address, then try sending the message again.\n3. For an iCloud account: For iCloud Mail, check account storage and system status before changing the account.\n\n## Good to know\n- Confirm which account/provider fails and whether Mail reports an error; the holder checks account access.\n- If account checks fail, contact the mail provider. Never ask the tech to collect credentials."
    },
    {
      "id": "reliability-brother-new-router",
      "title": "Brother after a new router",
      "platform": "Brother",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "new router",
        "router changed",
        "changed router"
      ],
      "sources": [
        {
          "title": "FAQs & Troubleshooting › My Brother machine cannot be used after the access point/router is replaced or the settings are changed",
          "url": "https://support.brother.com/g/b/faqend.aspx?c=us&lang=en&prod=hl2270dw_all&ftype3=2039&faqid=faq00100014_000"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Reconnect the Brother machine to the new wireless network.\n2. Use the linked manual or automatic wireless configuration procedure for the matching model.\n\n## Good to know\n- The cited page is for HL-2270DW. Use the model’s actual wireless setup instructions.\n- Stop if the model differs or the holder does not have network access; do not guess button sequences."
    },
    {
      "id": "reliability-brother-offline",
      "title": "Brother printer offline or paused",
      "platform": "Brother",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "offline",
        "paused",
        "not printing",
        "wont print"
      ],
      "sources": [
        {
          "title": "FAQs & Troubleshooting › The printer status is Offline or Paused. › STEP A: Verify the Brother machine is powered on and there are no errors",
          "url": "https://support.brother.com/g/b/faqend.aspx?c=us&faqid=faq00002646_009&ftype3=1972&lang=en&prod=mfc9130cw_us"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check power and LCD error messages first.\n2. Choose the actual connection type: Check the cable directly to the computer, or the Ethernet/wireless network configuration page.\n3. After the physical connection checks: Clear the applicable offline or paused state.\n\n## Good to know\n- The cited FAQ covers the MFC-9130CW. Check the exact model and operating system.\n- Stop for a power or LCD hardware error; follow Brother’s hardware help instead."
    },
    {
      "id": "reliability-canon-offline",
      "title": "Canon TS3700 offline",
      "platform": "Canon",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "offline",
        "not printing",
        "wont print"
      ],
      "sources": [
        {
          "title": "Change to Offline ( Windows )",
          "url": "https://ij.manual.canon/ij/webmanual/Manual/All/TS3700%20series/EN/NTR/ntr_t_03_17.html"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Choose the actual connection type: Check the USB or Wi-Fi connection and power-cycle the printer.\n2. If still offline: Check the printer and MP Drivers names match.\n3. If still offline: Follow the matching Windows branch to clear Use Printer Offline.\n\n## Good to know\n- Confirm TS3700-series applicability, Windows version and USB versus Wi-Fi connection.\n- Stop if the driver/model does not match; use Canon’s matching model manual."
    },
    {
      "id": "reliability-epson-new-router",
      "title": "Epson after a new router",
      "platform": "Epson",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "new router",
        "router changed",
        "changed router"
      ],
      "sources": [
        {
          "title": "Connecting to a New Wi-Fi Router",
          "url": "https://files.support.epson.com/docid/cpd4/cpd41557/source/printers/source/networking/tasks/switching_router.html"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Update the printer’s Wi-Fi connection for the new router.\n2. Follow Epson’s operating-system branch to install software and set up the wireless connection.\n\n## Good to know\n- Confirm the model’s network setup guide and Windows versus Mac; the holder supplies new network credentials.\n- Stop if model setup instructions differ; do not reset the whole device."
    },
    {
      "id": "reliability-epson-offline",
      "title": "Epson ET-2850 offline",
      "platform": "Epson",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "offline",
        "not printing",
        "wont print"
      ],
      "sources": [
        {
          "title": "I see the message Printer is Offline when I try to print with a wireless connection in Windows. What should I do?",
          "url": "https://epson.com/faq/SPT_C11CJ63202~faq-0000493-et2850?faq_cat=faq-topFaqs"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. For the matching Windows wireless setup: Clear Use Printer Offline in the print queue.\n2. Check the printer’s Wi-Fi indicator and follow the matching connected/disconnected branch.\n3. If the restart checks do not resolve it, contact Epson Support.\n\n## Good to know\n- This cited FAQ is for ET-2850 with wireless Windows printing; use the exact model’s page for other printers.\n- If safe checks fail, contact Epson. Do not silently disable firewalls or reset saved network settings."
    },
    {
      "id": "reliability-gmail-sync",
      "title": "Gmail stops sending or syncing",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "not sending",
        "not syncing",
        "cant send",
        "cannot send"
      ],
      "sources": [
        {
          "title": "Check your Google Account storage",
          "url": "https://support.google.com/mail/answer/6383854?visit_id=639272813946048584-1681127657&rd=1"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check Google Account storage when Gmail stops syncing.\n2. Check Gmail sync settings for the matching device.\n\n## Good to know\n- Confirm Gmail account access, available storage and device; distinguish mobile sync from server delivery.\n- Stop before clearing local app data; the holder checks their account, not the tech."
    },
    {
      "id": "reliability-google-account",
      "title": "Google Account recovery",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "forgot",
        "recover",
        "cant sign in",
        "cannot sign in"
      ],
      "sources": [
        {
          "title": "How to recover your Google Account or Gmail › Forgot your password",
          "url": "https://support.google.com/accounts/answer/7682439?hl=en"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Google’s account recovery instructions with the account holder.\n2. If the account is managed: For a work or school account, check with the administrator.\n\n## Good to know\n- The holder performs recovery on Google’s own page. Work/school accounts may need the administrator.\n- Never collect passwords, codes or recovery answers; stop if it is an organisation-managed account."
    },
    {
      "id": "reliability-hp-offline",
      "title": "HP printer offline",
      "platform": "HP",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "offline",
        "not printing",
        "wont print"
      ],
      "sources": [
        {
          "title": "Option 1: Run HP Print and Scan Doctor",
          "url": "https://www.hp.com/us-en/tech-takes/printers/troubleshooting/why-is-my-hp-printer-offline.html"
        },
        {
          "title": "Printer offline",
          "url": "https://support.hp.com/us-en/help/printer/printer-offline#hpProductContextPageTitle"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. For supported Windows or Mac: Open the HP app and run Diagnose & Fix.\n2. Follow the app’s onscreen checks: On Windows choose the wrench icon; on Mac use the printer dropdown.\n\n## Good to know\n- Confirm printer model, power/error state, operating system and connection type.\n- Stop if the app does not support this operating system or the printer reports a hardware error."
    },
    {
      "id": "reliability-iphone-storage",
      "title": "iPhone storage full",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "storage full",
        "out of space",
        "no storage"
      ],
      "sources": [
        {
          "title": "How to check the storage on your iPhone and iPad › Use the Finder, the Apple Devices app, or iTunes to check the storage on your device › If storage on your device differs from what you see in the Finder, Apple Devices app, or iTunes",
          "url": "https://support.apple.com/en-us/108429"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings → General → [device] Storage to review usage and recommendations.\n2. Tap an app’s name to inspect its storage before deciding what to change.\n\n## Good to know\n- Distinguish device storage from iCloud storage. Review each recommendation with the holder before removing anything.\n- Stop before deleting personal photos or app data; no automatic deletion."
    },
    {
      "id": "reliability-iphone-wifi",
      "title": "iPhone Wi-Fi connection fails",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "no internet",
        "wifi drops",
        "wi-fi drops",
        "cannot connect"
      ],
      "sources": [
        {
          "title": "If you can't connect to Wi-Fi on your iPhone or iPad › Uninstall VPN and security software",
          "url": "https://support.apple.com/en-us/111786"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Use Apple’s connection checks for the intended Wi-Fi network.\n2. Check the router connection before attempting device configuration changes.\n\n## Good to know\n- Confirm other devices, network name and device version; the account holder enters any password.\n- Stop before resetting network settings; a failed connection is not proof of a router fault."
    },
    {
      "id": "reliability-isp-stacked-routers",
      "title": "Slow internet behind the provider router",
      "platform": "NETGEAR",
      "devices": [
        "internet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "slow",
        "behind",
        "double nat",
        "stacked"
      ],
      "sources": [
        {
          "title": "What is double NAT and why is it bad?",
          "url": "https://kb.netgear.com/30186/What-is-Double-NAT"
        },
        {
          "title": "Test your internet speed › Understanding your speed test results › Why is my Wi-Fi slow?",
          "url": "https://www.verizon.com/speedtest/"
        },
        {
          "title": "How do I fix problems caused by my NETGEAR Orbi or Nighthawk router connected to an ISP gateway? › Your Orbi or Nighthawk router is connected to an ISP gateway.",
          "url": "https://kb.netgear.com/30187/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check whether there are two routers doing network address translation.\n2. Compare Wi-Fi and a wired Ethernet connection on the same device.\n3. If both devices are routers: For an ISP gateway, check its supported bridge mode; NETGEAR describes AP mode as the alternative.\n4. Before changing modes: Check which router features are disabled before choosing AP mode.\n\n## Good to know\n- Confirm both boxes are routers; a modem alone does not establish double NAT. Identify Fios versus Verizon Internet Gateway and any TV service before changing topology.\n- Stop before a topology change until the account holder and provider confirm the applicable procedure. Compare measurements; do not assume double NAT explains slow speed."
    },
    {
      "id": "reliability-magnifier-stuck",
      "title": "Windows Magnifier is stuck",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "magnifier stuck",
        "zoom stuck",
        "close magnifier",
        "turn off magnifier"
      ],
      "sources": [
        {
          "title": "Windows keyboard shortcuts for accessibility › Magnifier keyboard shortcuts",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/windows-keyboard-shortcuts-for-accessibility#magnifier-keyboard-shortcuts-1"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Press Windows key+Esc to turn Magnifier off.\n2. If it keeps starting: Use Windows key+Ctrl+M to inspect Magnifier settings.\n\n## Good to know\n- Confirm this is Windows Magnifier rather than browser zoom or another magnifier.\n- If it is another application, use that application’s guide instead."
    },
    {
      "id": "reliability-netgear-ap",
      "title": "NETGEAR access point mode",
      "platform": "NETGEAR",
      "devices": [
        "internet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "ap mode",
        "access point"
      ],
      "sources": [
        {
          "title": "How do I change my NETGEAR router to AP mode?",
          "url": "https://kb.netgear.com/20927/How-do-I-change-my-NETGEAR-router-to-AP-mode"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. For the matching model: Select ADVANCED → Advanced Setup → Wireless AP. Pro Gaming models use Settings → Setup → Wireless AP.\n2. After confirming the model: Select AP Mode; dynamically assigned addresses are the default.\n3. Review the address change before applying; reconnect to the new address afterwards.\n\n## Good to know\n- Identify the model; Orbi has a separate procedure. The holder signs in personally, with consent to disconnect devices.\n- Stop if the exact model menus differ; keep the existing router working and use the model manual."
    },
    {
      "id": "reliability-nvda-silent",
      "title": "NVDA speech is silent",
      "platform": "NV Access",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "silent",
        "no speech",
        "not talking",
        "stopped talking"
      ],
      "sources": [
        {
          "title": "NVDA 2026.2 User Guide › Using NVDA › Speech modes",
          "url": "https://download.nvaccess.org/documentation/userGuide.html#SpeechModes"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check the speech mode; Talk is the normal speaking mode.\n2. Check whether speech is in Off mode before treating it as a hardware fault.\n\n## Good to know\n- Confirm NVDA is running and which speech mode is selected; check system audio separately.\n- Stop if keys differ from the selected keyboard layout; use the actual NVDA guide."
    },
    {
      "id": "reliability-verizon-passthrough",
      "title": "Verizon Internet Gateway passthrough",
      "platform": "Verizon",
      "devices": [
        "internet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "bridge",
        "passthrough",
        "own router"
      ],
      "sources": [
        {
          "title": "Verizon Internet Gateway Configure IP Passthrough / Bridge Mode › Before you begin",
          "url": "https://www.verizon.com/support/knowledge-base-301824/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Before enabling passthrough: Check the consequences: Wi-Fi radios turn off, passthrough uses LAN2, and Wi-Fi/LAN1 lose internet.\n2. Only for the matching gateway: Use the gateway article for its IP Passthrough checkbox and Save Changes.\n\n## Good to know\n- This is the Verizon Internet Gateway article, not a generic Fios procedure. Obtain permission to interrupt service.\n- Stop if the gateway model differs; Wi-Fi and LAN1 internet become unavailable. Follow the maker rollback procedure with the holder."
    },
    {
      "id": "reliability-voiceover-silent",
      "title": "iPhone VoiceOver speech is silent",
      "platform": "Apple",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "voiceover silent",
        "voiceover stopped talking",
        "voiceover not talking",
        "voiceover no speech"
      ],
      "sources": [
        {
          "title": "Use VoiceOver gestures on iPhone › Use gestures to control VoiceOver",
          "url": "https://support.apple.com/guide/iphone/use-voiceover-gestures-iph3e2e2281/ios"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. With VoiceOver on, use the three-finger double tap to toggle mute; with Zoom also on, use the three-finger triple tap.\n\n## Good to know\n- Confirm VoiceOver is already enabled and whether Zoom is enabled; the gesture differs with Zoom.\n- Stop if the device is not an iPhone/iPad; use its actual VoiceOver guide."
    },
    {
      "id": "reliability-windows-no-internet",
      "title": "Windows cannot connect to Wi-Fi",
      "platform": "Microsoft",
      "devices": [
        "internet"
      ],
      "version": "Manufacturer passages checked 12 Oct 2026",
      "topics": [
        "no internet",
        "wifi drops",
        "wi-fi drops",
        "cannot connect",
        "cant connect"
      ],
      "sources": [
        {
          "title": "Connect to a Wi-Fi network in Windows › Connect to a Wi-Fi network",
          "url": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/connect-to-a-wi-fi-network-in-windows#connect-to-a-wi-fi-network"
        },
        {
          "title": "Fix Wi-Fi connection issues in Windows › Run the Network troubleshooter",
          "url": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/fix-wi-fi-connection-issues-in-windows#run-the-network-troubleshooter"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open quick settings, select Manage Wi-Fi connections, choose the intended network and Connect.\n2. If the connection still fails: Run the Windows network troubleshooter for the matching version.\n\n## Good to know\n- Confirm Windows version and whether other devices also fail; use safe checks before network changes.\n- Stop before any network reset or administrator configuration change; contact the provider if all devices fail."
    },
    {
      "id": "romeo-juliet-embossers",
      "title": "Romeo 60 and Juliet 120 embossers — where help comes from (HumanWare)",
      "platform": "HumanWare",
      "devices": [
        "printer"
      ],
      "version": "Juliet 120 / Romeo 60 manual (2024); HumanWare support page May 2026",
      "topics": [
        "braille printer",
        "embosser",
        "romeo",
        "juliet",
        "enabling technologies",
        "wi-fi"
      ],
      "sources": [
        {
          "title": "HumanWare support for Enabling Technologies embossers",
          "url": "https://www.humanware.com/support/enabling_technologies_embossers"
        },
        {
          "title": "Juliet 120 / Romeo 60 manual (PDF)",
          "url": "https://humanware.com/wp-content/uploads/2024/11/2024-09-18-Manual-Juliet-120-Romeo-60_EN.pdf"
        },
        {
          "title": "Wi-Fi setup with the configuration file (PDF)",
          "url": "https://www.humanware.com/wp-content/uploads/2024/11/Installing-the-Embosser-on-a-Wi-fi-Network-Using-the-Configuration-File.pdf"
        },
        {
          "title": "ETC firmware version 3 release notes, board 1366 only (PDF)",
          "url": "https://www.humanware.com/wp-content/uploads/2026/04/ETC-Firmware-version-3-Release-notes-1366-Only.pdf"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Read the label to confirm it says Romeo 60 or Juliet 120 (the current Enabling Technologies models).\n2. Use HumanWare's support page for these embossers for the manual, drivers and firmware.\n3. Network address: HELP+10 speaks it and HELP+1 prints the network page, as on Index embossers.\n4. Wi-Fi: follow HumanWare's PDF that sets up Wi-Fi with a configuration file.\n5. Firmware version 3 is for board 1366 only: read its release notes before loading it, and never turn the embosser off during an update.\n\n## Good to know\n- HumanWare's line: 1-800-722-3393."
    },
    {
      "id": "samsung-factory-reset",
      "title": "Samsung Galaxy — back up with Smart Switch, then factory reset (last resort)",
      "platform": "Samsung",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "One UI (Samsung pages Oct 2026)",
      "topics": [
        "samsung",
        "factory reset",
        "smart switch",
        "backup",
        "new phone"
      ],
      "sources": [
        {
          "title": "Smart Switch",
          "url": "https://www.samsung.com/us/support/answer/ANS00062998"
        },
        {
          "title": "Factory reset a Galaxy",
          "url": "https://www.samsung.com/us/support/answer/ANS10002030/"
        },
        {
          "title": "Factory reset your Android device",
          "url": "https://support.google.com/android/answer/6088915"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "medium",
      "body": "## Steps\n1. Back up the phone with Smart Switch (to a computer or another phone) or the tenant's accounts.\n2. Make sure the tenant knows the Google account password, and the Samsung account password if one is on the phone.\n3. Don't reset within 24 hours of changing the Google password.\n4. ⚠ This erases everything on the phone: factory reset (Samsung's page) only with the tenant's clear OK, then restore with Smart Switch.\n\n## Good to know\n- Smart Switch also moves everything to a new Galaxy phone."
    },
    {
      "id": "samsung-restart-device-care",
      "title": "Samsung Galaxy — restart, force restart, safe mode, Device Care, updates",
      "platform": "Samsung",
      "devices": [
        "phone",
        "tablet"
      ],
      "version": "One UI (Samsung pages Oct 2026)",
      "topics": [
        "samsung",
        "frozen",
        "restart",
        "force restart",
        "slow",
        "safe mode",
        "device care",
        "update"
      ],
      "sources": [
        {
          "title": "Restart a Galaxy (force restart: Volume down + Side)",
          "url": "https://www.samsung.com/us/support/answer/ANS10001374/"
        },
        {
          "title": "Safe mode on Galaxy",
          "url": "https://www.samsung.com/us/support/answer/ANS10003495/"
        },
        {
          "title": "Device Care",
          "url": "https://www.samsung.com/us/support/answer/ANS10001953"
        },
        {
          "title": "Update a Galaxy",
          "url": "https://www.samsung.com/us/support/answer/ANS10002027/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Frozen: press and hold the Volume down key and the Side key together until the screen goes off and the phone restarts.\n2. Slow or overheating: open Settings, then Device Care (or \"Battery and device care\"), and run its optimize check.\n3. If an app may be the cause, restart in safe mode (Samsung's page), see if the problem goes away, then restart normally.\n4. Update: Settings, Software update, Download and install; use Wi-Fi and a charger.\n\n## Good to know\n- Samsung's line: 1-800-SAMSUNG (726-7864); there is no separate accessibility line."
    },
    {
      "id": "samsung-talkback",
      "title": "Samsung Galaxy — TalkBack (or Voice Assistant on older Galaxy phones)",
      "platform": "Samsung",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "One UI (Samsung pages Jun 2024 and Apr 2026)",
      "topics": [
        "screen reader",
        "talkback",
        "voice assistant",
        "samsung",
        "turn on"
      ],
      "sources": [
        {
          "title": "TalkBack or Voice Assistant on Galaxy",
          "url": "https://www.samsung.com/us/support/answer/ANS10002553/"
        },
        {
          "title": "Accessibility settings on Galaxy",
          "url": "https://www.samsung.com/us/support/answer/ANS10002527/"
        },
        {
          "title": "Accessibility shortcuts on Galaxy",
          "url": "https://www.samsung.com/us/support/answer/ANS10001906/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings, then Accessibility, then TalkBack (older Galaxy phones call it Voice Assistant), and turn it on.\n2. To turn it on and off from the keys, set up an accessibility shortcut (Samsung's shortcuts page shows which keys this model uses).\n3. With TalkBack on, touch to hear, double-tap to press, swipe right and left to move.\n4. TalkBack's own tutorial, in its settings, teaches the rest.\n\n## Good to know\n- Galaxy phones use Google's TalkBack, so Google's TalkBack pages apply too."
    },
    {
      "id": "samsung-visibility-enhancements",
      "title": "Samsung Galaxy — visibility enhancements (high contrast, color inversion, magnification, Magnifier, extra dim)",
      "platform": "Samsung",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "One UI (Samsung pages Jan 2025 – Aug 2026)",
      "topics": [
        "easier to see",
        "high contrast",
        "color inversion",
        "invert colors",
        "magnification",
        "magnifier",
        "extra dim",
        "font size"
      ],
      "sources": [
        {
          "title": "Visibility enhancements on Galaxy (Samsung US)",
          "url": "https://www.samsung.com/us/support/answer/ANS10002540/"
        },
        {
          "title": "Font size, bold and high contrast fonts (Samsung US)",
          "url": "https://www.samsung.com/us/support/answer/ANS10001360/"
        },
        {
          "title": "Accessibility shortcuts (Samsung US)",
          "url": "https://www.samsung.com/us/support/answer/ANS10001906/"
        },
        {
          "title": "Visibility enhancements (Samsung Canada)",
          "url": "https://www.samsung.com/ca/support/mobile-devices/galaxy-phone-visibility-enhancements/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings, then Accessibility, then the visibility (or \"vision\") enhancements section.\n2. Turn on high contrast fonts, or the high contrast theme, so text stands out.\n3. Turn on color inversion for light text on a dark screen.\n4. Turn on Magnification and choose its shortcut; turn on the Magnifier to use the camera as a magnifying glass.\n5. Turn on Extra dim if the screen is too bright even at its lowest.\n6. For bigger letters, open Settings, then Display, then font size and style, and move the slider.\n\n## Good to know\n- Samsung's accessibility shortcuts page shows how to turn any of these on and off with the side and volume keys."
    },
    {
      "id": "slow-dropping-wifi",
      "title": "Slow or dropping Wi-Fi — placement, restart, extenders, and the provider's speed test",
      "platform": "Verizon",
      "devices": [
        "internet"
      ],
      "version": "Verizon, Spectrum, Apple and Microsoft pages (Jul–Sep 2026)",
      "topics": [
        "internet",
        "slow",
        "wi-fi",
        "dropping",
        "extender",
        "pods",
        "speed test"
      ],
      "sources": [
        {
          "title": "Slow or dropping Wi-Fi (Verizon)",
          "url": "https://www.verizon.com/support/residential/internet/connectivity/wi-fi"
        },
        {
          "title": "Verizon speed test",
          "url": "https://www.verizon.com/speedtest/"
        },
        {
          "title": "Spectrum speed test",
          "url": "https://www.spectrum.com/internet/speed-test"
        },
        {
          "title": "Spectrum router and modem quick fixes",
          "url": "https://www.spectrum.com/resources/internet-wifi/modem-troubleshooting-slow-dropped-connections"
        },
        {
          "title": "Why is my internet connection so slow (Windows)",
          "url": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/why-is-my-internet-connection-so-slow"
        },
        {
          "title": "Recommended settings for Wi-Fi routers (Apple)",
          "url": "https://support.apple.com/en-us/102766"
        },
        {
          "title": "Fios Extender E3200",
          "url": "https://www.verizon.com/support/residential/internet/equipment/network-extender/fios-extender"
        },
        {
          "title": "Spectrum WiFi 7 extenders",
          "url": "https://corporate.charter.com/newsroom/spectrum-launches-wifi-7-extenders-for-whole-home-connectivity"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Test close to the router: if it is fast there and slow in the far room, it is distance or walls, not the service.\n2. Move the router into the open, off the floor, away from metal and the microwave, if the tenant agrees.\n3. Restart the modem and router by unplugging them for a full minute.\n4. Run the provider's own speed test on the tenant's device near the router (Spectrum or Verizon), and the app's Internet check on the same device.\n5. Provider much faster than this device: the Wi-Fi or the device is the problem. Both slow: check for an outage and call the provider.\n6. If the far room stays weak, ask the provider about an extender: Spectrum's extenders pair by themselves; Verizon's Fios Extender is managed in the Verizon Home app.\n\n## Good to know\n- Spectrum's extenders cost extra each month; the tenant decides, not the tech."
    },
    {
      "id": "speakers-tv-wifi",
      "title": "Smart speakers and TV boxes — Google speaker, HomePod, Apple TV, Roku can't connect",
      "platform": "Google",
      "devices": [
        "speaker",
        "tv",
        "internet"
      ],
      "version": "Google Nest, HomePod, Apple TV and Roku pages (Oct 2026); Amazon Echo pages not read",
      "topics": [
        "internet",
        "wi-fi",
        "smart speaker",
        "homepod",
        "apple tv",
        "roku",
        "tv"
      ],
      "sources": [
        {
          "title": "Google smart speaker Wi-Fi",
          "url": "https://support.google.com/googlenest/answer/7212129?hl=en"
        },
        {
          "title": "HomePod says \"No Internet\"",
          "url": "https://support.apple.com/en-us/122539"
        },
        {
          "title": "Apple TV can't connect",
          "url": "https://support.apple.com/en-us/102346"
        },
        {
          "title": "Roku won't connect (error codes)",
          "url": "https://support.roku.com/article/21332781083287"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Check that other devices in the apartment have internet. If none do, restart the modem and router first.\n2. Unplug the speaker or TV box for a full minute and plug it back in.\n3. If the Wi-Fi name or password changed, set the device up on the new network with its own app (Google Home for a Google speaker, the Home app for a HomePod, Settings on the Apple TV or Roku).\n4. On a Roku, write down any error code it shows and look it up on Roku's page.\n\n## Good to know\n- Amazon Echo help pages block automated reading; a person collects them. No Echo steps are in the library yet."
    },
    {
      "id": "spectrum-restart-modem-router",
      "title": "Spectrum — restart the modem and router the right way (unplug, never hold a button)",
      "platform": "Spectrum",
      "devices": [
        "internet"
      ],
      "version": "Spectrum quick-fix page (Sep 2026); Advanced WiFi 7 and older WiFi 5/6 routers",
      "topics": [
        "internet",
        "restart",
        "modem",
        "router",
        "no internet",
        "slow"
      ],
      "sources": [
        {
          "title": "Spectrum router and modem quick fixes",
          "url": "https://www.spectrum.com/resources/internet-wifi/modem-troubleshooting-slow-dropped-connections"
        },
        {
          "title": "Contact Spectrum",
          "url": "https://www.spectrum.com/contact-spectrum"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Find the Spectrum modem and the router (on newer installs they may be one box).\n2. Unplug the power cord from both. Do not press or hold any button.\n3. Wait a full minute.\n4. Plug the modem in first and wait 2 to 5 minutes, until its lights settle.\n5. Then plug the router in and wait a few minutes until its light shows it is online.\n6. Test the internet on one device.\n\n## Good to know\n- Never hold a reset button: that can erase the router's settings, including the Wi-Fi name and password.\n- Spectrum internet support: 888-369-2408, 24/7. Spectrum Disability Support: 844-762-1301."
    },
    {
      "id": "talkback-reading-typing-email",
      "title": "TalkBack on Android — reading controls, typing, web pages and email",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "Android 16; TalkBack 17.0",
      "topics": [
        "screen reader",
        "talkback",
        "reading controls",
        "typing",
        "braille keyboard",
        "web page",
        "email",
        "image descriptions"
      ],
      "sources": [
        {
          "title": "TalkBack menu and reading controls",
          "url": "https://support.google.com/accessibility/android/answer/6007066"
        },
        {
          "title": "Navigate with TalkBack",
          "url": "https://support.google.com/accessibility/android/answer/6006598"
        },
        {
          "title": "TalkBack braille keyboard",
          "url": "https://support.google.com/accessibility/android/answer/9728765"
        },
        {
          "title": "Image descriptions in TalkBack",
          "url": "https://support.google.com/accessibility/android/answer/15341968?hl=en"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "low",
      "body": "## Steps\n1. Typing: double-tap a text box to bring up the keyboard; touch a key to hear it and lift your finger to type it.\n2. Reading controls let the tenant move by word, line, heading or link on a web page or in an email; Google's reading-controls page shows how to change them on this TalkBack version.\n3. On a web page in Chrome, set the reading control to Headings to jump from section to section.\n4. In Gmail, swipe right through the messages, double-tap to open one, and use the TalkBack menu for read-from-top.\n5. For a braille reader, turn on the TalkBack braille keyboard in TalkBack's settings and practise with its tutorial.\n6. TalkBack can describe pictures (image descriptions); Google's page shows where to turn it on.\n\n## Good to know\n- Low confidence: the exact gestures for reading controls and the TalkBack menu vary by phone and TalkBack version. Check them on Google's pages before teaching, and mark this entry checked."
    },
    {
      "id": "talkback-turn-on-gestures",
      "title": "TalkBack on Android — turn it on or off and the first gestures",
      "platform": "Google",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "Android 16; TalkBack 17.0",
      "topics": [
        "screen reader",
        "talkback",
        "turn on",
        "turn off",
        "gestures",
        "volume keys"
      ],
      "sources": [
        {
          "title": "Turn on TalkBack",
          "url": "https://support.google.com/accessibility/android/answer/6007100"
        },
        {
          "title": "TalkBack gestures",
          "url": "https://support.google.com/accessibility/android/answer/6151827?hl=en"
        },
        {
          "title": "Get started with TalkBack",
          "url": "https://support.google.com/accessibility/android/answer/6283677"
        },
        {
          "title": "Accessibility shortcuts (Android)",
          "url": "https://support.google.com/accessibility/android/answer/7650693"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. If the volume-key shortcut is set up, press and hold both volume keys for about 3 seconds to turn TalkBack on or off.\n2. Or ask the phone's assistant: \"Turn on TalkBack\" (or \"Turn off TalkBack\").\n3. Or open Settings, then Accessibility, then TalkBack, and turn on Use TalkBack.\n4. With TalkBack on, touch the screen to hear what is there; double-tap anywhere to press the item it just read.\n5. Swipe right for the next item and left for the previous one; scroll with two fingers.\n6. Open TalkBack's own tutorial in its settings to practise the rest of the gestures safely.\n\n## Good to know\n- \"My phone talks and won't do what I tap\": TalkBack is on; double-tap instead of tapping, or use the volume-key shortcut to turn it off.\n- Gestures for Back, Home and the TalkBack menu differ between phones; read them on Google's gestures page or in the tutorial rather than guessing."
    },
    {
      "id": "verizon-fios-restart-router",
      "title": "Verizon Fios — restart the router (unplug a full minute; never hold the reset button)",
      "platform": "Verizon",
      "devices": [
        "internet"
      ],
      "version": "Verizon Router CR1000A/B and Fios Router G3100 (Verizon pages, Oct 2026)",
      "topics": [
        "internet",
        "restart",
        "router",
        "fios",
        "no internet",
        "reset button"
      ],
      "sources": [
        {
          "title": "Verizon Router FAQs (CR1000A/B)",
          "url": "https://www.verizon.com/support/residential/internet/equipment/routers/verizon-router"
        },
        {
          "title": "Fios router FAQs",
          "url": "https://www.verizon.com/support/residential/internet/equipment/routers/fios-router/"
        },
        {
          "title": "Why is my internet not working (Verizon)",
          "url": "https://www.verizon.com/home/internet/guides/what-is-slowing-my-internet-down/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Find the Verizon router (the CR1000A/B, or the older G3100).\n2. Unplug its power cord. Do not press the reset pinhole on the back.\n3. Wait a full minute.\n4. Plug it back in and wait a few minutes until its light shows it is online.\n5. Test the internet on one device.\n\n## Good to know\n- The reset pinhole: a short press restarts, but about 10 seconds is a factory reset that erases the Wi-Fi name, password and settings (Verizon's own pages disagree on the exact seconds). Unplugging is the safe restart.\n- Verizon's Center for Customers with Disabilities: 800-974-6006 (voice/TTY), Mon–Fri 8:30 AM–5 PM ET."
    },
    {
      "id": "victor-reader-stream-trek",
      "title": "Victor Reader Stream 3 and Trek (HumanWare) — Wi-Fi, BARD authorization, what it can't do",
      "platform": "HumanWare",
      "devices": [
        "other",
        "internet"
      ],
      "version": "HumanWare support pages; Trek user guide (Nov 2024 upload) (catalog Oct 2026)",
      "topics": [
        "talking books",
        "victor reader",
        "stream",
        "trek",
        "wi-fi",
        "bard",
        "humanware"
      ],
      "sources": [
        {
          "title": "Victor Reader Stream 3 support",
          "url": "https://www.humanware.com/support/victor_reader_stream_3/"
        },
        {
          "title": "Victor Reader Stream 3 FAQ",
          "url": "https://www.humanware.com/support-training/victor-reader-stream-3-faq/"
        },
        {
          "title": "Victor Reader Stream 3 training and troubleshooting",
          "url": "https://www.humanware.com/support-training/victor-reader-stream-3-training-and-troubleshooting/"
        },
        {
          "title": "Victor Reader Trek support",
          "url": "https://www.humanware.com/support/victor_reader_trek/"
        },
        {
          "title": "Victor Reader Trek user guide",
          "url": "https://www.humanware.com/wp-content/uploads/2024/11/Victor-Reader-Trek-User-Guide.html"
        },
        {
          "title": "Commercial players compatible with NLS",
          "url": "https://www.loc.gov/nls/services-and-resources/equipment-for-nls-materials/commercial-players-compatible-with-nls-materials-and-additional-products/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Connect the Stream 3 or Trek to the home Wi-Fi from its Wi-Fi settings, as HumanWare's training page shows; have the Wi-Fi password ready.\n2. Networks with a web sign-in page don't work; a home Wi-Fi with a password does.\n3. To get NLS books over Wi-Fi, the player has to be authorized for BARD through HumanWare; it takes about 2 working days.\n4. The Stream 3 does not take NLS cartridges; books come over Wi-Fi or on an SD card or USB.\n5. For a problem, use HumanWare's FAQ and training pages, or call HumanWare, 1-800-722-3393.\n\n## Good to know\n- The Trek also has GPS; its user guide is a web page that a screen reader can read."
    },
    {
      "id": "viewplus-embosser-problems",
      "title": "ViewPlus embosser — only beeps, all four lights, error 50007, jams",
      "platform": "ViewPlus",
      "devices": [
        "printer"
      ],
      "version": "ViewPlus Columbia, Delta, Max, Premier, SpotDot; Tiger software (catalog Oct 2026)",
      "topics": [
        "braille printer",
        "embosser",
        "viewplus",
        "tiger",
        "beeps",
        "error 50007",
        "paper jam"
      ],
      "sources": [
        {
          "title": "ViewPlus manuals",
          "url": "https://viewplus.com/viewplus-support/manuals/"
        },
        {
          "title": "ViewPlus downloads (drivers, firmware, Tiger)",
          "url": "https://viewplus.com/download"
        },
        {
          "title": "ViewPlus knowledge base: \"just beeps\"",
          "url": "https://support.viewplus.com/kb/faq.php?id=347"
        },
        {
          "title": "ViewPlus knowledge base: error 50007",
          "url": "https://support.viewplus.com/kb/faq.php?id=365"
        },
        {
          "title": "ViewPlus support contact",
          "url": "https://support.viewplus.com/kb/faq.php?id=42"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Columbia or Delta only beeps: install the newest ViewPlus driver from the downloads page, update the firmware, restart the computer, and plug the embosser's USB in only after Windows has finished signing in.\n2. All four lights on, or error 50007: check that the carriage lock (shipping) screw has been removed, and reseat the SD card. If it continues, it needs repair.\n3. Paper jam: tear the paper at the nearest perforation on both sides, open the tractor lid, pull the paper out evenly (front, then rear), reload, press Cancel, and send the job again.\n4. Before the embosser is ever shipped for repair, put the shipping screw back in.\n\n## Good to know\n- ViewPlus support: support@viewplus.com, 1-866-836-2184."
    },
    {
      "id": "voiceover-iphone-gestures",
      "title": "VoiceOver on iPhone and iPad — the first gestures and the rotor",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "screen reader",
        "voiceover",
        "gestures",
        "rotor",
        "read all",
        "home screen"
      ],
      "sources": [
        {
          "title": "Use VoiceOver gestures on iPhone",
          "url": "https://support.apple.com/guide/iphone/use-voiceover-gestures-iph3e2e2281/ios"
        },
        {
          "title": "Control VoiceOver using the rotor",
          "url": "https://support.apple.com/guide/iphone/control-voiceover-using-the-rotor-iph3e2e3a6d/ios"
        },
        {
          "title": "Turn on and practice VoiceOver on iPad",
          "url": "https://support.apple.com/guide/ipad/turn-on-and-practice-voiceover-ipad9a246898/ipados"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Touch or drag one finger around the screen: VoiceOver says what is under the finger.\n2. Swipe right with one finger to move to the next item; swipe left for the previous one.\n3. Double-tap anywhere to press the item VoiceOver just read.\n4. Swipe up with two fingers to read the whole screen from the top; swipe down with two fingers to read from the current item.\n5. Tap with two fingers to pause or continue speech.\n6. Swipe up or down with three fingers to scroll a page.\n7. Go home: on iPhones without a Home button, slide one finger up from the bottom edge until you feel a vibration or hear a sound, then lift; on others, press the Home button.\n8. The rotor: turn two fingers on the screen like turning a dial to choose a setting (Headings, Links, Words, Speaking Rate…), then swipe up or down with one finger to use it.\n\n## Good to know\n- Teach one gesture at a time and let the tenant do it; VoiceOver Practice (in the VoiceOver settings) is safe for trying.\n- Apple's in-store session \"Get Started: VoiceOver on iPhone and iPad\" is free."
    },
    {
      "id": "voiceover-iphone-turn-on",
      "title": "VoiceOver on iPhone and iPad — turn it on, turn it off, practise",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "screen reader",
        "voiceover",
        "turn on",
        "turn off",
        "accessibility shortcut",
        "siri"
      ],
      "sources": [
        {
          "title": "Turn on and practice VoiceOver on iPhone",
          "url": "https://support.apple.com/guide/iphone/turn-on-and-practice-voiceover-iph3e2e415f/ios"
        },
        {
          "title": "Turn on and practice VoiceOver on iPad",
          "url": "https://support.apple.com/guide/ipad/turn-on-and-practice-voiceover-ipad9a246898/ipados"
        },
        {
          "title": "Accessibility Shortcut (triple-click)",
          "url": "https://support.apple.com/en-us/111771"
        },
        {
          "title": "Siri on iPhone",
          "url": "https://support.apple.com/guide/iphone/turn-on-and-activate-siri-iph83aad8922/ios"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. The quickest way: ask Siri \"Turn on VoiceOver\" (or \"Turn off VoiceOver\").\n2. Or open Settings, then Accessibility, then VoiceOver, and turn VoiceOver on.\n3. Set up the Accessibility Shortcut (Settings, Accessibility, Accessibility Shortcut, choose VoiceOver). Then three clicks of the side button (or the Home button on iPhones that have one) turns VoiceOver on or off.\n4. Once VoiceOver is on, a single tap only selects and speaks. To press a button or switch, tap it once, then double-tap anywhere on the screen.\n5. To turn it off in Settings while it is on: tap the VoiceOver switch once to select it, then double-tap.\n6. Open VoiceOver Practice in the VoiceOver settings to try gestures without changing anything.\n\n## Good to know\n- \"My phone talks and won't do what I tap\": VoiceOver is on. Use Siri or the triple-click to turn it off, or double-tap instead of tapping.\n- If the screen is black but the phone keeps talking, Screen Curtain may be on: a three-finger triple-tap turns it off.\n- Apple's free Accessibility line: 1-877-204-3930."
    },
    {
      "id": "voiceover-iphone-typing",
      "title": "VoiceOver on iPhone and iPad — typing, dictation and Braille Screen Input",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "screen reader",
        "voiceover",
        "typing",
        "keyboard",
        "dictation",
        "braille screen input"
      ],
      "sources": [
        {
          "title": "Use the onscreen keyboard with VoiceOver",
          "url": "https://support.apple.com/guide/iphone/use-the-onscreen-keyboard-iph3e2e3d1d/ios"
        },
        {
          "title": "Type braille on the screen (Braille Screen Input)",
          "url": "https://support.apple.com/guide/iphone/type-braille-on-the-screen-iph10366cc30/ios"
        },
        {
          "title": "Control VoiceOver using the rotor",
          "url": "https://support.apple.com/guide/iphone/control-voiceover-using-the-rotor-iph3e2e3a6d/ios"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Select the text field (swipe to it or touch it), then double-tap to bring up the keyboard.\n2. In Standard Typing, touch a key to hear it, then double-tap to type it. In Touch Typing, slide to the key and lift your finger to type it.\n3. Change the typing style with the rotor: turn two fingers to Typing Mode, then swipe up or down.\n4. To dictate instead, use the dictation key on the keyboard (the microphone), speak, and press it again to stop.\n5. For a braille reader, add Braille Screen Input to the rotor in the VoiceOver settings, then choose it from the rotor to type braille on the glass.\n\n## Good to know\n- Touch Typing is faster once the tenant is comfortable; Standard Typing makes fewer mistakes at first."
    },
    {
      "id": "voiceover-iphone-web-email",
      "title": "VoiceOver on iPhone and iPad — reading a web page and email",
      "platform": "Apple",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "version": "iOS/iPadOS 27",
      "topics": [
        "screen reader",
        "voiceover",
        "web page",
        "safari",
        "headings",
        "email",
        "mail"
      ],
      "sources": [
        {
          "title": "Control VoiceOver using the rotor",
          "url": "https://support.apple.com/guide/iphone/control-voiceover-using-the-rotor-iph3e2e3a6d/ios"
        },
        {
          "title": "Use VoiceOver gestures on iPhone",
          "url": "https://support.apple.com/guide/iphone/use-voiceover-gestures-iph3e2e2281/ios"
        },
        {
          "title": "iPhone User Guide",
          "url": "https://support.apple.com/guide/iphone/welcome/ios"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Web page: in Safari, swipe up with two fingers to hear the whole page from the top.\n2. To jump around, turn the rotor to Headings, then swipe down to go to the next heading and up for the previous one. Do the same with Links or Form Controls.\n3. Double-tap a link to open it.\n4. Email: in Mail, swipe right through the list of messages; double-tap one to open it, then swipe up with two fingers to hear it all.\n5. On a message in the list, swipe up or down with one finger to hear the actions (such as Delete or Flag), and double-tap to use one.\n6. To write a message, find the Compose button at the bottom of the screen, double-tap, fill in To, Subject and the message, then double-tap Send.\n\n## Good to know\n- Safari's Reader view and Accessibility Reader remove clutter, which makes long pages much easier."
    },
    {
      "id": "voiceover-mac-start",
      "title": "VoiceOver on Mac — turn it on (Command-F5) and the first keys",
      "platform": "Apple",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "macOS 27",
      "topics": [
        "screen reader",
        "voiceover",
        "mac",
        "turn on",
        "keys",
        "trackpad"
      ],
      "sources": [
        {
          "title": "Get started with VoiceOver on Mac (Command-F5)",
          "url": "https://support.apple.com/guide/voiceover/get-started-with-voiceover-vo4be8816d70/mac"
        },
        {
          "title": "Learn and practice VoiceOver on Mac",
          "url": "https://support.apple.com/guide/voiceover/learn-and-practice-voiceover-mchlp2687/mac"
        },
        {
          "title": "VoiceOver trackpad gestures (Mac)",
          "url": "https://support.apple.com/guide/voiceover/use-trackpad-gestures-to-control-voiceover-vo28030/mac"
        },
        {
          "title": "VoiceOver User Guide for Mac",
          "url": "https://support.apple.com/guide/voiceover/welcome/mac"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Press Command-F5 to turn VoiceOver on or off.\n2. The VoiceOver keys (\"VO\") are Control and Option held together; every VoiceOver command starts with them.\n3. VO-Right Arrow and VO-Left Arrow move to the next and previous item; VO-Space Bar presses the item.\n4. VO-A reads from the current spot; press Control to stop speech.\n5. VO-U opens the rotor (lists of headings, links, windows); use the arrow keys to choose and Return to go there.\n6. Open \"Learn and practice VoiceOver\" (Apple's page) for the built-in practice, which is safe to try.\n\n## Good to know\n- Apple's VoiceOver guide for Mac can be downloaded as a braille-ready (BRF) file."
    },
    {
      "id": "wifi-name-password-label",
      "title": "Find the Wi-Fi name and password (router label, provider app, a device that already has it)",
      "platform": "Verizon",
      "devices": [
        "internet",
        "phone",
        "computer"
      ],
      "version": "Verizon CR1000A/B and G3100; Verizon Home app; My Spectrum app; Windows 11; iOS 27 (Oct 2026)",
      "topics": [
        "internet",
        "wi-fi",
        "password",
        "network name",
        "router label",
        "qr code"
      ],
      "sources": [
        {
          "title": "Fios router FAQs (Wi-Fi name and password on the router label)",
          "url": "https://www.verizon.com/support/residential/internet/equipment/routers/fios-router/"
        },
        {
          "title": "Change Wi-Fi name or password (Verizon)",
          "url": "https://www.verizon.com/support/consumer/internet/home-network/change-wifi-name-password"
        },
        {
          "title": "Verizon Home app",
          "url": "https://www.verizon.com/support/verizon-home-app-faqs/"
        },
        {
          "title": "My Spectrum app",
          "url": "https://www.spectrum.com/apps"
        },
        {
          "title": "Find saved Wi-Fi passwords on iPhone",
          "url": "https://support.apple.com/en-us/104961"
        },
        {
          "title": "Connect to Wi-Fi; find a saved Wi-Fi password (Windows)",
          "url": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/connect-to-a-wi-fi-network-in-windows"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Verizon: the Wi-Fi name, the password and a join QR code are on the label on the back of the router (unless someone changed them).\n2. Spectrum: the Wi-Fi name and password are in the My Spectrum app; many Spectrum routers also have them on a label.\n3. Verizon: the Verizon Home app shows and changes the Wi-Fi name and password (the My Fios app was retired in 2023).\n4. A device that is already connected can show it: on an iPhone, Settings, then Wi-Fi, then the network's info button shows the saved password; on Windows, Microsoft's page shows where to see a saved password.\n5. Write it down for the tenant in large print (with their OK) before you change anything else.\n\n## Good to know\n- Changing the Wi-Fi password disconnects every device until the new password is typed on each one, printers included."
    },
    {
      "id": "windows-color-filters-contrast",
      "title": "Windows — color filters (Windows key + Ctrl + C) and contrast themes",
      "platform": "Microsoft",
      "devices": [
        "computer"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10 (color filters page Sep 2026)",
      "topics": [
        "easier to see",
        "color filters",
        "grayscale",
        "contrast themes",
        "high contrast",
        "invert colors"
      ],
      "sources": [
        {
          "title": "Use color filters in Windows",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/use-color-filters-in-windows"
        },
        {
          "title": "Change color contrast in Windows (contrast themes)",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/change-color-contrast-in-windows"
        },
        {
          "title": "Windows keyboard shortcuts for accessibility",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/windows-keyboard-shortcuts-for-accessibility"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Open Settings, then Accessibility, then Color filters, and turn Color filters on.\n2. Pick a filter (Inverted, Grayscale, or one for color blindness).\n3. Turn on the keyboard shortcut for color filters there; then the Windows logo key + Ctrl + C turns the filter on and off.\n4. For strong contrast instead, open Settings, then Accessibility, then Contrast themes, pick a theme and Apply.\n5. Left Alt + left Shift + Print Screen turns the contrast theme on and off from the keyboard.\n\n## Good to know\n- \"My screen went black and white\" or \"the colors are reversed\": a color filter is probably on; Windows logo key + Ctrl + C turns it off if the shortcut is on, otherwise turn it off in Settings."
    },
    {
      "id": "windows-frozen",
      "title": "Windows — frozen screen, a program not responding, a black or flickering screen",
      "platform": "Microsoft",
      "devices": [
        "computer"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "topics": [
        "frozen",
        "not responding",
        "stuck",
        "task manager",
        "black screen",
        "flickering"
      ],
      "sources": [
        {
          "title": "Troubleshoot screen flickering (Windows logo key + Ctrl + Shift + B)",
          "url": "https://support.microsoft.com/en-US/Windows/hardware/display-graphics/troubleshoot-screen-flickering-in-windows"
        },
        {
          "title": "Repair apps and programs in Windows",
          "url": "https://support.microsoft.com/en-US/Windows/Apps/repair-apps-and-programs-in-windows"
        },
        {
          "title": "Improve PC performance",
          "url": "https://support.microsoft.com/en-us/windows/tips-to-improve-pc-performance-in-windows-b3b3ef5b-5953-fb6a-2528-4bbed82fba96"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "high",
      "body": "## Steps\n1. Wait a full minute: the computer may be busy, not frozen.\n2. If the screen is black or flickering, press the Windows logo key + Ctrl + Shift + B to restart the graphics.\n3. Press Ctrl+Alt+Delete, open Task Manager, select the program that is \"not responding\", and choose End task.\n4. Press Ctrl+Alt+Delete, then the power button on that screen, then Restart.\n5. If one program keeps freezing, repair it (Settings, Apps, Installed apps, the program, Advanced options or Modify, Repair).\n6. ⚠ This erases any unsaved work in open programs: only if nothing responds at all, hold the power button for about 10 seconds until the computer turns off, wait, and turn it on.\n\n## Good to know\n- Ask the tenant whether anything unsaved is open before step 6."
    },
    {
      "id": "windows-magnifier",
      "title": "Windows — Magnifier (Windows key + Plus to start, Ctrl+Alt+I to invert)",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "topics": [
        "easier to see",
        "magnifier",
        "zoom",
        "invert colors",
        "low vision"
      ],
      "sources": [
        {
          "title": "Use Magnifier to make things on the screen easier to see",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/magnifier/use-magnifier-to-make-things-on-the-screen-easier-to-see"
        },
        {
          "title": "Windows keyboard shortcuts for accessibility",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/windows-keyboard-shortcuts-for-accessibility"
        },
        {
          "title": "Make Windows easier to see",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/make-windows-easier-to-see"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Press the Windows logo key and the Plus key together to start Magnifier and zoom in.\n2. Press the Windows logo key and Plus again to zoom in more; Windows logo key and Minus to zoom out.\n3. Press Ctrl+Alt+I to invert the colors inside Magnifier (light text on dark); press it again to turn it back.\n4. Press the Windows logo key and Esc to close Magnifier.\n5. To have it start by itself, open Settings, then Accessibility, then Magnifier, and turn on the option to start Magnifier after sign-in.\n\n## Good to know\n- \"Everything on my screen is huge and moves with the mouse\": Magnifier is on. Windows logo key + Esc closes it."
    },
    {
      "id": "windows-printer-queue",
      "title": "Windows — a print job is stuck (clear the queue, restart the print spooler)",
      "platform": "Microsoft",
      "devices": [
        "printer",
        "computer"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "topics": [
        "printer",
        "print queue",
        "stuck",
        "spooler",
        "not printing"
      ],
      "sources": [
        {
          "title": "Fix printer connection and printing problems in Windows (spooler, offline)",
          "url": "https://support.microsoft.com/en-US/Windows/Hardware/Printer/fix-printer-connection-and-printing-problems-in-windows"
        },
        {
          "title": "Windows troubleshooters (Get Help)",
          "url": "https://support.microsoft.com/en-US/Support/get-help/windows-troubleshooters"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Open Settings, then Bluetooth & devices, then Printers & scanners, choose the printer, and open the print queue.\n2. Cancel every document in the queue.\n3. Turn the printer off and on.\n4. If the jobs won't cancel, restart the Print Spooler service: type \"Services\" in the Start search, open it, find Print Spooler, and choose Restart.\n5. Run the printer troubleshooter in the Get Help app.\n6. Restart the computer and print a test page.\n\n## Good to know\n- Cancelling a print job doesn't delete the document; it can be printed again."
    },
    {
      "id": "windows-slow-storage",
      "title": "Windows — slow computer and a full drive (Storage Sense last)",
      "platform": "Microsoft",
      "devices": [
        "computer"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10 (Microsoft pages Sep 2026)",
      "topics": [
        "slow",
        "storage full",
        "disk full",
        "startup apps",
        "storage sense",
        "virus scan"
      ],
      "sources": [
        {
          "title": "Tips to improve PC performance in Windows",
          "url": "https://support.microsoft.com/en-us/windows/tips-to-improve-pc-performance-in-windows-b3b3ef5b-5953-fb6a-2528-4bbed82fba96"
        },
        {
          "title": "Free up drive space",
          "url": "https://support.microsoft.com/help/12425"
        },
        {
          "title": "Manage drive space with Storage Sense",
          "url": "https://support.microsoft.com/en-US/Windows/experience/storage-filemanagement/manage-drive-space-with-storage-sense"
        },
        {
          "title": "Windows Security (Defender)",
          "url": "https://support.microsoft.com/en-US/Windows/Security/windows-security/stay-protected-with-the-windows-security-app"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "medium",
      "body": "## Steps\n1. Restart the computer (Restart, not Shut down) and try again.\n2. Install waiting updates (Settings, Windows Update) and restart.\n3. Close programs that aren't needed; in Settings, Apps, Startup, turn off programs the tenant doesn't need at startup.\n4. Run a quick scan in Windows Security for viruses and other malware.\n5. Check the space left: Settings, System, Storage. Go through the cleanup recommendations with the tenant; nothing is removed without their OK.\n6. Run the maker's tool (SupportAssist on Dell, HP Support Assistant, Lenovo Vantage) for updates and a health check.\n7. ⚠ This erases temporary files and, depending on its settings, old files in the Recycle Bin and Downloads: turn on Storage Sense only after checking those folders with the tenant.\n\n## Good to know\n- An old PC with little memory will stay slow; say so plainly rather than promising a fix."
    },
    {
      "id": "windows-sound-bluetooth",
      "title": "Windows — no sound, and Bluetooth devices that won't connect",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "speaker"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "topics": [
        "no sound",
        "audio",
        "speakers",
        "headphones",
        "bluetooth",
        "pairing"
      ],
      "sources": [
        {
          "title": "Fix sound or audio problems in Windows",
          "url": "https://support.microsoft.com/en-US/Windows/Hardware/Audio/fix-sound-or-audio-problems-in-windows"
        },
        {
          "title": "Fix Bluetooth problems in Windows",
          "url": "https://support.microsoft.com/en-US/Windows/Hardware/bluetooth/fix-bluetooth-problems-in-windows"
        },
        {
          "title": "Windows troubleshooters (Get Help)",
          "url": "https://support.microsoft.com/en-US/Support/get-help/windows-troubleshooters"
        },
        {
          "title": "Drivers through Windows Update",
          "url": "https://support.microsoft.com/en-us/help/15046"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. No sound: check the volume and mute on the speaker icon by the clock, and on the speakers or headphones themselves.\n2. Choose the right output (the speaker icon has a list of devices): sound may be going to headphones or a Bluetooth speaker that isn't in use.\n3. Run the audio troubleshooter in the Get Help app.\n4. Bluetooth: check Bluetooth is on (quick settings by the clock), and the device is charged, close by and in pairing mode.\n5. In Settings, Bluetooth & devices, remove the device and pair it again.\n6. Restart the computer, and check Windows Update for driver updates.\n\n## Good to know\n- For a screen reader user, no sound means no computer: check the volume keys and the Narrator, JAWS or NVDA shortcut first."
    },
    {
      "id": "windows-text-size-pointer",
      "title": "Windows — bigger text, bigger everything, a bigger mouse pointer and text cursor",
      "platform": "Microsoft",
      "devices": [
        "computer"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "topics": [
        "easier to see",
        "text size",
        "scale",
        "mouse pointer",
        "text cursor"
      ],
      "sources": [
        {
          "title": "Change the size of text in Windows",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/change-the-size-of-text-in-windows"
        },
        {
          "title": "Make your mouse, keyboard and other input devices easier to use",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/make-your-mouse-keyboard-and-other-input-devices-easier-to-use"
        },
        {
          "title": "Make Windows easier to see",
          "url": "https://support.microsoft.com/en-us/accessibility/windows/make-windows-easier-to-see"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Open Settings, then Accessibility, then Text size. Drag the slider until the sample is easy to read, then select Apply.\n2. To make everything bigger (text, icons and windows), open Settings, then System, then Display, and choose a larger Scale.\n3. Open Settings, then Accessibility, then Mouse pointer and touch: make the pointer bigger and choose a color that stands out.\n4. Open Settings, then Accessibility, then Text cursor, and turn on the text cursor indicator so the typing spot is easy to find.\n\n## Good to know\n- Make one change at a time and ask the tenant after each one; too much scaling can push buttons off the screen."
    },
    {
      "id": "windows-updates-end-of-support",
      "title": "Windows Update problems, Windows 10 end of support (ESU to 12 Oct 2027), Office 2021 ending 14 Oct 2026",
      "platform": "Microsoft",
      "devices": [
        "computer"
      ],
      "version": "Windows 11 24H2/25H2; Windows 10 22H2 with consumer ESU (Microsoft pages Jun–Sep 2026)",
      "topics": [
        "updates",
        "windows update",
        "windows 10",
        "end of support",
        "esu",
        "windows 11",
        "office 2021"
      ],
      "sources": [
        {
          "title": "Troubleshoot problems updating Windows",
          "url": "https://support.microsoft.com/en-us/windows/troubleshoot-problems-updating-windows-188c2b0f-10a7-d72f-65b8-32d177eb136c"
        },
        {
          "title": "Windows 10 support has ended (options, ESU)",
          "url": "https://support.microsoft.com/en-US/Windows/Deployment/updates-lifecycle/windows-10-support-has-ended-on-october-14-2025"
        },
        {
          "title": "Extended Security Updates for Windows 10",
          "url": "https://www.microsoft.com/en-us/windows/extended-security-updates"
        },
        {
          "title": "End of support for Windows 10",
          "url": "https://www.microsoft.com/en-us/windows/end-of-support"
        },
        {
          "title": "PC Health Check app",
          "url": "https://support.microsoft.com/en-us/windows/how-to-use-the-pc-health-check-app-9c8abd9b-03ba-4e67-81ef-36f37caa7844"
        },
        {
          "title": "Windows 11 system requirements",
          "url": "https://support.microsoft.com/help/5005380"
        },
        {
          "title": "Office 2021 lifecycle",
          "url": "https://learn.microsoft.com/en-us/lifecycle/products/office-2021"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "high",
      "body": "## Steps\n1. Plug a laptop in, open Settings, then Windows Update, and choose Check for updates; restart when asked.\n2. If an update fails, free some drive space and try again, then run the Windows Update troubleshooter in Get Help.\n3. Windows 10: support ended on 14 Oct 2025, but the PC can get security updates until 12 Oct 2027 through consumer ESU.\n4. To enroll: Settings, Update & Security, Windows Update, \"Enroll now\". It is free by syncing PC settings with Windows Backup, or 1,000 Microsoft Rewards points, or a one-time $30 (one license covers up to 10 devices).\n5. ESU needs Windows 10 22H2 with the latest updates, and a Microsoft account that is an administrator on the PC.\n6. To see whether the PC can move to Windows 11 (TPM 2.0, Secure Boot, a listed processor, 4 GB memory, 64 GB storage), run the PC Health Check app.\n7. Office 2021 gets no more security fixes after 14 Oct 2026: tell the tenant, so they can decide what to do.\n\n## Good to know\n- Paying is the tenant's choice; never pay or enroll with their account without their OK."
    },
    {
      "id": "windows-wifi-fix",
      "title": "Windows — Wi-Fi won't connect or keeps dropping (network reset last)",
      "platform": "Microsoft",
      "devices": [
        "computer",
        "internet"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10 (Microsoft page Sep 2026)",
      "topics": [
        "internet",
        "wi-fi",
        "won't connect",
        "no internet",
        "network reset",
        "laptop"
      ],
      "sources": [
        {
          "title": "Fix Wi-Fi connection issues in Windows",
          "url": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/fix-wi-fi-connection-issues-in-windows"
        },
        {
          "title": "Connect to a Wi-Fi network in Windows",
          "url": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/connect-to-a-wi-fi-network-in-windows"
        },
        {
          "title": "Windows troubleshooters (Get Help)",
          "url": "https://support.microsoft.com/en-US/Support/get-help/windows-troubleshooters"
        },
        {
          "title": "Dell: Wi-Fi not working",
          "url": "https://www.dell.com/support/kbdoc/en-us/000132488"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "high",
      "body": "## Steps\n1. Check that Wi-Fi is on and Airplane mode is off (the network icon by the clock opens both).\n2. Choose the right network and type the password again carefully.\n3. Restart the computer.\n4. Restart the modem and router by unplugging them for a full minute.\n5. Run the network troubleshooter in the Get Help app.\n6. Forget the network (Settings, Network & internet, Wi-Fi, Manage known networks) and connect again with the password in hand.\n7. ⚠ This erases every saved Wi-Fi network and password on this computer: as the very last step, use Network reset (Settings, Network & internet, Advanced network settings). Have the Wi-Fi password ready first.\n\n## Good to know\n- Microsoft lists 13 steps and puts network reset last; so does this entry."
    },
    {
      "id": "windows-wont-start",
      "title": "Windows PC won't turn on or won't start (Dell, HP, Lenovo) — reset last",
      "platform": "Microsoft",
      "devices": [
        "computer"
      ],
      "version": "Windows 11 24H2/25H2 and Windows 10; Dell, HP and Lenovo pages (Oct 2026)",
      "topics": [
        "won't turn on",
        "won't start",
        "no power",
        "black screen",
        "startup repair",
        "safe mode",
        "system restore",
        "reset"
      ],
      "sources": [
        {
          "title": "Dell: no power, no boot, no video",
          "url": "https://www.dell.com/support/kbdoc/en-us/000125609"
        },
        {
          "title": "Dell: laptop power problems",
          "url": "https://www.dell.com/support/kbdoc/en-us/000124389/how-to-troubleshoot-power-issues-on-a-dell-laptop"
        },
        {
          "title": "HP: computer won't power on or boot",
          "url": "https://support.hp.com/us-en/document/c05336130"
        },
        {
          "title": "Lenovo: no power",
          "url": "https://support.lenovo.com/us/en/solutions/ht510410"
        },
        {
          "title": "Windows recovery environment",
          "url": "https://support.microsoft.com/windows/experience/backup-recovery/windows-recovery-environment"
        },
        {
          "title": "Startup Repair",
          "url": "https://support.microsoft.com/en-US/Windows/Experience/Startup-Boot/startup-repair"
        },
        {
          "title": "Safe Mode (Windows startup settings)",
          "url": "https://support.microsoft.com/en-US/Windows/Experience/startup-boot/windows-startup-settings"
        },
        {
          "title": "System Restore",
          "url": "https://support.microsoft.com/en-US/Windows/Experience/backup-recovery/system-restore"
        },
        {
          "title": "Reset your PC",
          "url": "https://support.microsoft.com/en-us/help/4026602/"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": true,
      "confidence": "medium",
      "body": "## Steps\n1. Check the power: the charger or cord is in firmly, the outlet works (try a lamp), and any charger light is on. Let a laptop charge for half an hour.\n2. On a desktop, check the monitor is on and its cable is in; press the Windows logo key + Ctrl + Shift + B to wake the screen.\n3. Unplug everything that isn't needed (USB drives, printers, discs) and try again.\n4. If there is no power at all, follow the maker's power page (Dell, HP or Lenovo) for that model, then run the maker's diagnostics (see the Dell, HP and Lenovo entries).\n5. If Windows starts but fails, it usually opens its recovery screens by itself; choose Startup Repair.\n6. From the recovery screens, try Safe Mode (Startup Settings). If the PC asks for a BitLocker recovery key, stop and find the key first.\n7. System Restore takes Windows back to an earlier day; personal files stay, but apps and drivers installed after that day are removed.\n8. ⚠ This erases apps and settings (and, with \"Remove everything\", the tenant's files): Reset this PC is the last resort. Back up first, choose \"Keep my files\", and only with the tenant's clear OK.\n\n## Good to know\n- If the tenant's files matter and the PC won't start, stop before step 8 and refer to the maker."
    },
    {
      "id": "zoomtext-zoom-colors",
      "title": "ZoomText — zoom in and out, color enhancements and inverted colors",
      "platform": "Vispero",
      "devices": [
        "computer",
        "screenReader"
      ],
      "version": "ZoomText 2026 (Sep 2026 build; user guide May 2026)",
      "topics": [
        "easier to see",
        "zoomtext",
        "zoom",
        "invert colors",
        "color enhancements",
        "hotkeys"
      ],
      "sources": [
        {
          "title": "ZoomText hotkeys",
          "url": "https://www.freedomscientific.com/training/zoomtext/zoomtext-hotkeys/"
        },
        {
          "title": "Getting Started with ZoomText",
          "url": "https://www.freedomscientific.com/training/zoomtext/getting-started/"
        },
        {
          "title": "ZoomText User Guide (PDF, May 2026)",
          "url": "https://support.freedomscientific.com/content/documents/manuals/ZoomText/ZoomText_User_Guide_English_US.pdf"
        },
        {
          "title": "ZoomText user guides in 22 languages (Spanish included)",
          "url": "https://support.freedomscientific.com/Support/ZoomTextDocumentation/ZoomTextGuides"
        }
      ],
      "catalogDate": "2026-10-10",
      "erases": false,
      "confidence": "medium",
      "body": "## Steps\n1. Make sure ZoomText is running (its toolbar opens, or the screen is magnified).\n2. Caps Lock + Up Arrow zooms in; Caps Lock + Down Arrow zooms out (ZoomText goes from 1x up to 60x).\n3. Caps Lock + C turns the color enhancements on and off.\n4. To choose inverted colors (light text on dark), open the color settings on ZoomText's Magnifier toolbar and pick an inverted scheme; the Getting Started lessons show it step by step.\n5. If a key doesn't work, check the hotkey list on Freedom Scientific's page for this version.\n\n## Good to know\n- The ZoomText user guide is available in Spanish.\n- Fusion is JAWS and ZoomText together: the same ZoomText keys work there (Fusion has its own hotkey page)."
    }
  ],
  "flows": [
    {
      "id": "android-frozen-slow",
      "title": "Android phone is frozen or very slow",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "frozen",
        "slow",
        "stuck",
        "not responding",
        "android",
        "pixel",
        "freezing"
      ],
      "steps": [
        {
          "id": "hold-power",
          "text": "Press and hold the power button until the phone restarts; charge it if the battery is low.",
          "erases": false,
          "entry": "android-frozen-slow-storage"
        },
        {
          "id": "safe-mode",
          "text": "Restart in safe mode to see whether a downloaded app is the cause; restart normally to leave it.",
          "erases": false,
          "entry": "android-frozen-slow-storage"
        },
        {
          "id": "storage",
          "text": "Settings, Storage: go through what takes space with the tenant.",
          "erases": false,
          "entry": "android-frozen-slow-storage"
        },
        {
          "id": "update",
          "text": "Install waiting updates on Wi-Fi with a charger.",
          "erases": false,
          "entry": "android-frozen-slow-storage"
        },
        {
          "id": "factory-reset",
          "text": "Factory reset — only after a backup, and after the tenant has proved their Google password works.",
          "erases": true,
          "warning": "This erases everything on the phone; it then asks for the Google account that was on it.",
          "entry": "android-factory-reset-find-hub"
        }
      ],
      "end": {
        "maker": "Google",
        "supportUrl": "https://support.google.com/accessibility/answer/7641084?hl=en"
      },
      "version": "Android 16–17",
      "confidence": "medium"
    },
    {
      "id": "android-wifi",
      "title": "Android or Samsung phone won't connect to Wi-Fi",
      "devices": [
        "phone",
        "tablet",
        "internet"
      ],
      "match": [
        "wi-fi",
        "wifi",
        "won't connect",
        "no internet",
        "internet",
        "android",
        "samsung",
        "galaxy"
      ],
      "firstQuestion": "Do other devices in the apartment have internet right now?",
      "steps": [
        {
          "id": "other-devices",
          "text": "Check whether other devices in the apartment have internet; if none do, it's the internet, not the phone.",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "wifi-on",
          "text": "Swipe down from the top: Wi-Fi on, Airplane mode off; choose the right network.",
          "erases": false,
          "entry": "android-wifi-fix"
        },
        {
          "id": "restart-phone",
          "text": "Restart the phone.",
          "erases": false,
          "entry": "android-wifi-fix"
        },
        {
          "id": "restart-router",
          "text": "Unplug the modem and router for a full minute, then plug them back in (modem first).",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "forget-rejoin",
          "text": "Forget the network and connect again with the password in hand (or the router's QR code).",
          "erases": false,
          "entry": "android-wifi-fix"
        },
        {
          "id": "reset-network",
          "text": "Reset the phone's network settings, with the Wi-Fi password ready.",
          "erases": true,
          "warning": "This erases saved Wi-Fi passwords and Bluetooth pairings on the phone.",
          "entry": "android-wifi-fix"
        }
      ],
      "end": {
        "maker": "Google",
        "supportUrl": "https://support.google.com/accessibility/answer/7641084?hl=en"
      },
      "version": "Android 16–17; One UI",
      "confidence": "medium"
    },
    {
      "id": "apple-account-password",
      "title": "Forgot the Apple Account password",
      "devices": [
        "phone",
        "tablet",
        "computer"
      ],
      "match": [
        "apple id",
        "apple account",
        "password",
        "forgot password",
        "icloud password",
        "locked out"
      ],
      "steps": [
        {
          "id": "reset-on-device",
          "text": "On a signed-in iPhone or iPad: Settings, their name, Sign-In & Security, Change Password (the device passcode is enough).",
          "erases": false,
          "entry": "apple-account-recovery"
        },
        {
          "id": "forgot-page",
          "text": "No signed-in device: follow Apple's forgotten-password page on a trusted device or the web.",
          "erases": false,
          "entry": "apple-account-recovery"
        },
        {
          "id": "account-recovery",
          "text": "If that fails, start account recovery and tell the tenant it takes days.",
          "erases": false,
          "entry": "apple-account-recovery"
        },
        {
          "id": "dont-sign-in",
          "text": "During recovery, don't sign in on another Apple device — that cancels it.",
          "erases": false,
          "entry": "apple-account-recovery"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/HT201232",
        "freeLine": {
          "name": "Apple Support",
          "phone": "1-800-275-2273",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "Apple pages, Oct 2026",
      "confidence": "high"
    },
    {
      "id": "canon-printer-offline",
      "title": "Canon printer says offline or won't print",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "canon",
        "pixma",
        "printer",
        "offline",
        "won't print",
        "wont print",
        "not printing"
      ],
      "steps": [
        {
          "id": "power-error",
          "text": "Check the printer is on and shows no error.",
          "erases": false,
          "entry": "canon-printer-offline"
        },
        {
          "id": "restart-printer",
          "text": "Turn the printer off, wait a full minute, and turn it on.",
          "erases": false,
          "entry": "canon-printer-offline"
        },
        {
          "id": "same-wifi",
          "text": "Check the computer and printer are on the same Wi-Fi.",
          "erases": false,
          "entry": "canon-printer-offline"
        },
        {
          "id": "windows-offline",
          "text": "Windows: in the print queue, untick “Use Printer Offline” and cancel stuck jobs.",
          "erases": false,
          "entry": "canon-printer-offline"
        },
        {
          "id": "restart-pc",
          "text": "Restart the computer and print a test page.",
          "erases": false,
          "entry": "canon-printer-offline"
        },
        {
          "id": "connection-assistant",
          "text": "If the router changed, run Canon's Wi-Fi Connection Assistant (or the Canon PRINT app).",
          "erases": false,
          "entry": "canon-printer-new-router"
        }
      ],
      "end": {
        "maker": "Canon",
        "supportUrl": "https://www.usa.canon.com/support"
      },
      "version": "Canon IJ manual pages (Oct 2026)",
      "confidence": "medium"
    },
    {
      "id": "epson-printer-offline",
      "title": "Epson printer says offline or won't print",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "epson",
        "printer",
        "offline",
        "won't print",
        "wont print",
        "not printing",
        "ecotank"
      ],
      "steps": [
        {
          "id": "power-error",
          "text": "Check the printer is on, has paper and ink, and shows no error.",
          "erases": false,
          "entry": "epson-printer-offline"
        },
        {
          "id": "restart-printer",
          "text": "Turn the printer off, wait a full minute, and turn it on.",
          "erases": false,
          "entry": "epson-printer-offline"
        },
        {
          "id": "same-wifi",
          "text": "Check the computer is on the same Wi-Fi as the printer.",
          "erases": false,
          "entry": "epson-printer-offline"
        },
        {
          "id": "windows-offline",
          "text": "Windows: in the print queue, untick “Use Printer Offline” and cancel stuck jobs.",
          "erases": false,
          "entry": "epson-printer-offline"
        },
        {
          "id": "mac-readd",
          "text": "Mac: remove the printer in Printers & Scanners and add it again.",
          "erases": false,
          "entry": "epson-printer-offline"
        },
        {
          "id": "new-router",
          "text": "If the router changed, run the Wi-Fi setup wizard on the printer or use Epson Smart Panel.",
          "erases": false,
          "entry": "epson-printer-new-router"
        }
      ],
      "end": {
        "maker": "Epson",
        "supportUrl": "https://epson.com/Support/sl/s"
      },
      "version": "Epson FAQ and networking pages (Oct 2026)",
      "confidence": "medium"
    },
    {
      "id": "hp-printer-offline",
      "title": "HP printer says offline or won't print",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "hp",
        "printer",
        "offline",
        "won't print",
        "wont print",
        "not printing",
        "hp smart",
        "deskjet",
        "officejet",
        "envy"
      ],
      "firstQuestion": "Does the printer's panel show an error or a blinking light?",
      "steps": [
        {
          "id": "power-error",
          "text": "Check the printer is on, has paper, and shows no error on its panel.",
          "erases": false,
          "entry": "hp-printer-offline"
        },
        {
          "id": "unplug-printer",
          "text": "Turn the printer off, unplug it for a full minute, plug in and turn on.",
          "erases": false,
          "entry": "hp-printer-offline"
        },
        {
          "id": "same-wifi",
          "text": "Check the computer or phone is on the same Wi-Fi as the printer.",
          "erases": false,
          "entry": "hp-printer-offline"
        },
        {
          "id": "diagnose-fix",
          "text": "Open the HP app (it replaced HP Smart), choose the printer, run Diagnose & Fix.",
          "erases": false,
          "entry": "hp-printer-offline"
        },
        {
          "id": "windows-offline",
          "text": "Windows: in the print queue, untick “Use Printer Offline” and cancel stuck jobs.",
          "erases": false,
          "entry": "hp-printer-offline"
        },
        {
          "id": "readd",
          "text": "Remove the printer from the computer and add it again with the HP app.",
          "erases": false,
          "entry": "hp-printer-offline"
        },
        {
          "id": "wireless-wizard",
          "text": "If the router or Wi-Fi password changed, run the printer's Wireless Setup Wizard (or set up Wi-Fi in the HP app).",
          "erases": false,
          "entry": "hp-printer-wifi-new-router"
        },
        {
          "id": "restore-network",
          "text": "Restore the printer's network settings, then set it up again with the HP app.",
          "erases": true,
          "warning": "This erases the printer's saved network settings.",
          "entry": "hp-printer-wifi-new-router"
        }
      ],
      "end": {
        "maker": "HP",
        "supportUrl": "https://www.hp.com/us-en/hp-information/accessibility-aging/need-help.html",
        "freeLine": {
          "name": "HP accessibility",
          "phone": "(877) 656-7058",
          "hours": "Mon–Fri 11 AM–8 PM ET"
        }
      },
      "version": "HP app (Oct 2026); Windows 11 and 10",
      "confidence": "medium"
    },
    {
      "id": "index-embosser-not-embossing",
      "title": "Index braille embosser won't emboss",
      "devices": [
        "printer"
      ],
      "match": [
        "embosser",
        "braille printer",
        "index",
        "won't emboss",
        "not embossing",
        "braille",
        "duxbury",
        "error code"
      ],
      "firstQuestion": "Does the embosser speak or show an error number?",
      "steps": [
        {
          "id": "ready-paper",
          "text": "Check the embosser is on, says it's ready, and has paper.",
          "erases": false,
          "entry": "index-paper-and-jams"
        },
        {
          "id": "error-code",
          "text": "Note any error number and look it up (for example 120 out of paper, 121 jam, 130–132 a door open).",
          "erases": false,
          "entry": "index-error-codes"
        },
        {
          "id": "clear-jam",
          "text": "Turn it off and clear any jam; reload the paper straight.",
          "erases": false,
          "entry": "index-paper-and-jams"
        },
        {
          "id": "help-10",
          "text": "If it's on the network, use HELP+10 to hear its IP address (HELP+1 prints the network page).",
          "erases": false,
          "entry": "index-network-ip-address"
        },
        {
          "id": "driver",
          "text": "Check the computer has Index's driver for this model (identify it from the serial label).",
          "erases": false,
          "entry": "index-connect-usb-network-wifi"
        },
        {
          "id": "duxbury-setup",
          "text": "In Duxbury, check the embosser model and “Send to Printer”; choose Generic if the model isn't listed.",
          "erases": false,
          "entry": "duxbury-send-to-embosser"
        },
        {
          "id": "test-page",
          "text": "Send one test page and ask the tenant to check it by touch.",
          "erases": false,
          "entry": "duxbury-send-to-embosser"
        }
      ],
      "end": {
        "maker": "Index",
        "supportUrl": "https://indexbraille.com/support/",
        "freeLine": {
          "name": "Index Braille through HumanWare (US distributor)",
          "phone": "1-800-722-3393",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "Index V4 and V5; Duxbury DBT 15.1 (Oct 2026)",
      "confidence": "medium"
    },
    {
      "id": "iphone-easier-to-see",
      "title": "Make an iPhone or iPad easier to see",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "match": [
        "hard to see",
        "too small",
        "can't read",
        "cant read",
        "bigger",
        "invert",
        "zoom",
        "colors",
        "too bright",
        "low vision"
      ],
      "firstQuestion": "Is the text too small, the screen too bright, or the colors hard to read?",
      "steps": [
        {
          "id": "larger-text",
          "text": "Settings, Accessibility, Display & Text Size: turn on Bold Text and drag Larger Text up.",
          "erases": false,
          "entry": "iphone-ipad-text-size"
        },
        {
          "id": "zoom",
          "text": "Turn on Zoom (Settings, Accessibility, Zoom); a three-finger double-tap zooms in and out.",
          "erases": false,
          "entry": "iphone-ipad-zoom"
        },
        {
          "id": "smart-invert",
          "text": "Turn on Smart Invert for light text on a dark screen.",
          "erases": false,
          "entry": "iphone-ipad-invert-filters-contrast"
        },
        {
          "id": "contrast-white-point",
          "text": "Turn on Increase Contrast and Reduce White Point to cut glare.",
          "erases": false,
          "entry": "iphone-ipad-invert-filters-contrast"
        },
        {
          "id": "magnifier",
          "text": "Show the Magnifier app for letters and labels, and add it to Control Center.",
          "erases": false,
          "entry": "iphone-ipad-magnifier"
        },
        {
          "id": "shortcut",
          "text": "Put the favorite setting on the Accessibility Shortcut (triple-click) so the tenant can switch it.",
          "erases": false,
          "entry": "iphone-ipad-invert-filters-contrast"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/en-us/111749",
        "freeLine": {
          "name": "Apple Accessibility",
          "phone": "1-877-204-3930",
          "hours": "Hours not listed in the catalog; any relay service works"
        }
      },
      "version": "iOS/iPadOS 27",
      "confidence": "high"
    },
    {
      "id": "iphone-email-not-sending",
      "title": "iPhone or iPad can't send email",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "email",
        "mail",
        "can't send",
        "cant send",
        "outbox",
        "not sending"
      ],
      "steps": [
        {
          "id": "internet",
          "text": "Check the device has internet: open a web page in Safari.",
          "erases": false,
          "entry": "iphone-email-not-sending"
        },
        {
          "id": "outbox",
          "text": "Look in Mail's Outbox for a stuck message (often a large attachment) and send it again smaller.",
          "erases": false,
          "entry": "iphone-email-not-sending"
        },
        {
          "id": "icloud-storage",
          "text": "For iCloud Mail, check iCloud storage: full storage stops email.",
          "erases": false,
          "entry": "iphone-email-not-sending"
        },
        {
          "id": "restart",
          "text": "Restart the iPhone or iPad and try again.",
          "erases": false,
          "entry": "iphone-email-not-sending"
        },
        {
          "id": "account-settings",
          "text": "Follow Apple's can't-send page for the account's settings; for Outlook.com or Gmail, use that provider's entry.",
          "erases": false,
          "entry": "iphone-email-not-sending"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/HT201232",
        "freeLine": {
          "name": "Apple Support",
          "phone": "1-800-275-2273",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "iOS/iPadOS 27",
      "confidence": "medium"
    },
    {
      "id": "iphone-forgot-passcode",
      "title": "Forgot the iPhone or iPad passcode (“iPhone Unavailable”)",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "passcode",
        "forgot passcode",
        "locked",
        "iphone unavailable",
        "locked out",
        "pin"
      ],
      "firstQuestion": "Was the passcode changed in the last 72 hours?",
      "steps": [
        {
          "id": "stop-guessing",
          "text": "Stop guessing: each wrong try makes the wait longer.",
          "erases": false,
          "entry": "iphone-ipad-forgot-passcode"
        },
        {
          "id": "previous-passcode",
          "text": "If it was changed in the last 72 hours, choose “Forgot Passcode?” and enter the previous passcode.",
          "erases": false,
          "entry": "iphone-ipad-forgot-passcode"
        },
        {
          "id": "check-account",
          "text": "Check the tenant knows their Apple Account password and has a backup; without the password, stop and call Apple.",
          "erases": false,
          "entry": "iphone-ipad-forgot-passcode"
        },
        {
          "id": "reset-on-device",
          "text": "On the “iPhone Unavailable” screen, use “Forgot Passcode?” to reset with the Apple Account password, then restore the backup.",
          "erases": true,
          "warning": "This erases everything on the iPhone or iPad; the backup puts it back.",
          "entry": "iphone-ipad-forgot-passcode"
        },
        {
          "id": "reset-with-computer",
          "text": "If that option isn't there, reset it with a computer in recovery mode, then restore the backup.",
          "erases": true,
          "warning": "This erases everything on the iPhone or iPad; the backup puts it back.",
          "entry": "iphone-ipad-forgot-passcode"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/HT201232",
        "freeLine": {
          "name": "Apple Support",
          "phone": "1-800-275-2273",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "iOS/iPadOS 27",
      "confidence": "high"
    },
    {
      "id": "iphone-frozen-wont-turn-on",
      "title": "iPhone or iPad is frozen, black, or won't turn on",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "frozen",
        "won't turn on",
        "wont turn on",
        "black screen",
        "stuck",
        "not responding",
        "dead",
        "apple logo"
      ],
      "firstQuestion": "Does the screen show anything at all — a light, the Apple logo, or nothing?",
      "steps": [
        {
          "id": "charge",
          "text": "Plug it into a charger that works and leave it for up to an hour.",
          "erases": false,
          "entry": "iphone-ipad-restart-frozen"
        },
        {
          "id": "close-app",
          "text": "If only one app is frozen, close it from the app switcher and open it again.",
          "erases": false,
          "entry": "iphone-ipad-restart-frozen"
        },
        {
          "id": "force-restart-iphone",
          "text": "Force restart: press and release volume up, press and release volume down, then hold the side button until the Apple logo appears.",
          "check": "Did the Apple logo appear?",
          "erases": false,
          "entry": "iphone-ipad-restart-frozen"
        },
        {
          "id": "force-restart-ipad",
          "text": "On an iPad, use the force restart for its kind (with or without a Home button) from the entry.",
          "check": "Did the Apple logo appear?",
          "erases": false,
          "entry": "iphone-ipad-restart-frozen"
        },
        {
          "id": "recovery-update",
          "text": "Stuck on the Apple logo: connect it to a computer and use recovery mode, then choose Update (it keeps the data).",
          "erases": false,
          "entry": "iphone-ipad-restart-frozen"
        },
        {
          "id": "recovery-restore",
          "text": "Restore in recovery mode — only with the tenant's OK and their Apple Account password known.",
          "erases": true,
          "warning": "This erases everything on the iPhone or iPad; the backup puts it back.",
          "entry": "iphone-ipad-restart-frozen"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/HT201232",
        "freeLine": {
          "name": "Apple Support",
          "phone": "1-800-275-2273",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "iOS/iPadOS 27",
      "confidence": "high"
    },
    {
      "id": "iphone-storage-full",
      "title": "iPhone or iPad says storage is full",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "storage full",
        "storage",
        "full",
        "no space",
        "out of space",
        "can't take photos"
      ],
      "steps": [
        {
          "id": "check-storage",
          "text": "Open Settings, General, iPhone Storage, and wait for the list.",
          "erases": false,
          "entry": "iphone-ipad-storage-update"
        },
        {
          "id": "offload",
          "text": "Turn on Offload Unused Apps (keeps the apps' documents and data).",
          "erases": false,
          "entry": "iphone-ipad-storage-update"
        },
        {
          "id": "review-large",
          "text": "Go through the biggest items (videos, old messages) with the tenant; they decide what goes.",
          "erases": false,
          "entry": "iphone-ipad-storage-update"
        },
        {
          "id": "icloud-storage",
          "text": "Check iCloud storage too: full iCloud stops email and backups.",
          "erases": false,
          "entry": "iphone-email-not-sending"
        },
        {
          "id": "update",
          "text": "With space free, install any waiting update (Settings, General, Software Update).",
          "erases": false,
          "entry": "iphone-ipad-storage-update"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/HT201232",
        "freeLine": {
          "name": "Apple Support",
          "phone": "1-800-275-2273",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "iOS/iPadOS 27",
      "confidence": "high"
    },
    {
      "id": "iphone-wifi",
      "title": "iPhone or iPad won't connect to Wi-Fi",
      "devices": [
        "phone",
        "tablet",
        "internet"
      ],
      "match": [
        "wi-fi",
        "wifi",
        "won't connect",
        "no internet",
        "internet",
        "network"
      ],
      "firstQuestion": "Do other devices in the apartment have internet right now?",
      "steps": [
        {
          "id": "other-devices",
          "text": "Check whether other devices in the apartment have internet; if none do, it's the internet, not the iPhone.",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "wifi-on",
          "text": "Settings, Wi-Fi: Wi-Fi on, the right network chosen, Airplane Mode off.",
          "erases": false,
          "entry": "iphone-ipad-wifi-fix"
        },
        {
          "id": "restart-device",
          "text": "Restart the iPhone or iPad.",
          "erases": false,
          "entry": "iphone-ipad-wifi-fix"
        },
        {
          "id": "restart-router",
          "text": "Unplug the modem and router for a full minute, then plug them back in (modem first).",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "forget-rejoin",
          "text": "Forget the network and join it again with the password in hand.",
          "erases": false,
          "entry": "iphone-ipad-wifi-fix"
        },
        {
          "id": "reset-network",
          "text": "Reset Network Settings (Settings, General, Transfer or Reset, Reset), with the Wi-Fi password ready.",
          "erases": true,
          "warning": "This erases saved Wi-Fi passwords, Bluetooth pairings and network settings on the device.",
          "entry": "iphone-ipad-wifi-fix"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/HT201232",
        "freeLine": {
          "name": "Apple Support",
          "phone": "1-800-275-2273",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "iOS/iPadOS 27",
      "confidence": "high"
    },
    {
      "id": "microsoft-account-password",
      "title": "Can't sign in to a Microsoft account (Outlook.com, Windows)",
      "devices": [
        "computer",
        "phone",
        "other"
      ],
      "match": [
        "microsoft account",
        "outlook password",
        "hotmail",
        "password",
        "can't sign in",
        "cant sign in",
        "locked out"
      ],
      "steps": [
        {
          "id": "check-typing",
          "text": "Check the email address spelling and that Caps Lock is off.",
          "erases": false,
          "entry": "microsoft-account-recovery"
        },
        {
          "id": "forgot-password",
          "text": "Use “Forgot password”; the code goes to the tenant's own phone or email and they type it.",
          "erases": false,
          "entry": "microsoft-account-recovery"
        },
        {
          "id": "recovery-form",
          "text": "If none of those work, fill in the recovery form from a device the tenant has used before.",
          "erases": false,
          "entry": "microsoft-account-recovery"
        },
        {
          "id": "update-info",
          "text": "Once in, check the recovery phone and email, and offer two-step verification.",
          "erases": false,
          "entry": "microsoft-account-recovery"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://www.microsoft.com/en-us/accessibility/disability-answer-desk",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Microsoft account pages, Oct 2026",
      "confidence": "high"
    },
    {
      "id": "nls-da2-wifi",
      "title": "Connect an NLS DA2 talking-book player to Wi-Fi",
      "devices": [
        "other",
        "internet"
      ],
      "match": [
        "da2",
        "talking book",
        "talking-book",
        "nls",
        "bard",
        "book player",
        "library player"
      ],
      "firstQuestion": "Is it a DA2? (A DS1 or DA1 has no Wi-Fi.)",
      "steps": [
        {
          "id": "which-player",
          "text": "Read the label: only the DA2 has Wi-Fi; a DS1 or DA1 uses cartridges or a USB drive.",
          "erases": false,
          "entry": "nls-talking-book-players-bard"
        },
        {
          "id": "bard-password",
          "text": "Check the tenant has a BARD account with a permanent password (the library sets it up).",
          "erases": false,
          "entry": "nls-da2-wifi"
        },
        {
          "id": "wifi-menu",
          "text": "Press and hold the Info key, then Settings, then Wi-Fi, and turn Wi-Fi on.",
          "erases": false,
          "entry": "nls-da2-wifi"
        },
        {
          "id": "choose-network",
          "text": "Choose the network and enter the password as the DA2 guide describes.",
          "erases": false,
          "entry": "nls-da2-wifi"
        },
        {
          "id": "usb-config",
          "text": "Or put wifi_config.txt on a USB drive (network name on line 1, password on line 2) and plug it into the DA2.",
          "erases": false,
          "entry": "nls-da2-wifi"
        }
      ],
      "end": {
        "maker": "NLS",
        "supportUrl": "https://www.loc.gov/nls/find-your-library/",
        "freeLine": {
          "name": "NLS (connects to the local library)",
          "phone": "888-657-7323",
          "hours": "Mon–Fri 9:30–4 ET"
        }
      },
      "version": "DA2 User Guide (Aug 2026)",
      "confidence": "medium"
    },
    {
      "id": "reliability-android-wifi",
      "title": "Android Wi-Fi connection fails",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "android",
        "no internet",
        "wifi drops",
        "wi-fi drops",
        "cannot connect"
      ],
      "firstQuestion": "Confirm Android version and whether another device connects; menus vary by device.",
      "steps": [
        {
          "id": "step-1",
          "text": "Open Settings, then Network & internet → Internet and select the intended network.",
          "erases": false,
          "entry": "reliability-android-wifi",
          "sourceUrl": "https://support.google.com/android/answer/9075847?hl=en",
          "quote": "Tap Network & internet Internet .",
          "sectionId": "manual-b2fee2429e69ba217003"
        },
        {
          "id": "step-2",
          "text": "Check the Android-version notes before following the connection procedure.",
          "erases": false,
          "entry": "reliability-android-wifi",
          "sourceUrl": "https://support.google.com/android/answer/9075847?hl=en",
          "quote": "Important: Some of these steps work only on Android 12 and up.",
          "sectionId": "manual-a42b02aed6f16ca8c785"
        }
      ],
      "end": {
        "maker": "Google",
        "supportUrl": "https://support.google.com/android/answer/9075847?hl=en"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "android-wifi"
    },
    {
      "id": "reliability-apple-account",
      "title": "Apple Account recovery",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "apple account",
        "apple id",
        "forgot",
        "recover",
        "cant sign in",
        "cannot sign in"
      ],
      "firstQuestion": "The account holder performs recovery personally. The tech never collects passwords or security codes.",
      "steps": [
        {
          "id": "step-1",
          "text": "The holder chooses Forgot Password and follows Apple’s onscreen instructions.",
          "erases": false,
          "entry": "reliability-apple-account",
          "sourceUrl": "https://support.apple.com/en-us/102656",
          "quote": "If you forgot your password and can't sign in to your Apple Account › Choose \"Forgot Password?\" and follow the onscreen instructions\nChoose \"Forgot Password?\" and follow the onscreen instructions Whether you're setting up a new device, signing in to your Apple Account in the Settings app, or making a purchase in the App Store, look for \"Forgot password?\" or \"Forgot password or don't have an Apple Account?\" Then follow the onscreen instructions — they'll direct you to a trusted device, ask for recovery factors (such as a two-factor verification code sent to your trusted phon",
          "sectionId": "manual-c54d12f5e1c0f5e747dc"
        },
        {
          "id": "step-2",
          "text": "Review Apple’s recovery-request cancellation warning before using another signed-in device.",
          "erases": false,
          "entry": "reliability-apple-account",
          "sourceUrl": "https://support.apple.com/en-us/102656",
          "quote": "Activity from a signed-in device will cancel your request.",
          "sectionId": "manual-a36b696ddd5bf9efb330"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/en-us/102656",
        "freeLine": {
          "name": "Apple Accessibility",
          "phone": "1-877-204-3930",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "apple-account"
    },
    {
      "id": "reliability-apple-mail",
      "title": "iPhone Mail will not send",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "iphone",
        "ipad",
        "email not sending",
        "cant send email",
        "cannot send email",
        "outbox"
      ],
      "firstQuestion": "Confirm which account/provider fails and whether Mail reports an error; the holder checks account access.",
      "steps": [
        {
          "id": "step-1",
          "text": "If Outbox is present: In Mail’s mailbox list, open Outbox and check the unsent message.",
          "erases": false,
          "entry": "reliability-apple-mail",
          "sourceUrl": "https://support.apple.com/en-us/102556",
          "quote": "Tap Outbox.",
          "sectionId": "manual-f5251f81fc1018181344"
        },
        {
          "id": "step-2",
          "text": "For the unsent message: Check the recipient address, then try sending the message again.",
          "erases": false,
          "entry": "reliability-apple-mail",
          "sourceUrl": "https://support.apple.com/en-us/102556",
          "quote": "Make sure that the recipient's email address is correct.",
          "sectionId": "manual-f5251f81fc1018181344"
        },
        {
          "id": "step-3",
          "text": "For an iCloud account: For iCloud Mail, check account storage and system status before changing the account.",
          "erases": false,
          "entry": "reliability-apple-mail",
          "sourceUrl": "https://support.apple.com/en-us/102562",
          "quote": "Make sure that you haven't exceeded your iCloud storage limit .",
          "sectionId": "manual-e8062a9a41c437fb6c07"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/en-us/102556",
        "freeLine": {
          "name": "Apple Accessibility",
          "phone": "1-877-204-3930",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "apple-mail"
    },
    {
      "id": "reliability-brother-new-router",
      "title": "Brother after a new router",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "brother",
        "new router",
        "router changed",
        "changed router"
      ],
      "firstQuestion": "The cited page is for HL-2270DW. Use the model’s actual wireless setup instructions.",
      "steps": [
        {
          "id": "step-1",
          "text": "Reconnect the Brother machine to the new wireless network.",
          "erases": false,
          "entry": "reliability-brother-new-router",
          "sourceUrl": "https://support.brother.com/g/b/faqend.aspx?c=us&lang=en&prod=hl2270dw_all&ftype3=2039&faqid=faq00100014_000",
          "quote": "from WEP to WPA2), you need to reconnect your Brother machine to new wireless access point/router network.",
          "sectionId": "manual-83a7370103e0a1b11aba"
        },
        {
          "id": "step-2",
          "text": "Use the linked manual or automatic wireless configuration procedure for the matching model.",
          "erases": false,
          "entry": "reliability-brother-new-router",
          "sourceUrl": "https://support.brother.com/g/b/faqend.aspx?c=us&lang=en&prod=hl2270dw_all&ftype3=2039&faqid=faq00100014_000",
          "quote": "Click here to configure the Brother machine for a wireless network manually.",
          "sectionId": "manual-83a7370103e0a1b11aba"
        }
      ],
      "end": {
        "maker": "Brother",
        "supportUrl": "https://support.brother.com/g/b/faqend.aspx?c=us&lang=en&prod=hl2270dw_all&ftype3=2039&faqid=faq00100014_000"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "brother-new-router"
    },
    {
      "id": "reliability-brother-offline",
      "title": "Brother printer offline or paused",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "brother",
        "offline",
        "paused",
        "not printing",
        "wont print"
      ],
      "firstQuestion": "The cited FAQ covers the MFC-9130CW. Check the exact model and operating system.",
      "steps": [
        {
          "id": "step-1",
          "text": "Check power and LCD error messages first.",
          "erases": false,
          "entry": "reliability-brother-offline",
          "sourceUrl": "https://support.brother.com/g/b/faqend.aspx?c=us&faqid=faq00002646_009&ftype3=1972&lang=en&prod=mfc9130cw_us",
          "quote": "Check the LCD for any error messages.",
          "sectionId": "manual-007213ec9f81b9d9d2fc"
        },
        {
          "id": "step-2",
          "text": "Choose the actual connection type: Check the cable directly to the computer, or the Ethernet/wireless network configuration page.",
          "erases": false,
          "entry": "reliability-brother-offline",
          "sourceUrl": "https://support.brother.com/g/b/faqend.aspx?c=us&faqid=faq00002646_009&ftype3=1972&lang=en&prod=mfc9130cw_us",
          "quote": "STEP B: Make sure the printer is connected to the computer If using a USB cable, make sure the cable is connected to both the printer and computer.",
          "sectionId": "manual-c67ce15bfcfdb719136e"
        },
        {
          "id": "step-3",
          "text": "After the physical connection checks: Clear the applicable offline or paused state.",
          "erases": false,
          "entry": "reliability-brother-offline",
          "sourceUrl": "https://support.brother.com/g/b/faqend.aspx?c=us&faqid=faq00002646_009&ftype3=1972&lang=en&prod=mfc9130cw_us",
          "quote": "If the printer status is Offline (Windows 10 or earlier) Right-click the icon for your Brother machine > See what's printing > Printer > Use Printer Offline (removes the checkmark).",
          "sectionId": "manual-5bcca0ea28c09f8cb017"
        }
      ],
      "end": {
        "maker": "Brother",
        "supportUrl": "https://support.brother.com/g/b/faqend.aspx?c=us&faqid=faq00002646_009&ftype3=1972&lang=en&prod=mfc9130cw_us"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "brother-offline"
    },
    {
      "id": "reliability-canon-offline",
      "title": "Canon TS3700 offline",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "canon",
        "pixma",
        "offline",
        "not printing",
        "wont print"
      ],
      "firstQuestion": "Confirm TS3700-series applicability, Windows version and USB versus Wi-Fi connection.",
      "steps": [
        {
          "id": "step-1",
          "text": "Choose the actual connection type: Check the USB or Wi-Fi connection and power-cycle the printer.",
          "erases": false,
          "entry": "reliability-canon-offline",
          "sourceUrl": "https://ij.manual.canon/ij/webmanual/Manual/All/TS3700%20series/EN/NTR/ntr_t_03_17.html",
          "quote": "Check the connection ( USB / Wi-Fi ).",
          "sectionId": "manual-4e1bdaf1155f538edfc9"
        },
        {
          "id": "step-2",
          "text": "If still offline: Check the printer and MP Drivers names match.",
          "erases": false,
          "entry": "reliability-canon-offline",
          "sourceUrl": "https://ij.manual.canon/ij/webmanual/Manual/All/TS3700%20series/EN/NTR/ntr_t_03_17.html",
          "quote": "Check the names of the printer and MP Drivers (Printer Driver) match.",
          "sectionId": "manual-4e1bdaf1155f538edfc9"
        },
        {
          "id": "step-3",
          "text": "If still offline: Follow the matching Windows branch to clear Use Printer Offline.",
          "erases": false,
          "entry": "reliability-canon-offline",
          "sourceUrl": "https://ij.manual.canon/ij/webmanual/Manual/All/TS3700%20series/EN/NTR/ntr_t_03_17.html",
          "quote": "Make sure that printer is not set to Use Printer Offline mode.",
          "sectionId": "manual-4e1bdaf1155f538edfc9"
        }
      ],
      "end": {
        "maker": "Canon",
        "supportUrl": "https://ij.manual.canon/ij/webmanual/Manual/All/TS3700%20series/EN/NTR/ntr_t_03_17.html"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "canon-offline"
    },
    {
      "id": "reliability-epson-new-router",
      "title": "Epson after a new router",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "epson",
        "new router",
        "router changed",
        "changed router"
      ],
      "firstQuestion": "Confirm the model’s network setup guide and Windows versus Mac; the holder supplies new network credentials.",
      "steps": [
        {
          "id": "step-1",
          "text": "Update the printer’s Wi-Fi connection for the new router.",
          "erases": false,
          "entry": "reliability-epson-new-router",
          "sourceUrl": "https://files.support.epson.com/docid/cpd4/cpd41557/source/printers/source/networking/tasks/switching_router.html",
          "quote": "Connecting to a New Wi-Fi Router If you change the wireless router you have been using on your network, you need to update your product's Wi-Fi connection to the new router.",
          "sectionId": "manual-2b9d7ff1e1d032980217"
        },
        {
          "id": "step-2",
          "text": "Follow Epson’s operating-system branch to install software and set up the wireless connection.",
          "erases": false,
          "entry": "reliability-epson-new-router",
          "sourceUrl": "https://files.support.epson.com/docid/cpd4/cpd41557/source/printers/source/networking/tasks/switching_router.html",
          "quote": "Download and install your product software from the Epson website using the instructions in the Quick Guide .",
          "sectionId": "manual-2b9d7ff1e1d032980217"
        }
      ],
      "end": {
        "maker": "Epson",
        "supportUrl": "https://files.support.epson.com/docid/cpd4/cpd41557/source/printers/source/networking/tasks/switching_router.html"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "epson-new-router"
    },
    {
      "id": "reliability-epson-offline",
      "title": "Epson ET-2850 offline",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "epson",
        "et-2850",
        "offline",
        "not printing",
        "wont print"
      ],
      "firstQuestion": "This cited FAQ is for ET-2850 with wireless Windows printing; use the exact model’s page for other printers.",
      "steps": [
        {
          "id": "step-1",
          "text": "For the matching Windows wireless setup: Clear Use Printer Offline in the print queue.",
          "erases": false,
          "entry": "reliability-epson-offline",
          "sourceUrl": "https://epson.com/faq/SPT_C11CJ63202~faq-0000493-et2850?faq_cat=faq-topFaqs",
          "quote": "In the Epson print queue, select Printer and deselect the Use Printer Offline checkbox.",
          "sectionId": "manual-7e93b35e0534e346b8dc"
        },
        {
          "id": "step-2",
          "text": "Check the printer’s Wi-Fi indicator and follow the matching connected/disconnected branch.",
          "erases": false,
          "entry": "reliability-epson-offline",
          "sourceUrl": "https://epson.com/faq/SPT_C11CJ63202~faq-0000493-et2850?faq_cat=faq-topFaqs",
          "quote": "Check your product's Wi-Fi indicator and do one of the following: If a wireless connection is established, unplug your router's power cord from the power outlet, wait a brief period, plug it back in, and then try to print.",
          "sectionId": "manual-7e93b35e0534e346b8dc"
        },
        {
          "id": "step-3",
          "text": "If the restart checks do not resolve it, contact Epson Support.",
          "erases": false,
          "entry": "reliability-epson-offline",
          "sourceUrl": "https://epson.com/faq/SPT_C11CJ63202~faq-0000493-et2850?faq_cat=faq-topFaqs",
          "quote": "Otherwise, contact Epson Support.",
          "sectionId": "manual-7e93b35e0534e346b8dc"
        }
      ],
      "end": {
        "maker": "Epson",
        "supportUrl": "https://epson.com/faq/SPT_C11CJ63202~faq-0000493-et2850?faq_cat=faq-topFaqs"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "epson-offline"
    },
    {
      "id": "reliability-gmail-sync",
      "title": "Gmail stops sending or syncing",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "gmail",
        "not sending",
        "not syncing",
        "cant send",
        "cannot send"
      ],
      "firstQuestion": "Confirm Gmail account access, available storage and device; distinguish mobile sync from server delivery.",
      "steps": [
        {
          "id": "step-1",
          "text": "Check Google Account storage when Gmail stops syncing.",
          "erases": false,
          "entry": "reliability-gmail-sync",
          "sourceUrl": "https://support.google.com/mail/answer/6383854?visit_id=639272813946048584-1681127657&rd=1",
          "quote": "Check your Google Account storage\nCheck your Google Account storage Your Google Account storage is shared across Gmail, Google Photos, and Google Drive.",
          "sectionId": "manual-603e1a0b534f75baf451"
        },
        {
          "id": "step-2",
          "text": "Check Gmail sync settings for the matching device.",
          "erases": false,
          "entry": "reliability-gmail-sync",
          "sourceUrl": "https://support.google.com/mail/answer/6383854?visit_id=639272813946048584-1681127657&rd=1",
          "quote": "Check your Gmail sync settings\nCheck your Gmail sync settings On your Android phone or tablet, open the Gmail app .",
          "sectionId": "manual-fa75c282b2d5edb591e5"
        }
      ],
      "end": {
        "maker": "Google",
        "supportUrl": "https://support.google.com/mail/answer/6383854?visit_id=639272813946048584-1681127657&rd=1"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "gmail-sync"
    },
    {
      "id": "reliability-google-account",
      "title": "Google Account recovery",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "google account",
        "gmail account",
        "forgot",
        "recover",
        "cant sign in",
        "cannot sign in"
      ],
      "firstQuestion": "The holder performs recovery on Google’s own page. Work/school accounts may need the administrator.",
      "steps": [
        {
          "id": "step-1",
          "text": "Open Google’s account recovery instructions with the account holder.",
          "erases": false,
          "entry": "reliability-google-account",
          "sourceUrl": "https://support.google.com/accounts/answer/7682439?hl=en",
          "quote": "oogle · How to recover your Google Account or Gmail · Not stated on page\nHow to recover your Google Account or Gmail › Forgot your password\nForgot your password Follow the steps to recover your Google Account or Gmail .",
          "sectionId": "manual-e0a7a8dd94516fef15cc"
        },
        {
          "id": "step-2",
          "text": "If the account is managed: For a work or school account, check with the administrator.",
          "erases": false,
          "entry": "reliability-google-account",
          "sourceUrl": "https://support.google.com/accounts/answer/7682439?hl=en",
          "quote": "Check with your administrator for help.",
          "sectionId": "manual-c14cba0b394f6b0f0330"
        }
      ],
      "end": {
        "maker": "Google",
        "supportUrl": "https://support.google.com/accounts/answer/7682439?hl=en"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "google-account"
    },
    {
      "id": "reliability-hp-offline",
      "title": "HP printer offline",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "hp",
        "deskjet",
        "officejet",
        "offline",
        "not printing",
        "wont print"
      ],
      "firstQuestion": "Confirm printer model, power/error state, operating system and connection type.",
      "steps": [
        {
          "id": "step-1",
          "text": "For supported Windows or Mac: Open the HP app and run Diagnose & Fix.",
          "erases": false,
          "entry": "reliability-hp-offline",
          "sourceUrl": "https://www.hp.com/us-en/tech-takes/printers/troubleshooting/why-is-my-hp-printer-offline.html",
          "quote": "Option 1: Run HP Print and Scan Doctor Download and run the HP Print and Scan Doctor application Open HPPSdr.exe from the download location (you may need administrator privileges) Click “Start” and select your printer Follow the on-screen prompts, selecting “Yes” when asked to turn on printer updates or set as default printer If the issue persists, you can also try using the Diagnose & Fix tool in the HP app Desktop App.",
          "sectionId": "manual-357b08158ab1b21f6fa7"
        },
        {
          "id": "step-2",
          "text": "Follow the app’s onscreen checks: On Windows choose the wrench icon; on Mac use the printer dropdown.",
          "erases": false,
          "entry": "reliability-hp-offline",
          "sourceUrl": "https://support.hp.com/us-en/help/printer/printer-offline#hpProductContextPageTitle",
          "quote": "To use Diagnose & Fix:​ Open or download the application on Windows or Mac For Windows, select the (wrench) icon in the bottom left corner On Mac, tap the printer dropdown in the top menu bar Follow the onscreen instructions See full Diagnose and Fix instructions Download now Operating system not supported Requires Windows 10 or later, iOS 14 or later, Android 7.0 and later, or macOS 10.14 and later Still need help? Try these solutions.",
          "sectionId": "manual-63badfbe83bf9e17d6d2"
        }
      ],
      "end": {
        "maker": "HP",
        "supportUrl": "https://www.hp.com/us-en/tech-takes/printers/troubleshooting/why-is-my-hp-printer-offline.html",
        "freeLine": {
          "name": "HP accessibility",
          "phone": "(877) 656-7058",
          "hours": "Mon–Fri 11 AM–8 PM ET"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "hp-offline"
    },
    {
      "id": "reliability-iphone-storage",
      "title": "iPhone storage full",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "iphone",
        "ipad",
        "storage full",
        "out of space",
        "no storage"
      ],
      "firstQuestion": "Distinguish device storage from iCloud storage. Review each recommendation with the holder before removing anything.",
      "steps": [
        {
          "id": "step-1",
          "text": "Open Settings → General → [device] Storage to review usage and recommendations.",
          "erases": false,
          "entry": "reliability-iphone-storage",
          "sourceUrl": "https://support.apple.com/en-us/108429",
          "quote": "To view usage on your device, open Settings and tap General, then tap [device] Storage.",
          "sectionId": "manual-7e7d1f4c88c0366f1e7f"
        },
        {
          "id": "step-2",
          "text": "Tap an app’s name to inspect its storage before deciding what to change.",
          "erases": false,
          "entry": "reliability-iphone-storage",
          "sourceUrl": "https://support.apple.com/en-us/108429",
          "quote": "Tap an app's name for more information about its storage.",
          "sectionId": "manual-8efad6d3692635fef19b"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/en-us/108429",
        "freeLine": {
          "name": "Apple Accessibility",
          "phone": "1-877-204-3930",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "iphone-storage"
    },
    {
      "id": "reliability-iphone-wifi",
      "title": "iPhone Wi-Fi connection fails",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "iphone",
        "ipad",
        "no internet",
        "wifi drops",
        "wi-fi drops",
        "cannot connect"
      ],
      "firstQuestion": "Confirm other devices, network name and device version; the account holder enters any password.",
      "steps": [
        {
          "id": "step-1",
          "text": "Use Apple’s connection checks for the intended Wi-Fi network.",
          "erases": false,
          "entry": "reliability-iphone-wifi",
          "sourceUrl": "https://support.apple.com/en-us/111786",
          "quote": "pple · If you can't connect to Wi-Fi on your iPhone or iPad · Not stated on page\nIf you can't connect to Wi-Fi on your iPhone or iPad › Uninstall VPN and security software\nUninstall VPN and security software If you have VPN or security software installed: Uninstall the software.",
          "sectionId": "manual-4161282a563156d9d05e"
        },
        {
          "id": "step-2",
          "text": "Check the router connection before attempting device configuration changes.",
          "erases": false,
          "entry": "reliability-iphone-wifi",
          "sourceUrl": "https://support.apple.com/en-us/111786",
          "quote": "Check your router and network settings .",
          "sectionId": "manual-808f790fa33fae2ddfc5"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/en-us/111786",
        "freeLine": {
          "name": "Apple Accessibility",
          "phone": "1-877-204-3930",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "iphone-wifi"
    },
    {
      "id": "reliability-isp-stacked-routers",
      "title": "Slow internet behind the provider router",
      "devices": [
        "internet"
      ],
      "match": [
        "netgear",
        "nighthawk",
        "orbi",
        "slow",
        "behind",
        "double nat",
        "stacked"
      ],
      "firstQuestion": "Confirm both boxes are routers; a modem alone does not establish double NAT. Identify Fios versus Verizon Internet Gateway and any TV service before changing topology.",
      "steps": [
        {
          "id": "step-1",
          "text": "Check whether there are two routers doing network address translation.",
          "erases": false,
          "entry": "reliability-isp-stacked-routers",
          "sourceUrl": "https://kb.netgear.com/30186/What-is-Double-NAT",
          "quote": "For more information, see What is NAT (Network Address Translation)? Double NAT occurs when you connect your router to an ISP gateway or another router.",
          "sectionId": "manual-8d1e878c145f0e70ea20"
        },
        {
          "id": "step-2",
          "text": "Compare Wi-Fi and a wired Ethernet connection on the same device.",
          "erases": false,
          "entry": "reliability-isp-stacked-routers",
          "sourceUrl": "https://www.verizon.com/speedtest/",
          "quote": "If all else fails, try a wired connection with an ethernet cable.",
          "sectionId": "manual-f64d6d66d47c4fe2b4dd"
        },
        {
          "id": "step-3",
          "text": "If both devices are routers: For an ISP gateway, check its supported bridge mode; NETGEAR describes AP mode as the alternative.",
          "erases": false,
          "entry": "reliability-isp-stacked-routers",
          "sourceUrl": "https://kb.netgear.com/30187/",
          "quote": "To fix network problems with your Orbi or Nighthawk router when it is connected to an ISP gateway: If your Orbi or Nighthawk router is connected to an ISP gateway, you can resolve double NAT issues by putting your ISP gateway in bridge mode or turning the gateway's WiFi off and putting your Orbi or Nighthawk router in access point (AP) mode.",
          "sectionId": "manual-6cb447a9bc7a4ff20d89"
        },
        {
          "id": "step-4",
          "text": "Before changing modes: Check which router features are disabled before choosing AP mode.",
          "erases": false,
          "entry": "reliability-isp-stacked-routers",
          "sourceUrl": "https://kb.netgear.com/30187/",
          "quote": "Some router features are disabled in AP mode.",
          "sectionId": "manual-6cb447a9bc7a4ff20d89"
        }
      ],
      "end": {
        "maker": "NETGEAR",
        "supportUrl": "https://kb.netgear.com/30186/What-is-Double-NAT"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "isp-stacked-routers"
    },
    {
      "id": "reliability-magnifier-stuck",
      "title": "Windows Magnifier is stuck",
      "devices": [
        "computer",
        "screenReader"
      ],
      "match": [
        "windows",
        "magnifier stuck",
        "zoom stuck",
        "close magnifier",
        "turn off magnifier"
      ],
      "firstQuestion": "Confirm this is Windows Magnifier rather than browser zoom or another magnifier.",
      "steps": [
        {
          "id": "step-1",
          "text": "Press Windows key+Esc to turn Magnifier off.",
          "erases": false,
          "entry": "reliability-magnifier-stuck",
          "sourceUrl": "https://support.microsoft.com/en-us/accessibility/windows/windows-keyboard-shortcuts-for-accessibility#magnifier-keyboard-shortcuts-1",
          "quote": "Windows key+Plus sign (+) | Turn Magnifier on Windows key+Esc | Turn Magnifier off Windows key+Plus sign (+) or Minus sign (-) | When Magnifier is on, zoom in or out Ctrl+Alt+mouse scroll wheel | Zoom in and out using the mouse scroll wheel Windows key+Ctrl+M | Open Magnifier settings Ctrl+Alt+arrow keys | Pan in the direction of the arrow keys Ctrl+Alt+I | Invert colors Ctrl+Alt+F | Switch to full screen view Ctrl+Alt+L | Switch to lens view Ctrl+Alt+D | Switch to docked view Ctrl+Alt+M | Cycle through views Ctrl+Alt+R | Resize the lens with the mouse Shift+Alt+arrow keys",
          "sectionId": "manual-1b7c5359dca9a473ba9d"
        },
        {
          "id": "step-2",
          "text": "If it keeps starting: Use Windows key+Ctrl+M to inspect Magnifier settings.",
          "erases": false,
          "entry": "reliability-magnifier-stuck",
          "sourceUrl": "https://support.microsoft.com/en-us/accessibility/windows/windows-keyboard-shortcuts-for-accessibility#magnifier-keyboard-shortcuts-1",
          "quote": "Windows key+Plus sign (+) | Turn Magnifier on Windows key+Esc | Turn Magnifier off Windows key+Plus sign (+) or Minus sign (-) | When Magnifier is on, zoom in or out Ctrl+Alt+mouse scroll wheel | Zoom in and out using the mouse scroll wheel Windows key+Ctrl+M | Open Magnifier settings Ctrl+Alt+arrow keys | Pan in the direction of the arrow keys Ctrl+Alt+I | Invert colors Ctrl+Alt+F | Switch to full screen view Ctrl+Alt+L | Switch to lens view Ctrl+Alt+D | Switch to docked view Ctrl+Alt+M | Cycle through views Ctrl+Alt+R | Resize the lens with the mouse Shift+Alt+arrow keys",
          "sectionId": "manual-1b7c5359dca9a473ba9d"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://support.microsoft.com/en-us/accessibility/windows/windows-keyboard-shortcuts-for-accessibility#magnifier-keyboard-shortcuts-1",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "magnifier-stuck"
    },
    {
      "id": "reliability-netgear-ap",
      "title": "NETGEAR access point mode",
      "devices": [
        "internet"
      ],
      "match": [
        "netgear",
        "nighthawk",
        "ap mode",
        "access point"
      ],
      "firstQuestion": "Identify the model; Orbi has a separate procedure. The holder signs in personally, with consent to disconnect devices.",
      "steps": [
        {
          "id": "step-1",
          "text": "For the matching model: Select ADVANCED → Advanced Setup → Wireless AP. Pro Gaming models use Settings → Setup → Wireless AP.",
          "erases": false,
          "entry": "reliability-netgear-ap",
          "sourceUrl": "https://kb.netgear.com/20927/How-do-I-change-my-NETGEAR-router-to-AP-mode",
          "quote": "Select ADVANCED > Advanced Setup > Wireless AP .",
          "sectionId": "manual-50072276dc1dfdf5cdcf"
        },
        {
          "id": "step-2",
          "text": "After confirming the model: Select AP Mode; dynamically assigned addresses are the default.",
          "erases": false,
          "entry": "reliability-netgear-ap",
          "sourceUrl": "https://kb.netgear.com/20927/How-do-I-change-my-NETGEAR-router-to-AP-mode",
          "quote": "Select AP Mode .",
          "sectionId": "manual-50072276dc1dfdf5cdcf"
        },
        {
          "id": "step-3",
          "text": "Review the address change before applying; reconnect to the new address afterwards.",
          "erases": false,
          "entry": "reliability-netgear-ap",
          "sourceUrl": "https://kb.netgear.com/20927/How-do-I-change-my-NETGEAR-router-to-AP-mode",
          "quote": "Options to Choose IP Address settings on this access point appear.",
          "sectionId": "manual-50072276dc1dfdf5cdcf"
        }
      ],
      "end": {
        "maker": "NETGEAR",
        "supportUrl": "https://kb.netgear.com/20927/How-do-I-change-my-NETGEAR-router-to-AP-mode"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "netgear-ap"
    },
    {
      "id": "reliability-nvda-silent",
      "title": "NVDA speech is silent",
      "devices": [
        "computer",
        "screenReader"
      ],
      "match": [
        "nvda",
        "silent",
        "no speech",
        "not talking",
        "stopped talking"
      ],
      "firstQuestion": "Confirm NVDA is running and which speech mode is selected; check system audio separately.",
      "steps": [
        {
          "id": "step-1",
          "text": "Check the speech mode; Talk is the normal speaking mode.",
          "erases": false,
          "entry": "reliability-nvda-silent",
          "sourceUrl": "https://download.nvaccess.org/documentation/userGuide.html#SpeechModes",
          "quote": "The four available speech modes are: Talk (Default): NVDA will speak normally in reaction to screen changes, notifications, and actions such as moving the focus, or issuing commands.",
          "sectionId": "manual-1b0ee057ea048b051b69"
        },
        {
          "id": "step-2",
          "text": "Check whether speech is in Off mode before treating it as a hardware fault.",
          "erases": false,
          "entry": "reliability-nvda-silent",
          "sourceUrl": "https://download.nvaccess.org/documentation/userGuide.html#SpeechModes",
          "quote": "Off: NVDA will not speak anything, however unlike sleep mode, it will silently react to commands.",
          "sectionId": "manual-1b0ee057ea048b051b69"
        }
      ],
      "end": {
        "maker": "NV Access",
        "supportUrl": "https://download.nvaccess.org/documentation/userGuide.html#SpeechModes"
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "nvda-silent"
    },
    {
      "id": "reliability-verizon-passthrough",
      "title": "Verizon Internet Gateway passthrough",
      "devices": [
        "internet"
      ],
      "match": [
        "verizon internet gateway",
        "bridge",
        "passthrough",
        "own router"
      ],
      "firstQuestion": "This is the Verizon Internet Gateway article, not a generic Fios procedure. Obtain permission to interrupt service.",
      "steps": [
        {
          "id": "step-1",
          "text": "Before enabling passthrough: Check the consequences: Wi-Fi radios turn off, passthrough uses LAN2, and Wi-Fi/LAN1 lose internet.",
          "erases": false,
          "entry": "reliability-verizon-passthrough",
          "sourceUrl": "https://www.verizon.com/support/knowledge-base-301824/",
          "quote": "When enabling IP passthrough: All Wi-Fi radios are automatically turn off (and re-enabled upon turn off IP passthrough).",
          "sectionId": "manual-7d4d4602afda9e7f29f3"
        },
        {
          "id": "step-2",
          "text": "Only for the matching gateway: Use the gateway article for its IP Passthrough checkbox and Save Changes.",
          "erases": false,
          "entry": "reliability-verizon-passthrough",
          "sourceUrl": "https://www.verizon.com/support/knowledge-base-301824/",
          "quote": "From the 'Bridge' section, click the IP Passthrough checkbox then click Save Changes .",
          "sectionId": "manual-e648a10c3ebffe095371"
        }
      ],
      "end": {
        "maker": "Verizon",
        "supportUrl": "https://www.verizon.com/support/knowledge-base-301824/",
        "freeLine": {
          "name": "Verizon Center for Customers with Disabilities (Fios)",
          "phone": "800-974-6006 (voice/TTY)",
          "hours": "Mon–Fri 8:30 AM–5 PM ET"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "verizon-passthrough"
    },
    {
      "id": "reliability-voiceover-silent",
      "title": "iPhone VoiceOver speech is silent",
      "devices": [
        "computer",
        "screenReader"
      ],
      "match": [
        "iphone",
        "ipad",
        "voiceover silent",
        "voiceover stopped talking",
        "voiceover not talking",
        "voiceover no speech"
      ],
      "firstQuestion": "Confirm VoiceOver is already enabled and whether Zoom is enabled; the gesture differs with Zoom.",
      "steps": [
        {
          "id": "step-1",
          "text": "With VoiceOver on, use the three-finger double tap to toggle mute; with Zoom also on, use the three-finger triple tap.",
          "erases": false,
          "entry": "reliability-voiceover-silent",
          "sourceUrl": "https://support.apple.com/guide/iphone/use-voiceover-gestures-iph3e2e2281/ios",
          "quote": "Mute or unmute VoiceOver | Three-finger double tap.",
          "sectionId": "manual-49a6fc0d889851f47e75"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/guide/iphone/use-voiceover-gestures-iph3e2e2281/ios",
        "freeLine": {
          "name": "Apple Accessibility",
          "phone": "1-877-204-3930",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "voiceover-silent"
    },
    {
      "id": "reliability-windows-no-internet",
      "title": "Windows cannot connect to Wi-Fi",
      "devices": [
        "internet"
      ],
      "match": [
        "windows",
        "no internet",
        "wifi drops",
        "wi-fi drops",
        "cannot connect",
        "cant connect"
      ],
      "firstQuestion": "Confirm Windows version and whether other devices also fail; use safe checks before network changes.",
      "steps": [
        {
          "id": "step-1",
          "text": "Open quick settings, select Manage Wi-Fi connections, choose the intended network and Connect.",
          "erases": false,
          "entry": "reliability-windows-no-internet",
          "sourceUrl": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/connect-to-a-wi-fi-network-in-windows#connect-to-a-wi-fi-network",
          "quote": "On the Wi-Fi quick setting, select Manage Wi-Fi connections .",
          "sectionId": "manual-dc7e3231af120deca665"
        },
        {
          "id": "step-2",
          "text": "If the connection still fails: Run the Windows network troubleshooter for the matching version.",
          "erases": false,
          "entry": "reliability-windows-no-internet",
          "sourceUrl": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/fix-wi-fi-connection-issues-in-windows#run-the-network-troubleshooter",
          "quote": "Fix Wi-Fi connection issues in Windows › Run the Network troubleshooter\nRun the Network troubleshooter If you are using a Windows 11 device, start by running the automated Network and Internet troubleshooter in the Get Help app.",
          "sectionId": "manual-abc142e78cbaaed91d83"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://support.microsoft.com/en-us/windows/experience/connectivity-networking/connect-to-a-wi-fi-network-in-windows#connect-to-a-wi-fi-network",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Manufacturer passages checked 12 Oct 2026",
      "confidence": "medium",
      "decisionGuideId": "windows-no-internet"
    },
    {
      "id": "samsung-slow-frozen",
      "title": "Samsung Galaxy is frozen, slow or overheating",
      "devices": [
        "phone",
        "tablet"
      ],
      "match": [
        "samsung",
        "galaxy",
        "frozen",
        "slow",
        "hot",
        "overheating",
        "stuck"
      ],
      "steps": [
        {
          "id": "force-restart",
          "text": "Hold Volume down and the Side key together until the phone restarts.",
          "erases": false,
          "entry": "samsung-restart-device-care"
        },
        {
          "id": "device-care",
          "text": "Settings, Device Care (Battery and device care): run the optimize check.",
          "erases": false,
          "entry": "samsung-restart-device-care"
        },
        {
          "id": "safe-mode",
          "text": "Restart in safe mode to see whether an app is the cause, then restart normally.",
          "erases": false,
          "entry": "samsung-restart-device-care"
        },
        {
          "id": "update",
          "text": "Settings, Software update, Download and install (on Wi-Fi, with a charger).",
          "erases": false,
          "entry": "samsung-restart-device-care"
        },
        {
          "id": "factory-reset",
          "text": "Back up with Smart Switch, check the Google and Samsung passwords, then factory reset.",
          "erases": true,
          "warning": "This erases everything on the phone; Smart Switch puts it back.",
          "entry": "samsung-factory-reset"
        }
      ],
      "end": {
        "maker": "Samsung",
        "supportUrl": "https://www.samsung.com/us/support/contact/",
        "freeLine": {
          "name": "Samsung",
          "phone": "1-800-SAMSUNG (726-7864)",
          "hours": "Hours not listed in the catalog"
        }
      },
      "version": "One UI (Samsung pages Oct 2026)",
      "confidence": "medium"
    },
    {
      "id": "spectrum-internet-down",
      "title": "Spectrum internet is down or very slow",
      "devices": [
        "internet"
      ],
      "match": [
        "spectrum",
        "internet down",
        "no internet",
        "outage",
        "modem",
        "slow internet",
        "router"
      ],
      "firstQuestion": "Is the internet down on every device in the apartment, or just one?",
      "steps": [
        {
          "id": "other-devices",
          "text": "Check two or three devices; if only one is affected, follow that device's Wi-Fi flow.",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "unplug-both",
          "text": "Unplug the modem and the router for a full minute; don't press or hold any button.",
          "erases": false,
          "entry": "spectrum-restart-modem-router"
        },
        {
          "id": "modem-first",
          "text": "Plug the modem in first and wait 2 to 5 minutes, then plug in the router.",
          "erases": false,
          "entry": "spectrum-restart-modem-router"
        },
        {
          "id": "outage",
          "text": "Check for an outage: ask a neighbor, the My Spectrum app on mobile data, or Spectrum's 24/7 line.",
          "erases": false,
          "entry": "internet-outage-check"
        },
        {
          "id": "speed-test",
          "text": "Run Spectrum's speed test near the router and the app's Internet check on the same device.",
          "erases": false,
          "entry": "slow-dropping-wifi"
        }
      ],
      "end": {
        "maker": "Spectrum",
        "supportUrl": "https://www.spectrum.com/choose-spectrum/access",
        "freeLine": {
          "name": "Spectrum Disability Support",
          "phone": "844-762-1301",
          "hours": "Hours not listed in the catalog (internet support 888-369-2408 is 24/7)"
        }
      },
      "version": "Spectrum pages (Sep–Oct 2026)",
      "confidence": "high"
    },
    {
      "id": "talkback-on-off",
      "title": "Turn TalkBack on or off on Android",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "match": [
        "talkback",
        "talking",
        "screen reader",
        "phone talks",
        "double tap",
        "voice assistant"
      ],
      "firstQuestion": "Is TalkBack on now — does the phone speak when you touch the screen?",
      "steps": [
        {
          "id": "volume-keys",
          "text": "If the shortcut is set up, press and hold both volume keys for about 3 seconds.",
          "erases": false,
          "entry": "talkback-turn-on-gestures"
        },
        {
          "id": "assistant",
          "text": "Ask the phone's assistant: “Turn on TalkBack” (or “Turn off TalkBack”).",
          "erases": false,
          "entry": "talkback-turn-on-gestures"
        },
        {
          "id": "settings",
          "text": "Settings, Accessibility, TalkBack: Use TalkBack. With TalkBack on, tap the switch once and double-tap to change it.",
          "erases": false,
          "entry": "talkback-turn-on-gestures"
        },
        {
          "id": "double-tap",
          "text": "Remind the tenant: with TalkBack on, touch to hear and double-tap to press.",
          "erases": false,
          "entry": "talkback-turn-on-gestures"
        },
        {
          "id": "tutorial",
          "text": "Open TalkBack's tutorial in its settings to practise safely.",
          "erases": false,
          "entry": "talkback-turn-on-gestures"
        }
      ],
      "end": {
        "maker": "Google",
        "supportUrl": "https://support.google.com/accessibility/answer/7641084?hl=en"
      },
      "version": "Android 16; TalkBack 17.0",
      "confidence": "medium"
    },
    {
      "id": "verizon-internet-down",
      "title": "Verizon Fios internet is down or very slow",
      "devices": [
        "internet"
      ],
      "match": [
        "verizon",
        "fios",
        "internet down",
        "no internet",
        "outage",
        "router",
        "slow internet"
      ],
      "firstQuestion": "Is the internet down on every device in the apartment, or just one?",
      "steps": [
        {
          "id": "other-devices",
          "text": "Check two or three devices; if only one is affected, follow that device's Wi-Fi flow.",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "unplug-router",
          "text": "Unplug the Verizon router for a full minute and plug it back in; never press the reset pinhole.",
          "erases": false,
          "entry": "verizon-fios-restart-router"
        },
        {
          "id": "outage",
          "text": "Check Verizon's outage page or the Verizon Home app on mobile data.",
          "erases": false,
          "entry": "internet-outage-check"
        },
        {
          "id": "speed-test",
          "text": "Run Verizon's speed test near the router and the app's Internet check on the same device.",
          "erases": false,
          "entry": "slow-dropping-wifi"
        }
      ],
      "end": {
        "maker": "Verizon",
        "supportUrl": "https://www.verizon.com/about/accessibility/contact-us",
        "freeLine": {
          "name": "Verizon Center for Customers with Disabilities",
          "phone": "800-974-6006 (voice/TTY)",
          "hours": "Mon–Fri 8:30 AM–5 PM ET"
        }
      },
      "version": "Verizon CR1000A/B and G3100 (Oct 2026)",
      "confidence": "high"
    },
    {
      "id": "voiceover-iphone-on-off",
      "title": "Turn VoiceOver on or off on an iPhone or iPad",
      "devices": [
        "phone",
        "tablet",
        "screenReader"
      ],
      "match": [
        "voiceover",
        "voice over",
        "talking",
        "screen reader",
        "phone talks",
        "double tap",
        "won't let me tap",
        "speaks"
      ],
      "firstQuestion": "Is VoiceOver on now — does the phone speak when you touch the screen?",
      "steps": [
        {
          "id": "siri",
          "text": "Ask Siri: “Turn on VoiceOver” (or “Turn off VoiceOver”).",
          "erases": false,
          "entry": "voiceover-iphone-turn-on"
        },
        {
          "id": "triple-click",
          "text": "If the Accessibility Shortcut is set to VoiceOver, press the side button (or the Home button) three times quickly.",
          "erases": false,
          "entry": "voiceover-iphone-turn-on"
        },
        {
          "id": "settings",
          "text": "Settings, Accessibility, VoiceOver: turn it on. While it is on, tap the switch once and then double-tap to change it.",
          "erases": false,
          "entry": "voiceover-iphone-turn-on"
        },
        {
          "id": "double-tap",
          "text": "Remind the tenant: with VoiceOver on, one tap speaks and a double-tap presses.",
          "erases": false,
          "entry": "voiceover-iphone-gestures"
        },
        {
          "id": "screen-curtain",
          "text": "Screen black but the phone talks: a three-finger triple-tap turns Screen Curtain off.",
          "erases": false,
          "entry": "voiceover-iphone-turn-on"
        },
        {
          "id": "practice",
          "text": "Open VoiceOver Practice in the VoiceOver settings to try the gestures safely.",
          "erases": false,
          "entry": "voiceover-iphone-turn-on"
        }
      ],
      "end": {
        "maker": "Apple",
        "supportUrl": "https://support.apple.com/en-us/111749",
        "freeLine": {
          "name": "Apple Accessibility",
          "phone": "1-877-204-3930",
          "hours": "Hours not listed in the catalog; any relay service works"
        }
      },
      "version": "iOS/iPadOS 27",
      "confidence": "high"
    },
    {
      "id": "windows-no-sound",
      "title": "Windows computer has no sound",
      "devices": [
        "computer",
        "speaker",
        "screenReader"
      ],
      "match": [
        "no sound",
        "sound",
        "audio",
        "speakers",
        "can't hear",
        "cant hear",
        "volume",
        "headphones",
        "bluetooth"
      ],
      "steps": [
        {
          "id": "volume-mute",
          "text": "Check the volume and mute on the speaker icon, and on the speakers or headphones.",
          "erases": false,
          "entry": "windows-sound-bluetooth"
        },
        {
          "id": "output-device",
          "text": "Pick the right output device from the speaker icon's list.",
          "erases": false,
          "entry": "windows-sound-bluetooth"
        },
        {
          "id": "troubleshooter",
          "text": "Run the audio troubleshooter in the Get Help app.",
          "erases": false,
          "entry": "windows-sound-bluetooth"
        },
        {
          "id": "bluetooth-repair",
          "text": "If it's a Bluetooth speaker or headphones: remove the device and pair it again.",
          "erases": false,
          "entry": "windows-sound-bluetooth"
        },
        {
          "id": "restart-update",
          "text": "Restart the computer and check Windows Update for driver updates.",
          "erases": false,
          "entry": "windows-sound-bluetooth"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://www.microsoft.com/en-us/accessibility/disability-answer-desk",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "confidence": "high"
    },
    {
      "id": "windows-print-job-stuck",
      "title": "A print job is stuck on Windows",
      "devices": [
        "printer",
        "computer"
      ],
      "match": [
        "stuck",
        "print queue",
        "won't print",
        "wont print",
        "printing",
        "spooler",
        "printer"
      ],
      "steps": [
        {
          "id": "cancel-jobs",
          "text": "Open the printer's print queue (Settings, Bluetooth & devices, Printers & scanners) and cancel every document.",
          "erases": false,
          "entry": "windows-printer-queue"
        },
        {
          "id": "printer-off-on",
          "text": "Turn the printer off and on.",
          "erases": false,
          "entry": "windows-printer-queue"
        },
        {
          "id": "restart-spooler",
          "text": "Restart the Print Spooler service (Start search: Services, Print Spooler, Restart).",
          "erases": false,
          "entry": "windows-printer-queue"
        },
        {
          "id": "troubleshooter",
          "text": "Run the printer troubleshooter in the Get Help app.",
          "erases": false,
          "entry": "windows-printer-queue"
        },
        {
          "id": "restart-pc",
          "text": "Restart the computer and print a test page.",
          "erases": false,
          "entry": "windows-printer-queue"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://www.microsoft.com/en-us/accessibility/disability-answer-desk",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "confidence": "medium"
    },
    {
      "id": "windows-slow",
      "title": "Windows computer is slow",
      "devices": [
        "computer"
      ],
      "match": [
        "slow",
        "takes forever",
        "sluggish",
        "laptop slow",
        "computer slow",
        "full",
        "storage"
      ],
      "steps": [
        {
          "id": "restart",
          "text": "Restart (not Shut down) and try again.",
          "erases": false,
          "entry": "windows-slow-storage"
        },
        {
          "id": "updates",
          "text": "Install waiting updates and restart.",
          "erases": false,
          "entry": "windows-slow-storage"
        },
        {
          "id": "startup-apps",
          "text": "Settings, Apps, Startup: turn off programs the tenant doesn't need at startup.",
          "erases": false,
          "entry": "windows-slow-storage"
        },
        {
          "id": "security-scan",
          "text": "Run a quick scan in Windows Security.",
          "erases": false,
          "entry": "windows-slow-storage"
        },
        {
          "id": "storage-review",
          "text": "Settings, System, Storage: go through the cleanup recommendations with the tenant.",
          "erases": false,
          "entry": "windows-slow-storage"
        },
        {
          "id": "maker-tool",
          "text": "Run the maker's tool: SupportAssist (Dell), HP Support Assistant, or Lenovo Vantage.",
          "erases": false,
          "entry": "windows-slow-storage"
        },
        {
          "id": "storage-sense",
          "text": "Turn on Storage Sense, after checking the Recycle Bin and Downloads with the tenant.",
          "erases": true,
          "warning": "This erases temporary files and, depending on its settings, old files in the Recycle Bin and Downloads.",
          "entry": "windows-slow-storage"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://www.microsoft.com/en-us/accessibility/disability-answer-desk",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "confidence": "medium"
    },
    {
      "id": "windows-wifi-no-internet",
      "title": "Windows computer has no internet or won't connect to Wi-Fi",
      "devices": [
        "computer",
        "internet"
      ],
      "match": [
        "wi-fi",
        "wifi",
        "no internet",
        "won't connect",
        "internet",
        "network",
        "connected no internet",
        "laptop"
      ],
      "firstQuestion": "Do other devices in the apartment have internet right now?",
      "steps": [
        {
          "id": "other-devices",
          "text": "Check whether other devices in the apartment have internet; if none do, it's the internet, not the computer.",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "wifi-on",
          "text": "Network icon by the clock: Wi-Fi on, Airplane mode off, the right network.",
          "erases": false,
          "entry": "windows-wifi-fix"
        },
        {
          "id": "restart-pc",
          "text": "Restart the computer.",
          "erases": false,
          "entry": "windows-wifi-fix"
        },
        {
          "id": "restart-router",
          "text": "Unplug the modem and router for a full minute, then plug them back in (modem first).",
          "erases": false,
          "entry": "connected-no-internet"
        },
        {
          "id": "troubleshooter",
          "text": "Run the network troubleshooter in the Get Help app.",
          "erases": false,
          "entry": "windows-wifi-fix"
        },
        {
          "id": "forget-rejoin",
          "text": "Forget the network (Manage known networks) and connect again with the password in hand.",
          "erases": false,
          "entry": "windows-wifi-fix"
        },
        {
          "id": "network-reset",
          "text": "Network reset (Settings, Network & internet, Advanced network settings), with the Wi-Fi password ready.",
          "erases": true,
          "warning": "This erases every saved Wi-Fi network and password on the computer.",
          "entry": "windows-wifi-fix"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://www.microsoft.com/en-us/accessibility/disability-answer-desk",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Windows 11 24H2/25H2 and Windows 10",
      "confidence": "high"
    },
    {
      "id": "windows-wont-start",
      "title": "Windows computer won't turn on or won't start",
      "devices": [
        "computer"
      ],
      "match": [
        "won't turn on",
        "wont turn on",
        "won't start",
        "wont start",
        "no power",
        "black screen",
        "dead",
        "boot"
      ],
      "firstQuestion": "Is there any light or sound when you press the power button?",
      "steps": [
        {
          "id": "power",
          "text": "Check the charger or cord, the outlet (try a lamp), and any charger light; let a laptop charge.",
          "erases": false,
          "entry": "windows-wont-start"
        },
        {
          "id": "screen",
          "text": "Desktop: check the monitor and its cable; press Windows logo key + Ctrl + Shift + B.",
          "erases": false,
          "entry": "windows-wont-start"
        },
        {
          "id": "unplug-extras",
          "text": "Unplug USB drives, printers and discs, and try again.",
          "erases": false,
          "entry": "windows-wont-start"
        },
        {
          "id": "maker-diagnostics",
          "text": "Run the maker's diagnostics: F12 at the Dell logo; HP PC Hardware Diagnostics; F10 on a ThinkPad or the Novo button on an IdeaPad.",
          "erases": false,
          "entry": "windows-wont-start"
        },
        {
          "id": "startup-repair",
          "text": "From Windows' recovery screens, choose Startup Repair.",
          "erases": false,
          "entry": "windows-wont-start"
        },
        {
          "id": "safe-mode",
          "text": "Try Safe Mode from Startup Settings (stop if it asks for a BitLocker key you don't have).",
          "erases": false,
          "entry": "windows-wont-start"
        },
        {
          "id": "system-restore",
          "text": "System Restore to an earlier day (files stay; later apps and drivers are removed).",
          "erases": false,
          "entry": "windows-wont-start"
        },
        {
          "id": "reset-pc",
          "text": "Reset this PC with “Keep my files”, after a backup and with the tenant's clear OK.",
          "erases": true,
          "warning": "This erases apps and settings (and the tenant's files with “Remove everything”).",
          "entry": "windows-wont-start"
        }
      ],
      "end": {
        "maker": "Microsoft",
        "supportUrl": "https://www.microsoft.com/en-us/accessibility/disability-answer-desk",
        "freeLine": {
          "name": "Microsoft Disability Answer Desk",
          "phone": "1-800-936-5900",
          "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT"
        }
      },
      "version": "Windows 11 24H2/25H2 and Windows 10; Dell, HP, Lenovo",
      "confidence": "medium"
    }
  ],
  "freeHelp": {
    "catalogDate": "2026-10-10",
    "catalogVersion": "Tech Wizard Library — Source Catalog v2",
    "lines": [
      {
        "id": "apple-accessibility",
        "who": "Apple Accessibility",
        "phones": [
          "1-877-204-3930"
        ],
        "url": "https://support.apple.com/en-us/111749",
        "note": "Any relay service works.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Apple",
        "helps": [
          "phone",
          "tablet",
          "computer",
          "tv",
          "speaker",
          "screenReader"
        ]
      },
      {
        "id": "apple-today-voiceover",
        "who": "Apple in-store session: “Get Started: VoiceOver on iPhone and iPad”",
        "phones": [],
        "url": "https://www.apple.com/today/event/get-started-voiceover-on-iphone-ipad/",
        "note": "Free session; bring a device or use theirs.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Apple",
        "helps": [
          "phone",
          "tablet",
          "screenReader"
        ]
      },
      {
        "id": "apple-support",
        "who": "Apple Support",
        "phones": [
          "1-800-275-2273"
        ],
        "url": "https://support.apple.com/HT201232",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Apple",
        "helps": [
          "phone",
          "tablet",
          "computer",
          "tv",
          "speaker"
        ],
        "note": "Hours not listed in the catalog."
      },
      {
        "id": "microsoft-disability-answer-desk",
        "who": "Microsoft Disability Answer Desk",
        "phones": [
          "1-800-936-5900",
          "1-503-427-1234 (ASL)"
        ],
        "url": "https://www.microsoft.com/en-us/accessibility/disability-answer-desk",
        "hours": "Mon–Fri 5 AM–9 PM PT; weekends 6 AM–5 PM PT",
        "note": "Also reachable through Be My Eyes.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Microsoft",
        "helps": [
          "computer",
          "screenReader",
          "printer",
          "internet",
          "other"
        ]
      },
      {
        "id": "microsoft-contact",
        "who": "Microsoft Support (chat)",
        "phones": [],
        "url": "https://support.microsoft.com/contactus",
        "note": "Chat; no phone number listed.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Microsoft",
        "helps": [
          "computer",
          "other"
        ]
      },
      {
        "id": "google-disability-support",
        "who": "Google Disability Support",
        "phones": [],
        "url": "https://support.google.com/accessibility/answer/7641084?hl=en",
        "hours": "4 AM–7 PM PT weekdays",
        "note": "Phone, chat, Be My Eyes and ASL; the number is on Google's page.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Google",
        "helps": [
          "phone",
          "tablet",
          "speaker",
          "tv",
          "screenReader"
        ]
      },
      {
        "id": "samsung",
        "who": "Samsung",
        "phones": [
          "1-800-SAMSUNG (726-7864)"
        ],
        "url": "https://www.samsung.com/us/support/contact/",
        "note": "No separate accessibility line.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Samsung",
        "helps": [
          "phone",
          "tablet",
          "tv"
        ]
      },
      {
        "id": "hp-accessibility",
        "who": "HP accessibility",
        "phones": [
          "(877) 656-7058"
        ],
        "url": "https://www.hp.com/us-en/hp-information/accessibility-aging/need-help.html",
        "hours": "Mon–Fri 11 AM–8 PM ET",
        "kind": "maker",
        "nonprofit": false,
        "maker": "HP",
        "helps": [
          "computer",
          "printer"
        ]
      },
      {
        "id": "dell-support",
        "who": "Dell Support",
        "phones": [],
        "url": "https://www.dell.com/support/contents/en-us/category/contact-information",
        "note": "Technical support by online form; no phone line in the catalog.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Dell",
        "helps": [
          "computer"
        ]
      },
      {
        "id": "lenovo-support",
        "who": "Lenovo Support",
        "phones": [],
        "url": "https://support.lenovo.com/us/en/",
        "note": "No phone line in the catalog.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Lenovo",
        "helps": [
          "computer"
        ]
      },
      {
        "id": "spectrum-disability",
        "who": "Spectrum Disability Support",
        "phones": [
          "844-762-1301"
        ],
        "url": "https://www.spectrum.com/choose-spectrum/access",
        "note": "Can turn on guide narration remotely.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Spectrum",
        "helps": [
          "internet",
          "tv"
        ]
      },
      {
        "id": "spectrum-internet",
        "who": "Spectrum internet support",
        "phones": [
          "888-369-2408"
        ],
        "url": "https://www.spectrum.com/contact-spectrum",
        "hours": "24/7",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Spectrum",
        "helps": [
          "internet"
        ]
      },
      {
        "id": "verizon-disabilities",
        "who": "Verizon Center for Customers with Disabilities (Fios)",
        "phones": [
          "800-974-6006 (voice/TTY)",
          "508-251-5301 (ASL)"
        ],
        "url": "https://www.verizon.com/about/accessibility/contact-us",
        "hours": "Mon–Fri 8:30 AM–5 PM ET",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Verizon",
        "helps": [
          "internet",
          "tv"
        ]
      },
      {
        "id": "freedom-scientific-support",
        "who": "Freedom Scientific (Vispero) technical support",
        "phones": [
          "727-803-8600"
        ],
        "url": "https://support.freedomscientific.com/forms/techsupport",
        "hours": "Hardware: Mon–Fri 8:30–5 ET",
        "note": "Software support only with a current maintenance agreement or subscription.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Freedom Scientific",
        "helps": [
          "screenReader",
          "other"
        ]
      },
      {
        "id": "freedom-scientific-training",
        "who": "Freedom Scientific free training (webinars, recorded webinars, podcast)",
        "phones": [],
        "url": "https://www.freedomscientific.com/training/freewebinars/",
        "note": "Free. Recorded webinars and the weekly podcast are on the training center.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Vispero",
        "helps": [
          "screenReader",
          "computer"
        ]
      },
      {
        "id": "nvda",
        "who": "NV Access (NVDA)",
        "phones": [],
        "url": "https://www.nvaccess.org/get-help/",
        "note": "NVDA and its User Guide are free; training and phone support are paid.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "NV Access",
        "helps": [
          "screenReader",
          "computer"
        ]
      },
      {
        "id": "nls",
        "who": "NLS (Library of Congress)",
        "phones": [
          "888-657-7323"
        ],
        "url": "https://www.loc.gov/nls/find-your-library/",
        "hours": "Mon–Fri 9:30–4 ET",
        "note": "Connects to the local library.",
        "kind": "government",
        "nonprofit": false,
        "maker": "NLS",
        "helps": [
          "other"
        ]
      },
      {
        "id": "heiskell",
        "who": "Andrew Heiskell Braille and Talking Book Library (NYPL), 40 W. 20th St.",
        "phones": [
          "212-206-5400"
        ],
        "url": "https://www.nypl.org/about/locations/heiskell",
        "hours": "Mon/Wed/Fri/Sat 10–5; Tue/Thu 12–7",
        "note": "Manhattan's talking-book library in the NLS network.",
        "kind": "government",
        "nonprofit": false,
        "maker": "NYPL",
        "helps": [
          "other"
        ]
      },
      {
        "id": "humanware",
        "who": "HumanWare",
        "phones": [
          "1-800-722-3393"
        ],
        "url": "https://www.humanware.com/support/",
        "note": "US repair center, Stuart FL.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "HumanWare",
        "helps": [
          "other",
          "screenReader",
          "printer"
        ]
      },
      {
        "id": "index-through-humanware",
        "who": "Index Braille (US and Canada through HumanWare)",
        "phones": [
          "1-800-722-3393"
        ],
        "url": "https://indexbraille.com/contact/",
        "note": "HumanWare is Index's US and Canada distributor; the number is HumanWare's line.",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Index",
        "helps": [
          "printer"
        ]
      },
      {
        "id": "selvas-blv",
        "who": "SELVAS BLV (BrailleSense)",
        "phones": [
          "888-520-4467"
        ],
        "email": "support@selvasblv.com",
        "url": "https://selvasblv.com/technicalsupport",
        "kind": "maker",
        "nonprofit": false,
        "maker": "SELVAS BLV",
        "helps": [
          "other",
          "screenReader"
        ],
        "note": "Hours not listed in the catalog."
      },
      {
        "id": "aph",
        "who": "APH",
        "phones": [
          "1-800-223-1839"
        ],
        "url": "https://www.aph.org/customer-service/",
        "hours": "Mon–Fri 8–8 ET",
        "kind": "maker",
        "nonprofit": false,
        "maker": "APH",
        "helps": [
          "other",
          "screenReader",
          "printer"
        ]
      },
      {
        "id": "orbit-research",
        "who": "Orbit Research",
        "phones": [
          "1-888-606-7248"
        ],
        "email": "techsupport@orbitresearch.com",
        "url": "https://www.orbitresearch.com/support/",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Orbit Research",
        "helps": [
          "other",
          "screenReader"
        ],
        "note": "Hours not listed in the catalog."
      },
      {
        "id": "eschenbach",
        "who": "Eschenbach",
        "phones": [
          "800-487-5389"
        ],
        "url": "https://eschenbach.com/resource-center/user-manuals.asp",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Eschenbach",
        "helps": [
          "other"
        ],
        "note": "Hours not listed in the catalog."
      },
      {
        "id": "orcam",
        "who": "OrCam",
        "phones": [
          "1-800-713-3741"
        ],
        "url": "https://orcam.helpjuice.com/myeye-resources/orcam-myeye-3-user-guide",
        "kind": "maker",
        "nonprofit": false,
        "maker": "OrCam",
        "helps": [
          "other"
        ],
        "note": "Hours not listed in the catalog."
      },
      {
        "id": "viewplus",
        "who": "ViewPlus",
        "phones": [
          "1-866-836-2184"
        ],
        "email": "support@viewplus.com",
        "url": "https://support.viewplus.com/kb/faq.php?id=42",
        "kind": "maker",
        "nonprofit": false,
        "maker": "ViewPlus",
        "helps": [
          "printer"
        ],
        "note": "Hours not listed in the catalog."
      },
      {
        "id": "duxbury",
        "who": "Duxbury Systems (DBT)",
        "phones": [
          "+1-978-692-3000"
        ],
        "email": "support@duxsys.com",
        "url": "https://duxburysystems.com/contact.asp",
        "kind": "maker",
        "nonprofit": false,
        "maker": "Duxbury",
        "helps": [
          "printer",
          "computer"
        ],
        "note": "Hours not listed in the catalog."
      },
      {
        "id": "be-my-eyes",
        "who": "Be My Eyes",
        "phones": [],
        "url": "https://www.bemyeyes.com/",
        "note": "Free volunteer video calls; companies' help desks inside the app.",
        "kind": "app",
        "nonprofit": false,
        "maker": "Be My Eyes",
        "helps": "all"
      },
      {
        "id": "aira",
        "who": "Aira",
        "phones": [],
        "url": "https://aira.io/explorer-tips-how-to-get-free-aira-minutes/",
        "note": "Free tier: 5 free minutes every 48 hours, and 3 welcome calls.",
        "kind": "app",
        "nonprofit": false,
        "maker": "Aira",
        "helps": "all"
      },
      {
        "id": "doj-elder-fraud",
        "who": "DOJ National Elder Fraud Hotline",
        "phones": [
          "833-372-8311"
        ],
        "url": "https://ovc.ojp.gov/program/stop-elder-fraud/providing-help-restoring-hope",
        "hours": "Mon–Fri 10 AM–6 PM ET",
        "kind": "government",
        "nonprofit": false,
        "helps": "all",
        "scam": true
      },
      {
        "id": "aarp-fraud-watch",
        "who": "AARP Fraud Watch Helpline",
        "phones": [
          "877-908-3360"
        ],
        "url": "https://www.aarp.org/money/scams-fraud/helpline/",
        "hours": "Mon–Fri 8 AM–8 PM ET",
        "note": "Nonprofit.",
        "kind": "nonprofit",
        "nonprofit": true,
        "helps": "all",
        "scam": true
      }
    ]
  },
  "scamWatch": {
    "catalogDate": "2026-10-10",
    "feeds": [
      {
        "id": "ftc-en",
        "name": "FTC Consumer Alerts",
        "url": "https://consumer.ftc.gov/blog/gd-rss.xml",
        "language": "en",
        "who": "government",
        "filter": "scams-and-fraud",
        "note": "About 2 a week; no categories, so items that are not about scams or fraud are left out."
      },
      {
        "id": "ftc-es",
        "name": "FTC Alertas para consumidores",
        "url": "https://consumidor.ftc.gov/blog/gd-rss.xml",
        "language": "es",
        "who": "government",
        "filter": "scams-and-fraud",
        "note": "The FTC's Spanish feed; same filter as the English one."
      },
      {
        "id": "ic3-psa",
        "name": "FBI IC3 Public Service Announcements",
        "url": "https://www.ic3.gov/PSA/RSS",
        "language": "en",
        "who": "government",
        "filter": "drop-business-only",
        "note": "About 3 a month; some are for businesses only and are left out."
      },
      {
        "id": "google-safety",
        "name": "Google Safety & Security blog",
        "url": "https://blog.google/innovation-and-ai/technology/safety-security/rss/",
        "language": "en",
        "who": "maker",
        "filter": "scams-only",
        "note": "Mostly product news; a scams advisory about twice a year. Scam items only."
      }
    ],
    "noFeed": [
      {
        "who": "Microsoft",
        "note": "No consumer scam feed (about 80% sure); its security blog is for businesses."
      }
    ],
    "spotIt": [
      {
        "id": "ftc-tech-support",
        "title": "FTC: how to spot, avoid and report tech support scams",
        "url": "https://consumer.ftc.gov/articles/how-spot-avoid-and-report-tech-support-scams",
        "who": "government"
      },
      {
        "id": "ftc-government-impersonation",
        "title": "FTC: government impersonation scams",
        "url": "https://consumer.ftc.gov/articles/how-avoid-government-impersonation-scam",
        "who": "government"
      },
      {
        "id": "ftc-phone-scams",
        "title": "FTC: phone scams",
        "url": "https://consumer.ftc.gov/articles/phone-scams",
        "who": "government"
      },
      {
        "id": "ftc-spam-texts",
        "title": "FTC: spam text messages (forward to 7726)",
        "url": "https://consumer.ftc.gov/articles/how-recognize-and-report-spam-text-messages",
        "who": "government"
      },
      {
        "id": "ftc-pass-it-on",
        "title": "FTC: Pass It On (for older adults)",
        "url": "https://consumer.ftc.gov/features/pass-it-on",
        "who": "government"
      },
      {
        "id": "fbi-elder-fraud",
        "title": "FBI: elder fraud",
        "url": "https://www.fbi.gov/how-we-can-help-you/scams-and-safety/common-frauds-and-scams/elder-fraud",
        "who": "government"
      },
      {
        "id": "ic3-elder-fraud",
        "title": "IC3: elder fraud",
        "url": "https://www.ic3.gov/CrimeInfo/ElderFraud",
        "who": "government"
      },
      {
        "id": "cisa-phishing",
        "title": "CISA: recognize and report phishing",
        "url": "https://www.cisa.gov/secure-our-world/recognize-and-report-phishing",
        "who": "government"
      },
      {
        "id": "nyc-dcwp",
        "title": "NYC Department of Consumer and Worker Protection: tips on scams",
        "url": "https://www.nyc.gov/site/dca/consumers/scams.page",
        "who": "government"
      },
      {
        "id": "ny-ag",
        "title": "NY Attorney General press releases (filter “Consumer Alert”)",
        "url": "https://ag.ny.gov/press-releases",
        "who": "government",
        "note": "Not a feed; open it and filter on Consumer Alert."
      },
      {
        "id": "microsoft-tech-support-scams",
        "title": "Microsoft: protect yourself from tech support scams (Microsoft never calls first)",
        "url": "https://support.microsoft.com/office/protect-yourself-from-tech-support-scams",
        "who": "maker"
      },
      {
        "id": "microsoft-phishing",
        "title": "Microsoft: protect yourself from phishing",
        "url": "https://support.microsoft.com/en-us/security/protect-yourself-from-phishing",
        "who": "maker"
      },
      {
        "id": "apple-phishing",
        "title": "Apple: phishing and fake support calls",
        "url": "https://support.apple.com/en-us/102568",
        "who": "maker"
      },
      {
        "id": "google-scams",
        "title": "Google: scams and phishing",
        "url": "https://support.google.com/faqs/answer/2952493",
        "who": "maker"
      },
      {
        "id": "verizon-fraud",
        "title": "Verizon: hacks and fraud",
        "url": "https://www.verizon.com/about/account-security/overview",
        "who": "provider"
      }
    ],
    "callOrReport": [
      {
        "id": "doj-elder-fraud",
        "kind": "call",
        "name": "DOJ National Elder Fraud Hotline",
        "phone": "833-372-8311",
        "hours": "Mon–Fri 10 AM–6 PM ET",
        "how": "Call for help reporting fraud against someone 60 or older.",
        "url": "https://ovc.ojp.gov/program/stop-elder-fraud/providing-help-restoring-hope",
        "nonprofit": false,
        "inCatalog": true
      },
      {
        "id": "aarp-fraud-watch",
        "kind": "call",
        "name": "AARP Fraud Watch Helpline (nonprofit)",
        "phone": "877-908-3360",
        "hours": "Mon–Fri 8 AM–8 PM ET",
        "how": "Call to talk it through with a trained volunteer.",
        "url": "https://www.aarp.org/money/scams-fraud/helpline/",
        "nonprofit": true,
        "inCatalog": true
      },
      {
        "id": "forward-texts-7726",
        "kind": "report",
        "name": "Forward spam texts to 7726 (SPAM)",
        "how": "Forward the text to 7726; the carrier uses it to block the sender.",
        "url": "https://consumer.ftc.gov/articles/how-recognize-and-report-spam-text-messages",
        "nonprofit": false,
        "inCatalog": true
      },
      {
        "id": "ftc-report-tech-support",
        "kind": "report",
        "name": "Report a tech support scam to the FTC",
        "how": "The FTC's tech support scam page says how and where to report it.",
        "url": "https://consumer.ftc.gov/articles/how-spot-avoid-and-report-tech-support-scams",
        "nonprofit": false,
        "inCatalog": true
      },
      {
        "id": "ic3-report",
        "kind": "report",
        "name": "Report elder fraud to the FBI's IC3",
        "how": "IC3's elder fraud page explains how to file a report.",
        "url": "https://www.ic3.gov/CrimeInfo/ElderFraud",
        "nonprofit": false,
        "inCatalog": true
      },
      {
        "id": "microsoft-reportascam",
        "kind": "report",
        "name": "Report a Microsoft tech support scam",
        "how": "Report it at microsoft.com/reportascam.",
        "url": "https://support.microsoft.com/office/protect-yourself-from-tech-support-scams",
        "nonprofit": false,
        "inCatalog": true
      },
      {
        "id": "apple-reportphishing",
        "kind": "report",
        "name": "Forward phishing email that pretends to be Apple",
        "email": "reportphishing@apple.com",
        "how": "Forward the suspicious email to reportphishing@apple.com.",
        "url": "https://support.apple.com/en-us/102568",
        "nonprofit": false,
        "inCatalog": false,
        "confirm": "The address is named in the 1.8.5 prompt; the catalog lists Apple's page (102568) but not the address. A person confirms it on that page and marks it checked."
      },
      {
        "id": "verizon-phishing",
        "kind": "report",
        "name": "Forward phishing that pretends to be Verizon",
        "email": "phishing@verizon.com",
        "how": "Forward phishing email to phishing@verizon.com; forward texts to 7726.",
        "url": "https://www.verizon.com/about/account-security/overview",
        "nonprofit": false,
        "inCatalog": true
      }
    ]
  },
  "whatsNew": {
    "catalogDate": "2026-10-10",
    "pages": [
      {
        "id": "jaws",
        "product": "JAWS",
        "maker": "Vispero",
        "current": "JAWS 2026 (Sep 2026 build); 2027 announced for a webinar on 12 Nov 2026",
        "url": "https://support.freedomscientific.com/Downloads/JAWS/JAWSWhatsNew",
        "loadsByScript": true,
        "note": "The page's text loads by script: open it in a browser."
      },
      {
        "id": "zoomtext",
        "product": "ZoomText",
        "maker": "Vispero",
        "current": "ZoomText 2026 (Sep 2026 build)",
        "url": "https://support.freedomscientific.com/Downloads/ZoomText/ZoomTextWhatsNew",
        "loadsByScript": true,
        "note": "The page's text loads by script: open it in a browser."
      },
      {
        "id": "fusion",
        "product": "Fusion",
        "maker": "Vispero",
        "current": "Fusion 2026 (Sep 2026 build)",
        "url": "https://support.freedomscientific.com/Downloads/Fusion",
        "loadsByScript": true,
        "note": "The catalog has no separate Fusion What's New page; the downloads page lists the builds. Fusion is JAWS and ZoomText together, so their What's New pages apply."
      },
      {
        "id": "nvda",
        "product": "NVDA",
        "maker": "NV Access",
        "current": "NVDA 2026.2 (31 Aug 2026)",
        "url": "https://download.nvaccess.org/documentation/changes.html",
        "loadsByScript": false
      },
      {
        "id": "talkback",
        "product": "TalkBack",
        "maker": "Google",
        "current": "TalkBack 17.0 (Android 16–17)",
        "url": "https://support.google.com/accessibility/android/answer/17069786?hl=en",
        "loadsByScript": false
      },
      {
        "id": "narrator",
        "product": "Narrator",
        "maker": "Microsoft",
        "current": "Windows 11 24H2/25H2 (Narrator guide Aug 2026)",
        "url": "https://support.microsoft.com/en-us/accessibility/windows/narrator/complete-guide-to-narrator",
        "loadsByScript": false,
        "note": "The catalog has no Narrator What's New page; the complete guide is updated with Windows."
      }
    ],
    "gaps": [
      {
        "id": "amazon-help-pages",
        "what": "Amazon's customer help pages: the VoiceView guide, Screen Magnifier, accessibility support, and the Echo Wi-Fi pages; Amazon's accessibility phone number",
        "why": "They block automated reading; only Amazon's developer pages could be checked.",
        "who": "A person collects them and checks the Fire tablet entry."
      },
      {
        "id": "spectrum-support-site",
        "what": "Spectrum's support site (spectrum.net)",
        "why": "It blocks automated reading; spectrum.com and Charter pages were used instead.",
        "who": "A person collects the pages the tech needs."
      },
      {
        "id": "vispero-whats-new-script",
        "what": "The JAWS, ZoomText and Fusion What's New pages",
        "why": "Their text loads by script, so it can't be read automatically.",
        "who": "A person opens them in a browser to re-check."
      },
      {
        "id": "samsung-pdfs",
        "what": "Samsung's per-model user guide PDFs",
        "why": "They could not be opened automatically.",
        "who": "A person downloads the guide for a tenant's model when needed."
      }
    ]
  }
};
